import React from 'react'

import { withRouter } from 'react-router-dom'

import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable' 
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { FaCopy } from "react-icons/fa";
import { Editor } from "primereact/editor";
import { Steps } from 'primereact/steps';
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import '../../styles/publicacaoModal.css';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber'
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea'
import { Calendar } from 'primereact/calendar'
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { RadioButton } from 'primereact/radiobutton'
import { Checkbox } from 'primereact/checkbox'
import { ProgressSpinner } from 'primereact/progressspinner';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';
import { uniqueId } from "lodash"
import filesize from 'filesize'

import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'
import ProgressoFile from '../../componentes/ProfressoFile'
import PartesAlterar from '../../componentes/PartesAlterar'
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList/index'
import RodizioAtividadeComponent from '../atividades/RodizioAtividadeComponent'

import ProcessoService from '../../app/service/ProcessoService'
import LocalStorageService from '../../app/service/localStorageService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import TipoAcaoService from '../../app/service/TipoAcaoService'
import StatusProcessualService from '../../app/service/StatusProcessualService'
import TipoDecisaoService from '../../app/service/TipoDecisao'
import ObjetoScaoService from '../../app/service/ObjetoAcaoService'
import PessoaService from '../../app/service/PessoaService'
import AreaAtuacaoService from '../../app/service/AreaAtuacaoService'
import ObjetoAcaoProcessoService from '../../app/service/ObjetoAcaoProcessoService'
import PagamentoProcessoService from '../../app/service/PagamentoProcessoService'
import TipoPagamentoService from '../../app/service/TipoPagamentoService'
import CustasProcessoService from '../../app/service/CustasProcessoService'
import TipoCustaService from '../../app/service/TiposCustasService'
import TipoGarantiaService from '../../app/service/TipoGarantiaService'
import GarantiaProcessoService from '../../app/service/GarantiaProcessoService'
import HistoricoProcessoService from '../../app/service/HistoricoProcessoService'
import UploadService from '../../app/service/UploadService'
import ArquivoProcessoServiice from '../../app/service/ArquivoProcessoService'
import ProcessoImportanciaService from '../../app/service/ProcessoImportanciaService'
import AtivividadeService from '../../app/service/AtividadeService'
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import ArquivoAtividadeService from '../../app/service/ArquivoAtividadeService'
import ArquivoPessoaService from '../../app/service/ArquivoPessoaService'
import FinanceiroService from '../../app/service/FinanceiroService'
import EstadoService from '../../app/service/EstadoService'
import CidadeService from '../../app/service/CidadeService'
import StatusAtividadeService from '../../app/service/StatusAtividadeService'
import PedidoService from '../../app/service/PedidoService'
import PedidoProcessoService from '../../app/service/PedidoProcessoService'
import TipoAndamentoProcessualService from '../../app/service/TipoAndamentoProcessualService'
import MotivoResultadoService from '../../app/service/MotivoResultadoService'
import AgravoApensoService from '../../app/service/AgravoApensoService'
import RitoService from '../../app/service/RitoService'
import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import TituloAtividadeFaseService from '../../app/service/TituloAtividadeFaseService'
import UsuarioService from '../../app/service/UsuarioService'
import ExecucaoCheckListService from '../../app/service/ExecucaoCheckListService'
import PublicacoesService from '../../app/service/PublicacoesService';

import { AuthContext } from '../../main/ProvedorAutenticacao'

import AtividadeComponent from '../atividades/AtividadeComponent'
import AtividadeComponentInclusao from '../atividades/AtividadeComponentInclusao'

import './processo.css'
import './calendario.css'
import './upload.css'
import '../home/painel.css'

class FichaProcesso extends React.Component {

  constructor(props) {
    super(props);

    this.processoService = new ProcessoService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.tipoAcaoService = new TipoAcaoService();
    this.statusProcessualService = new StatusProcessualService();
    this.tipoDecisaoService = new TipoDecisaoService();
    this.objetoAcaoService = new ObjetoScaoService();
    this.pessoaService = new PessoaService();
    this.areaAtuacaoService = new AreaAtuacaoService();
    this.objetoAcaoProcessoService = new ObjetoAcaoProcessoService();
    this.pagamentoProcessoService = new PagamentoProcessoService();
    this.tipoPagamentoService = new TipoPagamentoService();
    this.custasProcessoService = new CustasProcessoService();
    this.tipoCustaService = new TipoCustaService();
    this.tipoGarantiaService = new TipoGarantiaService();
    this.garantiaProcessoService = new GarantiaProcessoService();
    this.historicoProcessoService = new HistoricoProcessoService();
    this.uploadService = new UploadService();
    this.arquivoProcessoService = new ArquivoProcessoServiice();
    this.processoImportanciaService = new ProcessoImportanciaService();
    this.atividadeService = new AtivividadeService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.financeiroService = new FinanceiroService();
    this.estadoService = new EstadoService();
    this.cidadeService = new CidadeService();
    this.statusAtividadeService = new StatusAtividadeService();
    this.pedidoService = new PedidoService();
    this.pedidoProcessoService = new PedidoProcessoService();
    this.tipoAndamentoProcessualService = new TipoAndamentoProcessualService();
    this.motivoResultadoService = new MotivoResultadoService();
    this.agravoApensoService = new AgravoApensoService();
    this.ritoService = new RitoService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.tituloAtividadeFaseService = new TituloAtividadeFaseService();
    this.usuarioService = new UsuarioService();
    this.execucaoCheckListService = new ExecucaoCheckListService();
		this.publicacoesService = new PublicacoesService();

    this.consultarPessoa = this.consultarPessoa.bind(this);
    this.acoesObjetosAcao = this.acoesObjetosAcao.bind(this);
    this.onTipoDecisaoChange = this.onTipoDecisaoChange.bind(this);
    this.vlPagamento = this.vlPagamento.bind(this);
    this.acoesPagamentosProcesso = this.acoesPagamentosProcesso.bind(this);
    this.acoesCustasProcesso = this.acoesCustasProcesso.bind(this);
    this.onChangeTipoPagamento = this.onChangeTipoPagamento.bind(this);
    this.onChangeStatusProcessual = this.onChangeStatusProcessual.bind(this);
    this.onChangeGrupoTrabalho = this.onChangeGrupoTrabalho.bind(this);
    this.onChangeTipoAcao = this.onChangeTipoAcao.bind(this);
    this.onChangeAreaAtuacao = this.onChangeAreaAtuacao.bind(this);
    this.renderFooterCadastroPagamentos = this.renderFooterCadastroPagamentos.bind(this);
    this.confirmaExclusaoPagamento = this.confirmaExclusaoPagamento.bind(this);
    this.confirmaExclusaoCusta = this.confirmaExclusaoCusta.bind(this);
    this.acceptExcluirPagamento = this.acceptExcluirPagamento.bind(this);
    this.acceptExcluirCustas = this.acceptExcluirCustas.bind(this);
    this.vlCustas = this.vlCustas.bind(this);
    this.onChangeTipoCustas = this.onChangeTipoCustas.bind(this);
    this.renderFooterCadastroCustas = this.renderFooterCadastroCustas.bind(this);
    this.acoesGarantiasProcesso = this.acoesGarantiasProcesso.bind(this);
    this.acceptExcluirGarantias = this.acceptExcluirGarantias.bind(this);
    this.confirmaExclusaoGarantia = this.confirmaExclusaoGarantia.bind(this);
    this.vlPenhora = this.vlPenhora.bind(this);
    this.headerResumoPagamentos = this.headerResumoPagamentos.bind(this);
    this.headerResumoCustas = this.headerResumoCustas.bind(this);
    this.onChangeTipoGarantia = this.onChangeTipoGarantia.bind(this);
    this.headerTotalPenhora = this.headerTotalPenhora.bind(this);
    this.aceptExcluirObjetoAcao = this.aceptExcluirObjetoAcao.bind(this);
    this.onCityChange = this.onCityChange.bind(this);
    this.acoesHistoricoProcesso = this.acoesHistoricoProcesso.bind(this);
		this.historicoProcesso = this.historicoProcesso.bind(this);
    this.acceptExcluirHistoricoAtividade = this.acceptExcluirHistoricoAtividade.bind(this);
    this.usuarioHistorico = this.usuarioHistorico.bind(this);
    //Upload
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    //Atividades
    this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
    this.acoesHistoricoUsuario = this.acoesHistoricoUsuario.bind(this);
    this.acoesHistoricoAtividade = this.acoesHistoricoAtividade.bind(this);
    this.acoesAtividade = this.acoesAtividade.bind(this);
    this.onChangeStatusAtividade = this.onChangeStatusAtividade.bind(this);
    this.onSubGrupoChange = this.onSubGrupoChange.bind(this);
    this.acoesArquivosAtividade = this.acoesArquivosAtividade.bind(this);
    this.renderFooterDescricaoArquivoAtividade = this.renderFooterDescricaoArquivoAtividade.bind(this);
    this.novaAtividadeHeader = this.novaAtividadeHeader.bind(this);
    this.acceptExcluirArquivoNovaAtividade = this.acceptExcluirArquivoNovaAtividade.bind(this);
    this.acoesArquivosNovaAtividade = this.acoesArquivosNovaAtividade.bind(this);
    this.renderFooterAtividadeNovaAtividade = this.renderFooterAtividadeNovaAtividade.bind(this);
    this.renderFooterDescricaoArquivoNovaAtividade = this.renderFooterDescricaoArquivoNovaAtividade.bind(this);
    this.onChangeEstado = this.onChangeEstado.bind(this);
    this.onChangeCidade = this.onChangeCidade.bind(this);
    this.onChangeTipoPessoa = this.onChangeTipoPessoa.bind(this);
    this.acceptExcluirArquivoAtividade = this.acceptExcluirArquivoAtividade.bind(this);
    this.acoesPedidos = this.acoesPedidos.bind(this);
    this.acceptExcluirPedido = this.acceptExcluirPedido.bind(this);
    this.templateHistoricoAtividade = this.templateHistoricoAtividade.bind(this);
    //Lançamentos Financeiros
    this.acoesFinanceiro = this.acoesFinanceiro.bind(this);
    this.onChangeObjetos = this.onChangeObjetos.bind(this);
    //Agravo Apenso
    this.renderFooterCadastroAgravoApenso = this.renderFooterCadastroAgravoApenso.bind(this);
    this.acoesPartesAgravoApenso = this.acoesPartesAgravoApenso.bind(this);
    this.renderFooterAgravoApensoExistente = this.renderFooterAgravoApensoExistente.bind(this);
    this.acoesProcessoAgravosApensos = this.acoesProcessoAgravosApensos.bind(this);
    this.acceptExcluirAgravoApenso = this.acceptExcluirAgravoApenso.bind(this);
    this.onMudancaData = this.onMudancaData.bind(this);
    this.acoesPartes = this.acoesPartes.bind(this);
    this.incluirParte = this.incluirParte.bind(this);
    this.acceptExcluirParte = this.acceptExcluirParte.bind(this);
    this.onChangeFasesPorTitulo = this.onChangeFasesPorTitulo.bind(this);
    this.onChangeTitulosPorFase = this.onChangeTitulosPorFase.bind(this);
    this.onGrauChange = this.onGrauChange.bind(this);
    this.grauTemplate = this.grauTemplate.bind(this);
    this.situacaoFinanceiro = this.situacaoFinanceiro.bind(this);
    this.tipoCategoriaFinanceiro = this.tipoCategoriaFinanceiro.bind(this);
    this.exibirPublicacao = this.exibirPublicacao.bind(this);

    this.state = {
      processo: {},
      codigo: '',
      gruposTrabalho: [],
      grupoTrabalho: null,
      pasta: '',
      nrProcesso: '',
      nrCnj: '',
      instancia: null,
      dsComarca: '',
      tiposAcao: [],
      tipoAcao: null,
      statusProcessuais: [],
      statusProcessual: null,
      areasAtuacao: [],
      areaAtuacao: null,
      tiposDecisao: [],
      tipoDecisao: null,
      dataDistribuicao: '',
      dataUltimaMovimentacao: '',
      dataCadastro: '',
      dataSentenca: '',
      dataUltimaDecisao: '',
      vlProvavel: '',
      vlPossivel: '',
      vlRemoto: '',
			pessoaProcesso: null,
      vlCausa: '',
      objetosAcao: [],
      subObjetosAcao: [],
      selectSubObjetos: null,
      modalObjetos: false,
      uf: null,
      objetoAcao: null,
      dsPedidos: '',
      observacao: '',
      responsavel: null,
      responsavelProcesso: null,
      pagamentos: [],
      push: [],
      modalLoad: '',
      pedidosProcesso: [],
      contingenciaContabil: null,
      orgaoColegiado: '',
      relatorProcesso: '',
      //Partes
      partesProcesso: [],
      filterPessoas: null,
      pessoas: [],
      linkFichaPessoa: '',
      exibirNovaParte: 'none',
      iconeExibirNovaParte: '+',
      codigoParte: '',
      selectParte: null,
      codigoObjeto: '',
      visibleObjeto: false,
      pedidos: [],
      pedido: null,
      pedidosProcesso: [],
      pedidoProcesso: null,
      modalPedidos: false,
      modalAlterarPedidos: false,
      //Pagamentos de Processo
      codigoPagamento: '',
      modalPagamentos: false,
      tipo: null,
      pagamento: null,
      tiposPagamentos: [],
      tipoPagamento: null,
      vlPagamento: '',
      dtPagamento: '',
      visiblePagamento: false,
      vlCredito: 0,
      vlDebito: 0,
      saldo: 0,
      corSaldo: '',
      //Custas do Processo
      codigoCustas: '',
      modalCustas: false,
      custasProcessos: [],
      custas: null,
      vlCustas: '',
      visibleCusas: false,
      vlCreditoCustas: 0,
      vlDebitoCustas: 0,
      saldoCustas: 0,
      corSaldoCustas: '',
      tiposCustas: [],
      tipoCusta: null,
      //Garantias de Processo
      codigoGarantia: '',
      garantiasProcesso: [],
      tipoGarantia: null,
      tiposGarantias: [],
      vlPenhora: '',
      visibleGarantias: false,
      modalGarantias: false,
      totalPenhora: 0,
      //historico do Processo
      codigoHistorico: '',
      descAndamento: '',
      dataHistorico: '',
      dataOcorrencia: '',
      listaHistorico: [],
      modalHistorico: false,
      visibleHistorico: false,
      modalVisualizeHistorico: false,
      visibleVisualiseHistorico: false,
      //Tipos de Andamento Processual
      tiposAndamento: [],
      tipoAndamento: null,
      //Arquivos
      fileData: null,
      fileName: '',
      modalExibirArquivo: false,
      modalExibirArquivoProcesso: false,
      upLoadFiles: [],
      nome: '',
      dsArquivo: '',
      arquivosAtividades: [],
      modalDescricaoArquivo: false,
      modalDescricaoArquivoNovaAtividade: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      //processo Importancia
      iconeImportanteParaMim: 'p-button-rounded p-button-secondary',
      iconeImportanteParaMimTitle: 'Clique para favoritar o proceso',
      iconeImportanteParaEmpresa: '',
      iconeImportanteParaEmpresaTitle: '',
      iconeEstrategico: '',
      iconeEstrátegicoTitle: '',
      processoImportancia: null,
      //Atividades
      atividades: [],
      //Alterar Atividade
      atividade: null,
      codigoAtividade: '',
      titulo: '',
      pontuacao: '',
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      tipo: '',
      status: '',
      hora: '',
      displayAtividade: false,
      displayProcesso: false,
      displayAtividadeAlterar: false,
      modalAtividadeComponente: false,
      modalInclusaoComponente: false,
      processoParaInclusao: null,
      displayRodizioAtividade: false,
      displayProcesso: false,
      displayDescricao: false,
      tipoAtividade: null,
      grupos: [],
      usuarios: [],
      selectGrupo: null,
      subGrupos: [],
      selectSubGrupo: null,
      modalTrocaGrupoVisible: false,
      subGruposTrocaGrupo: [],
      subGrupoParaTrocaGrupo: null,
      atividadesParaTrocaGrupo: [],
      responsaveis: [],
      interessados: [],
      interessado: null,
      pesquisaProcesso: '',
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      bloqueiaGrupo: false,
      optionStatus: null,
      responsaveisLista: [],
      quantidadeResponsaveis: '',
      interessadosLista: [],
      quantidadeInteressados: '',
      nomeGrupoTrabalho: '',
      detail: '',
      usuarioCriouAtividade: '',
      dataRegistroAtividade: '',
      //Atividade Customizada
      grupoTrabalhoDescricao: '',
      subGrupoTrabalhoDescricao: '',
      codigoProcesso: '',
      codigoSubGrupo: '',
      codigoGrupo: '',
      statusCodigo: '',
      dataLimiteAntiga: '',
      horaAntiga: '',
      codigoAtividade: '',
      //Histórico da Atividade
      historico: [],
      registroHistorico: null,
      displayHistorico: null,
      dsHistorico: '',
      displayHistoricoIncluir: false,
      visibleHistorico: false,
      //Alterar Histórico
      modalAlterarHistorico: false,
      historicoAtividade: null,
      //Arquivos Anexados da atividade
      exibirLinkAnexo: 'none',
      displayArquivosAnexadosAtividade: false,
      upLoadFiles: [],
      nome: '',
      dsArquivo: '',
      modalDescricaoArquivoAtividade: false,
      arquivo: null,
      fileName: '',
      fileData: null,
      modalExibirArquivo: false,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      arquivosNovaAtividade: [],
      displayAnexoNovaAtividade: false,
      //Lançamentos Financeiros
      lancamentosFinanceiros: [],
      lancamento: null,
      displayConsultaLancamento: false,
      displayPagarLancamento: false,
      tipo: '',
      categoriaNome: '',
      tipoNome: '',
      vlLancamento: '',
      vlLancamentoMascara: '',
      vlPagoMascara: '',
      dtVencimento: '',
      vlPago: '',
      dtPago: '',
      dsLancamento: '',
      observacao: '',
      situacao: '',
      vlLancamentoNovo: '',
      dtVencimentoNovo: '',
      modalDespesaPagamento: false,
      modalReceitaPagamento: false,
      //Cadastro de nova Pessoa
      modalNovoCliente: null,
      nome: '',
      selectTipo: null,
      perfil: null,
      perfis: [],
      selectCidade: null,
      selectEstado: null,
      estados: [],
      cidades: [],
      openSpinner: false,
      //Motivo Resultado
      motivos: [],
      motivo: null,
      //Agravo e Apenso
      agravosApensos: [],
      agravoApenso: null,
      tipoProcessoAgravoApenso: null,
      numeroAgravoApenso: '',
      parteAgravoApenso: null,
      nomeParteAgravoApenso: '',
      tipoParteAgravoApenso: null,
      camara: '',
      relator: '',
      agravoApensoConsulta: null,
      camaraConsulta: '',
      relatorConsulta: '',
      exibirAgravoApenso: 'none',
      exibirAgravoApensoNegacao: 'block',
      modalAgravoApenso: false,
      agravoApensoExistente: null,
      modalAgravoApensoExistente: false,
      codigoProcessoExistente: '',
      codigoAgravoApenso: '',
      linkProcessoPrincipal: '',
      exibeLInkProcessoPrincipal: 'none',
      paramProcessoPrincipal: '',
      mudancaDataAtividade: false,
      isFinancero: false,
      //Ritos de Processo
      ritos: [],
      rito: null,
      //Informações do processo na tela de edição de atividade
      partes: '',
      favorito: '',
      titleFavorito: '',
      exibirFavorito: '',
      importante: '',
      titleImportante: '',
      exibirImportanteEmpresa: '',
      mudancaDataHistorico: [],
      //Títulos de Atividades
      titulos: [],
      tituloAtividade: null,
      //Tarefas Agrupadas
      modalTarefaAgrupada: false,
      grupoTarefa: null,
      tarefas: [],
      gruposTarefas: [],
      exibirComponentes: 'none',
      exibirComponentesGrupos: 'none',
      usuariosTarefas: [],
      //Recorrência
      recorrencia: null,
      repeticao: null,
      classeDiv: 'hide',
      desabilitaBotao: false,
      separador: 'none',
      //Informações de Usuários da Tarefa
      modalInformacaoUsuario: false,
      //Partes
      montaPartes: '',
      //Bancada
      bancadas: [],
      bancada: null,
      //Grau de urgencia
      grau: [],
      //Check List
      activeIndex: '',
      checkList: [],
      execucaoCheckList: null,
      modalCheckList: false,
      usuarioCheckList: '',
      dataExecucaoCheckList: '',
      statusExecucao: '',
      expandedRows: [],
      //Atividades do processo
      atividadesFiltroStatus: null,
      atividadesFiltroImportante: null,
      atividadesFiltroUrgente: null,
      atividadesFiltroDataLimiteInicial: null,
      atividadesFiltroDataLimiteFinal: null,
      atividadesFiltroPrazoFatalInicial: null,
      atividadesFiltroPrazoFatalFinal: null,
      atividadesFiltroDataConclusaoInicial: null,
      atividadesFiltroDataConclusaoFinal: null,
      atividadesFiltroClassificacao: null,
      atividadesFiltroOrdenacao: null,
      modalFiltroFaseAtividade: false,
      //Processo está excluído
      exibirProcessoExcluido: 'none',
      //Novo título de atividade
      novoTitulo: '',
      pontuacao: '',
      modalNovoTitulo: false,
      //Ordenação de Andamento Processual
      classificacaoAndamento: null,
      ordenacaoAndamento: null,
      //Ordenação de Documentos
      classificacaoDocumentos: null,
      ordenacaoDocumentos: null,
      //Copia e Cola
      copiadoCnj: false,
      copiadoProcesso: false,
      copiadoPasta: false,
			//Publicações
			publicacao: null,
			isPublicacao: false,
    }

    this.options = this.getLightTheme();

    this.classificacaoAndamentoOpcoes = [
      {codigo: 1, nome: 'Data do Ocorrência'},
      {codigo: 2, nome: 'Data do Histórico'},
      {codigo: 3, nome: 'Descrição'},
      {codigo: 4, nome: 'Tipo de Andamento'}
    ];

    this.ordenacaoAndamentoOpcoes = [
      {codigo: 1, nome: 'Ascendente'},
      {codigo: 2, nome: 'Descendente'},
    ];

    this.classificacaoDocumentosOpcoes = [
      {codigo: 1, nome: 'Arquivo'},
      {codigo: 2, nome: 'Data de Inclusao'}
    ];

    this.ordenacaoDocumentosOpcoes = [
      {codigo: 1, nome: 'Ascendente'},
      {codigo: 2, nome: 'Descendente'},
    ];

    this.atividadesImportante = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ];

    this.atividadesUrgente = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ]

    this.classificacaoAtividadesOpcoes = [
      {codigo: 1, nome: 'Data Limite'},
      {codigo: 2, nome: 'Prazo Fatal'},
      {codigo: 3, nome: 'Código'}
    ];

    this.ordenacaoAtividadesOpcoes = [
      {codigo: 'ASC', nome: 'Ascendente'},
      {codigo: 'DESC', nome: 'Descendente'}
    ];

    this.recorrencia = [
      {codigo: '2', nome: '2'},
      {codigo: '3', nome: '3'},
      {codigo: '4', nome: '4'},
      {codigo: '5', nome: '5'},
      {codigo: '6', nome: '6'},
      {codigo: '7', nome: '7'},
      {codigo: '8', nome: '8'},
      {codigo: '9', nome: '9'},
      {codigo: '10', nome: '10'},
      {codigo: '11', nome: '11'},
      {codigo: '12', nome: '12'},
      {codigo: '13', nome: '13'},
      {codigo: '14', nome: '14'},
      {codigo: '15', nome: '15'},
      {codigo: '16', nome: '16'},
      {codigo: '17', nome: '17'},
      {codigo: '18', nome: '18'},
      {codigo: '19', nome: '19'},
      {codigo: '20', nome: '20'},
      {codigo: '21', nome: '21'},
      {codigo: '22', nome: '22'},
      {codigo: '23', nome: '23'},
      {codigo: '24', nome: '24'}
    ];

    this.autoresAgravoApenso = [];
    this.reusAgravoApenso = [];
    this.partesAgravoApenso = [];

    this.tipoParte = [
      {codigo: 'A', nome: 'Autor'},
      {codigo: 'R', nome: 'Réu'},
      {codigo: 'A', nome: 'Agravado'},
      {codigo: 'R', nome: 'Agravante'}
    ]

    this.tiposProcessoAgravoApenso = [
      {codigo: 'AG', nome: 'Agravo'},
      {codigo: 'AP', nome: 'Apenso'}
    ]

    this.tiposPessoa = [
      {codigo: 'F', nome: 'Física'},
      {codigo: 'J', nome: 'Jurídica'}
    ]

    this.contingenciaContabil = [
      {codigo: 'PO', nome: 'Possível'},
      {codigo: 'PR', nome: 'Provável'},
      {codigo: 'RE', nome: 'Remoto'}
    ];

    this.tiposPagamentosCustas =[
      {codigo: 'C', nome: 'Crédito'},
      {codigo: 'D', nome: 'Débito'}
    ]

    this.estados = [
      {codigo: 'AC', nome: 'Acre'},
      {codigo: 'AL', nome: 'Alagoas'},
      {codigo: 'AM', nome: 'Amazonas'},
      {codigo: 'AP', nome: 'Amapá'},
      {codigo: 'BA', nome: 'Bahia'},
      {codigo: 'CE', nome: 'Ceará'},
      {codigo: 'DF', nome: 'Distrito Federal'},
      {codigo: 'ES', nome: 'Espírito Santo'},
      {codigo: 'GO', nome: 'Goiás'},
      {codigo: 'MA', nome: 'Maranhão'},
      {codigo: 'MG', nome: 'Minas Gerais'},
      {codigo: 'MS', nome: 'Mato Grosso do Sul'},
      {codigo: 'MT', nome: 'Mato Grosso'},
      {codigo: 'PA', nome: 'Pará'},
      {codigo: 'PB', nome: 'Paraíba'},
      {codigo: 'PE', nome: 'Pernambuco'},
      {codigo: 'PI', nome: 'Piauí'},
      {codigo: 'PR', nome: 'Paraná'},
      {codigo: 'RJ', nome: 'Rio de janeiro'},
      {codigo: 'RN', nome: 'Rio Grande do Norte'},
      {codigo: 'RO', nome: 'Rondônia'},
      {codigo: 'RR', nome: 'Roraima'},
      {codigo: 'RS', nome: 'Rio Grande do Sul'},
      {codigo: 'SC', nome: 'Santa Catarina'},
      {codigo: 'SE', nome: 'Sergipe'},
      {codigo: 'SP', nome: 'São Paulo'},
      {codigo: 'TO', nome: 'Tocantins'}
    ];

    this.tipoPartes = [
      {codigo: 'A', nome: 'Autor'},
      {codigo: 'R', nome: 'Réu'},
      {codigo: 'AD', nome: 'Advogado'},
      {codigo: 'EM', nome: 'Embargante'},
      {codigo: 'RE', nome: 'Reclamado'},
      {codigo: 'TE', nome: 'Testemunha'},
      {codigo: 'EN', nome: 'Envolvido'},
      {codigo: 'IN', nome: 'Inventariante'},
      {codigo: 'RC', nome: 'Reclamante'},
      {codigo: 'NO', nome: 'Notificado'},
      {codigo: 'NC', nome: 'Notificante'}
    ];

    this.objetosProcesso = [];

    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Stembro', 'Outubro', 'Novembro', 'Dezemro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoy',
      clear: 'Claro'
    });
  }

  novoFiltroAtividades = async () => {
    this.setState({atividadesFiltroStatus: null});
    this.setState({atividadesFiltroImportante: null});
    this.setState({atividadesFiltroUrgente: null});
    this.setState({atividadesFiltroDataLimiteInicial: null});
    this.setState({atividadesFiltroDataLimiteFinal: null});
    this.setState({atividadesFiltroPrazoFatalInicial: null});
    this.setState({atividadesFiltroPrazoFatalFinal: null});
    this.setState({atividadesFiltroDataConclusaoInicial: null});
    this.setState({atividadesFiltroDataConclusaoFinal: null});
    this.setState({atividadesFiltroClassificacao: null});
    this.setState({atividadesFiltroOrdenacao: null});
    this.setState({openSpinner: true});
    await this.listarStatusAtividade();
    this.setState({openSpinner: false});
    this.abrirModal('modalFiltroFaseAtividade');
  }

  formatarDataFiltro = (data) => {
    if(data == null) {
      return '0';
    }
    const month = this.pad2(data.getMonth() + 1);
    const day = this.pad2(data.getDate());
    return `${data.getFullYear()}-${month}-${day}`;
  }

  consultarAtividadesFiltro = async () => {
    const filtro = {
      processo: this.state.processo.codigo,
      status: this.state.atividadesFiltroStatus != null ? this.state.atividadesFiltroStatus.codigo : '0',
      importante: this.state.atividadesFiltroImportante != null ? this.state.atividadesFiltroImportante.codigo : 'T',
      urgente: this.state.atividadesFiltroUrgente != null ? this.state.atividadesFiltroUrgente.codigo : 'T',
      dataLimiteInicial: this.formatarDataFiltro(this.state.atividadesFiltroDataLimiteInicial),
      dataLimiteFinal: this.formatarDataFiltro(this.state.atividadesFiltroDataLimiteFinal),
      prazoFatalInicial: this.formatarDataFiltro(this.state.atividadesFiltroPrazoFatalInicial),
      prazoFatalFinal: this.formatarDataFiltro(this.state.atividadesFiltroPrazoFatalFinal),
      dataConclusaoInicial: this.formatarDataFiltro(this.state.atividadesFiltroDataConclusaoInicial),
      dataConclusaoFinal: this.formatarDataFiltro(this.state.atividadesFiltroDataConclusaoFinal),
      classificacao: this.state.atividadesFiltroClassificacao != null ? this.state.atividadesFiltroClassificacao.codigo : 1,
      ordenacao: this.state.atividadesFiltroOrdenacao != null ? this.state.atividadesFiltroOrdenacao.codigo : 'DESC',
    };

    this.setState({openSpinner: true});
    await this.atividadeService.consultarAtividadesPorProcessoFiltro(filtro)
      .then(response => {
        this.setState({atividades: response.data});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
  }

  listarUsuarios = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuarios: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao listar usuários', life: 4000});
      })
  }

  //Tarefas Agrupdas
  renderFooterAtividadeAgrupada(name) {
    return (
        <div className="left">
            <Button label="Cadastrar"
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrartividadeAgrupada}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  onMudancaData(e) {
    let selectedCities = [...this.state.mudancaDataHistorico];

    if (e.checked)
        selectedCities.push(e.value);
    else
        selectedCities.splice(selectedCities.indexOf(e.value), 1);

    this.setState({ mudancaDataHistorico: selectedCities });
  }

  listarTitulosAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
      })
  }


  listarRitosProcessuais = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.ritoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({ritos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Ritos Processuais', detail:'Erro ao carregar ritos processuais', life: 4000});
      })
  }

  consultarAgravoApensoExistente = async () => {
    if(this.state.numeroAgravoApenso != '' && this.state.numeroAgravoApenso != null) {
      const usuarioLogado = this.context.usuarioAutenticado;
      this.setState({openSpinner: true});
      await this.agravoApensoService.consultarPorNumero(this.state.numeroAgravoApenso,usuarioLogado.empresa.codigo)
        .then(response => {
          console.log('Calma', response.data);
          if(response.data.codigo != null) {
            this.setState({agravoApensoExistente: response.data});
            this.setState({codigoProcessoExistente: response.data.codigo});
            this.abrirModalAgravoApensoProcessoExistente('modalAgravoApensoExistente')
          }
        }).catch(error => {
          console.log('Processo não encontrado')
        });
        this.setState({openSpinner: false});
      }
  }

  carregaProcessoExistenteAgravoApenso = async () => {
    this.setState({openSpinner: true});
    await this.agravoApensoService.consultarProcessoExistente(this.state.codigoProcessoExistente)
      .then(response => {
        this.setState({agravoApensoExistente: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Erro ao buscar processo já existente', life: 4000});
        return;
      });
      let partes = null;
      for(let i = 0; i < this.state.agravoApensoExistente.autores.length; i++) {
        partes = {
          nome: this.state.agravoApensoExistente.autores[i].nome,
          tipo: {
            codigo: 1,
            nome: 'Autor'
          }
        };
        this.partesAgravoApenso.push(partes);
      }

      for(let i = 0; i < this.state.agravoApensoExistente.reus.length; i++) {
        partes = {
          nome: this.state.agravoApensoExistente.reus[i].nome,
          tipo: {
            codigo: 2,
            nome: 'Reu'
          }
        };
        this.partesAgravoApenso.push(partes);
      }

      this.fecharModal('modalAgravoApensoExistente');
      this.setState({openSpinner: false});
  }

  renderFooterCadastroAgravoApenso(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.cadastrarAgravoApenso}/>
          &nbsp;
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text" 
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  cadastrarAgravoApenso = async () => {
    if(this.state.numeroAgravoApenso == '') {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Informe o número do processo', life: 4000});
      return;
    }

    if(this.state.tipoProcessoAgravoApenso == null) {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Informe o tipo de processo', life: 4000});
      return;
    }

    if(this.partesAgravoApenso.length === 0) {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Nenhuma parte informada', life: 4000});
      return;
    }

    var parteAutor = false;
    var parteReu = true;
    for(let i = 0; i < this.partesAgravoApenso.length; i++) {
      if(this.partesAgravoApenso[i].tipo.codigo == 1) {
        parteAutor = true;
      }

      if(this.partesAgravoApenso[i].tipo.codigo == 2) {
        parteReu = true;
      }
    }

    if(!parteAutor && !parteReu) {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Uma das partes está faltando no processo', life: 4000});
      return;
    }

    var partes = [];
    
    for(let i = 0; i < this.partesAgravoApenso.length; i++) {
      partes.push({
        pessoa: {
          nome: this.partesAgravoApenso[i].nome
          },
        tipo: this.partesAgravoApenso[i].tipo.codigo
      })
    }
    const usuarioLogado = this.context.usuarioAutenticado;
    const objeto = {
      processoPrincipal: this.state.processo,
      processo: {
        nrCnj: this.state.numeroAgravoApenso
      },
      camara: this.state.camara,
      relator: this.state.relator,
      partes: partes,
      tipo: this.state.tipoProcessoAgravoApenso.codigo,
      usuario: usuarioLogado
    }
    this.setState({openSpinner: true});
    await this.agravoApensoService.cadastrarAgravoApenso(objeto)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Agravo/Apenso', detail:'Registro inserido com sucesso', life: 4000});
        this.listarAgravosApensos();
        this.fecharModal('modalAgravoApenso');
      }).catch(error => {
        this.setState(error.response.data);
        //console.log(error);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  consultarProcessoPrincipal = () => {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${this.state.processo.processoPrincipal.codigo}/SEARCH`});
    //this.props.history.push(`/fichaProcesso/${this.state.processo.processoPrincipal.codigo}/SEARCH`);
  }

  renderFooterAgravoApensoExistente(name) {
    return (
        <div>
          <Button label="Confirmar" 
                  className="p-button-primary p-button-text"
                  onClick={this.carregaProcessoExistenteAgravoApenso}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-danger p-button-text" 
                  onClick={this.cancelarConsultaAgravoApenso}/>
        </div>
    );
  }

  cancelarConsultaAgravoApenso = () => {
    this.setState({numeroAgravoApenso: ''});
    this.setState({agravoApensoExistente: null});
    this.fecharModal('modalAgravoApensoExistente');
  }

  async abrirModalAgravoApensoProcessoExistente(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  async abrirModalAgravoApenso(name, position) {
    
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }
    
    this.setState({openSpinner: true});
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposAgravoApenso();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  async abrirModalAgravoApenso2(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  limparCamposAgravoApenso = () => {
    this.setState({agravoApenso: null});
    this.setState({numeroAgravoApenso: ''});
    this.setState({nomeParteAgravoApenso: ''});
    this.setState({parteAgravoApenso: null});
    this.setState({camara: ''});
    this.setState({relator: ''});
    this.autoresAgravoApenso = [];
    this.reusAgravoApenso = [];
    this.partesAgravoApenso = [];
  } 

  incluirParteAgravoApenso = () => {
    if(this.state.nomeParteAgravoApenso == '') {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Informe o nome da parte', life: 4000});
      return;
    }

    if(this.state.tipoParteAgravoApenso == null) {
      this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Informe tipo da parte', life: 4000});
      return;
    }

    for(let i = 0; i < this.partesAgravoApenso.length; i++) {
      if(this.state.nomeParteAgravoApenso == this.partesAgravoApenso[i].nome) {
        this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Nome já incluído', life: 4000});
        return;
      }
    }

    const parte = {
      nome: this.state.nomeParteAgravoApenso,
      tipo: this.state.tipoParteAgravoApenso
    }

    this.partesAgravoApenso.push(parte);

    this.setState({nomeParteAgravoApenso: ''});
    this.setState({tipoParteAgravoApenso: ''});

    this.abrirModalAgravoApenso2('modalAgravoApenso');
  }

  acoesProcessoAgravosApensos(rowData) {
    return (
      <div>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoAgravoApenso(rowData)} 
                tooltip="Excluir Agravo/Apenso" 
                tooltipOptions={{position: 'top'}}/>
      </div>
    );
  }

  confirmaExclusaoAgravoApenso(processo) {
    this.setState({codigoAgravoApenso: processo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este registro?',
        header: 'Exclusão de registro de Agravo Apenso',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirAgravoApenso,
        reject: this.reject
    });
  }

  acceptExcluirAgravoApenso() {
    this.excluirAgravoApenso();
  }

  excluirAgravoApenso = async () => {
    this.setState({openSpinner: true});
    await this.agravoApensoService.excluirRegistro(this.state.codigoAgravoApenso)
      .then(response => {
        this.listarAgravosApensos();
        this.toast.show({severity:'success', summary: 'Agravo/Apenso', detail:'Registro excluído com sucesso', life: 4000});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Erro ao excluir registro', life: 4000});
      });

      this.setState({openSpinner: false});
  }

  listarAgravosApensos = () => {
    this.agravoApensoService.listar(this.state.processo.codigo)
      .then(response => {
        this.setState({agravosApensos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Agravo/Apenso', detail:'Erro ao listar processo de Agravo/Apenso', life: 4000});
      })
  }

  acoesPartesAgravoApenso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Parte"
                onClick={() => this.excluirParteAgravoApenso(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  excluirParteAgravoApenso(parte) {
    for(let i = 0; i < this.partesAgravoApenso.length; i++) {
      if(parte.nome === this.partesAgravoApenso[i].nome) {
        this.partesAgravoApenso.splice(i,1);
        this.abrirModalAgravoApenso2('modalAgravoApenso');
        return;
      }
    }
  }

  listarMotivosResultado = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.motivoResultadoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({motivos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Motivos de Resultado', life: 4000});
      })
  }

  listarTiposAndamento = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tipoAndamentoProcessualService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposAndamento: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Andamento Processual', detail:`${this.state.detail}`, life: 4000});
      });
  }

  listarPedidos = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.pedidoService.listarPedidos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pedidos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async abrirModalPedidos(name, position) {
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }
    this.setState({openSpinner: true});
    await this.listarPedidos();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampospedidos();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  limparCampospedidos = () => {
    this.setState({pedido: null});
    this.setState({vlProvavel: null});
    this.setState({vlPossivel: null});
    this.setState({vlRemoto: null});
  }

  cadastrarPedido = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.pedido == null) {
      this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:'O pedido é obrigatório', life: 4000});
      return;
    }

    let encontrou = false;
    for(let i = 0; i < this.state.pedidosProcesso.length; i++) {
      if(this.state.pedido.codigo === this.state.pedidosProcesso[i].pedido.codigo) {
        encontrou = true;
      }
    };

    if(encontrou) {
      this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:'Pedido já cadastrado no processo', life: 4000});
      return;
    }

    if((this.state.vlProvavel == null || this.state.vlProvavel == '' || this.state.vlProvavel == '0') &&
       (this.state.vlPossivel == null || this.state.vlPossivel == '' || this.state.vlPossivel == '0') &&
       (this.state.vlRemoto == null || this.state.vlRemoto == '' || this.state.vlRemoto == '0')) {
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:'Nenhum valor foi informado', life: 4000});
        return;
    }

    const pedidoProcesso = {
      pedido: this.state.pedido,
      processo: {
        codigo: this.state.processo.codigo
      },
      vlProvavel: this.state.vlProvavel == null ? 0 : this.state.vlProvavel,
      vlPossivel: this.state.vlPossivel == null ? 0 : this.state.vlPossivel,
      vlRemoto: this.state.vlRemoto == null ? 0 : this.state.vlRemoto,
      vlCausa: '0'
    }
    this.setState({openSpinner: true});
    this.pedidoProcessoService.cadastrarPedidoProcesso(pedidoProcesso)
      .then(response => {
        this.fecharModal('modalPedidos');
        this.consultarPedidosProcesso();
        this.setState({openSpinner: false});
        this.toast.show({severity:'success', summary: 'Pedidos do Processo', detail:'Peido cadastrado com sucesso', life: 4000});
        if(usuarioLogado.empresa.codigo == 1) {
          this.setState({vlCausa: response.data.vlCausa});
          this.toast.show({severity:'success', summary: 'Pedidos do Processo', detail:'Valor da Causa Atualizado', life: 12000});
        }
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async consultarPedidoProcesso(pedido) {
    this.setState({openSpinner: true});
    await this.pedidoProcessoService.consultarPedidoProcesso(pedido.codigo)
      .then(response => {
        this.setState({pedidoProcesso: response.data});
        this.setState({pedido: response.data.pedido})
        this.setState({vlPossivel: response.data.vlPossivel});
        this.setState({vlProvavel: response.data.vlProvavel});
        this.setState({vlRemoto: response.data.vlRemoto});
        this.abrirModalPedidoProcesso('modalAlterarPedido')
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${error}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async abrirModalPedidoProcesso(name, position) {
    await this.listarPedidos();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  alterarPedidoProcesso = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.pedido == null) {
      this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:'O pedido é obrigatório', life: 4000});
      return;
    }

    this.setState({openSpinner: true});
    const pedidoAlterar = {
      codigo: this.state.pedidoProcesso.codigo,
      pedido: this.state.pedido,
      processo: {
        codigo: this.state.processo.codigo
      },
      vlPossivel: this.state.vlPossivel,
      vlProvavel: this.state.vlProvavel,
      vlRemoto: this.state.vlRemoto
    };

    this.setState({openSpinner: true});
    await this.pedidoProcessoService.alterarPedidoProcesso(pedidoAlterar)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Pedidos do Processo', detail:'Pedido do processo alterado com sucesso!', life: 4000});
        this.consultarPedidosProcesso();
        if(usuarioLogado.empresa.codigo == 1) {
          this.setState({vlCausa: response.data.vlCausa});
          this.toast.show({severity:'success', summary: 'Pedidos do Processo', detail:'Valor da Causa Atualizado', life: 12000});
        }
        this.fecharModal('modalAlterarPedido');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${error}`, life: 4000});
      });
  }

  acoesPedidos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                tooltip="Editar Pedido"
                onClick={() => this.consultarPedidoProcesso(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Pedido"
                onClick={() => this.confirmaExclusaoPedido(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusaoPedido(pedido) {
    this.setState({codigoPedidoProcesso: pedido.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o pedido do processo?',
        header: 'Exclusão de Pagamento',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirPedido,
        reject: this.reject
    });
  }

  acceptExcluirPedido() {
    this.excluirPedido();
  }

  excluirPedido = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.pedidoProcessoService.excluirPedido(this.state.codigoPedidoProcesso)
      .then(response => {
        this.consultarPedidosProcesso();
        this.toast.show({severity:'success', summary: 'Pedidos do Processo', detail:'Pedido excluído com sucesso', life: 4000});
        if(usuarioLogado.empresa.codigo == 1) {
          this.setState({vlCausa: response.data});
          this.toast.show({severity:'success', summary: 'Pedidos do Processo', detail:'Valor da Causa Atualizado', life: 12000});
        }
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${this.state.detail}`, life: 4000});
      });
  }

  parseMoedaBR(valor) {
    if (!valor) return 0;

    return Number(
      valor
        .replace(/[^\d,.-]/g, "") // remove tudo que não for número, vírgula ou ponto
        .replace(/\./g, "")
        .replace(",", ".")
    );
  }

  consultarPedidosProcesso = async () => {
    await this.pedidoProcessoService.consultarPedidosProcesso(this.state.processo.codigo)
      .then(response => {
        this.setState({pedidosProcesso: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pedidos do Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarStatusAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.statusAtividadeService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusAtividade: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
  }

  listarEstados = async () => {
    this.estadoService.listarEstados()
      .then(response => {
        this.setState({estados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao listar Estados', life: 4000});
      });
  }

  onChangeTipoPessoa(e) {
    this.setState({selectTipo: e.value});
  }

  async onChangeEstado(e) {
    await this.setState({selectEstado: e.value});
    this.listarCidades();
  }

  listarCidades = () => {
    this.cidadeService.listarCidades(this.state.selectEstado.codigo)
      .then(response => {
        this.setState({cidades: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao listar Cidades', life: 4000});
      })
  }

  onChangeCidade(e) {
    this.setState({selectCidade: e.value});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastroCliente(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.listarEstados();
    this.setState({nome: ''});
    this.setState({selectTipo: null});
    this.setState({selectEstado: null});
    this.setState({selectCidade: null});
    this.setState(state);
  }

  async novoAutor() {
    await this.listarPerfisPessoa();
    this.abrirModalCadastroCliente('modalNovoCliente');
  }

  async novoReu() {
    await this.listarPerfisPessoa();
    this.abrirModalCadastroCliente('modalNovoCliente');
  }

  async novoAdvogado() {
    await this.listarPerfisPessoa();
    this.abrirModalCadastroCliente('modalNovoCliente');
  }

  cadastrarNovoCliente = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o nome da Pessoa', life: 4000});
      return false;
    }

    if(this.state.selectTipo == null || this.state.selectTipo.codigo == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o Tipo de Pessoa', life: 4000});
      return false;
    }

    if(this.state.selectCidade == null || this.state.selectCidade.codigo == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe a Cidade', life: 4000});
      return false;
    }

    if(this.state.perfil == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:'Informe o perfil da pessoa', life: 4000});
      return false;
    }

    await this.pessoaService.cadastrarPessoaProcesso({
      nome: this.state.nome,
      tipoPessoa: this.state.selectTipo.codigo,
      perfil: this.state.perfil,
      cidade: this.state.selectCidade,
      empresa: usuarioLogado.empresa,
      usuario: usuarioLogado.codigo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Cadastro de nova Pessoa', detail:'Nova Pessoa cadastrada com sucesso', life: 4000});
      this.fecharModal('modalNovoCliente');
      this.listarPessoasEmpresaParteCliente(this.state.processo.codigo);
      this.listarPessoasEmpresaParteContraria(this.state.processo.codigo);
      this.listarPessoasEmpresaAdvogados(this.state.processo.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Cadastro de nova Pessoa', detail:`${this.state.detail}`, life: 4000});
    })
  }

  listarPerfisPessoa = async () => {
    await this.pessoaService.listarPerfilPessoa()
      .then(response => {
        this.setState({perfis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de perfis de pessoa', life: 4000});
      })
  }

  carregaCombosConsulta = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.listarGruposTrabalho(usuarioLogado);
    this.listarTiposAcao(usuarioLogado.empresa);
    this.listarStatusProcessual(usuarioLogado.empresa);
    this.listarTiposDecisao(usuarioLogado.empresa);
    this.listarObjetosAcao(usuarioLogado.empresa);
    this.listarAreaAtuacao(usuarioLogado.empresa);
    this.listarMotivosResultado();
    this.listarRitosProcessuais();
    this.listarUsuarios();
    this.listarBancadas();
  }

  listarGruposTrabalho = (usuario) => {
    this.grupoTrabalhoService.listarGruposUsuario(usuario.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      });
  }

  listarTiposGarantias = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tipoGarantiaService.listarGarantias(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposGarantias: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Tipos de Garantias', detail:'Erro ao carregar Tipos de Garantias', life: 4000});
      })
  }

  listarTiposAcao = (empresa) => {
    this.tipoAcaoService.listarTipoAcao(empresa.codigo)
      .then(response => {
        this.setState({tiposAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Ação', life: 4000});
      })
  }

  listarStatusProcessual = (empresa) => {
    this.statusProcessualService.listarStatusProcessual(empresa.codigo)
      .then(response => {
        this.setState({statusProcessuais: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Status Processual', life: 4000});
      })
  }

  listarTiposDecisao = (empresa) => {
    this.tipoDecisaoService.listarTiposDecisao(empresa.codigo)
      .then(response => {
        this.setState({tiposDecisao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Decisão', life: 4000});
      })
  }

  listarObjetosAcao = async(empresa) => {
    const filtro = {
      empresa: empresa.codigo,
      processo: this.state.processo.codigo
    }
    await this.objetoAcaoService.listarObjetosForaProcesso(filtro)
      .then(response => {
        this.setState({objetosAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Objetos de Ação', life: 4000});
      })
  }

  listarSubObjetosAcao = (objetoPai) => {
    const filtro = {
      processo: this.state.processo.codigo,
      objetoPai: objetoPai
    }
    this.objetoAcaoService.listarSubObjetosForaProcesso(filtro)
      .then(response => {
        this.setState({subObjetosAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Sub-Objetos de Ação', life: 4000});
      })
  }

  async onChangeObjetos(e) {
    await this.setState({objetoAcao: e.value});
    this.listarSubObjetosAcao(this.state.objetoAcao.codigo);
  }

  listarAreaAtuacao = (empresa) => {
    this.areaAtuacaoService.listarAreaAtuacao(empresa.codigo)
      .then(response => {
        this.setState({areasAtuacao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Áreas de Atuação', life: 4000});
      })
  }

  

  confirmaExclusaoObjetoAcao(objeto) {
    this.setState({codigoObjeto: objeto.codigo});
    console.log('Objeto para ser excluído',objeto.codigo)
    confirmDialog({
        message: 'Deseja realmente excluir o Objeto de Ação?',
        header: 'Exclusão de Objeto de Ação',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.aceptExcluirObjetoAcao,
        reject: this.reject
    });
  }

  aceptExcluirObjetoAcao() {
    this.excluirObjetoAcao();
  }

  excluirObjetoAcao = async () => {
    this.setState({openSpinner: true});
    await this.objetoAcaoProcessoService.excluirObjetoProcesso(this.state.codigoObjeto)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Objetos de Ação', detail:'Objeto de Ação excluído', life: 4000});
        const usuarioLogado = this.context.usuarioAutenticado
        this.listarObjetosAcao(usuarioLogado.empresa);
        this.consultarObjetosPorProcesso(this.state.processo.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
      })

      this.setState({openSpinner: false});
  }

  listarTiposPagamentos = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tipoPagamentoService.listarTiposPagamentos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposPagamentos: response.data});
      }).catch(error => {
        console.log('Erro ao listar os tipos de pagamentos', error.data);
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  onChangeTipoPagamento(e) {
    this.setState({tipoPagamento: e.value});
  }

  onChangeTipoCustas(e) {
    this.setState({tipoCusta: e.value});
  }

  onChangeStatusProcessual(e) {
    this.setState({statusProcessual: e.value})
  }

  onChangeGrupoTrabalho(e) {
    this.setState({grupoTrabalho: e.value})
  }

  onChangeAreaAtuacao(e) {
    this.setState({areaAtuacao: e.value})
  }

  onChangeTipoAcao(e) {
    this.setState({tipoAcao: e.value})
  }

  consultarPessoa(event) {
    setTimeout(() => {
        let filterPessoas;
        if (!event.query.trim().length) {
            filterPessoas = [...this.state.pessoas];
        }
        else {
            filterPessoas = this.state.pessoas.filter((pessoa) => {
                return pessoa.nome.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }

        this.setState({ filterPessoas });
    }, 250);
  }

  load(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  async componentDidMount(){
    this.setState({openSpinner: true});
    const params = this.props.match.params;
    if(params.codigo) {
       await this.consultarProcesso(params.codigo);
       this.consultarProcessoImportancia();
       if(params.action == 'NEW') {
        this.toast.show({severity:'success', summary: 'Processos', detail:'Processo cadastrado com sucesso !', life: 4000});
       }
    }
    this.carregaCombosConsulta();
    this.listarPessoasEmpresaPartes();
 
    this.setState({openSpinner: false})
  }

  listarPessoasEmpresaPartes = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.pessoaService.listarPessoas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pessoas: response.data});
      }).catch(error => {
        console.log('Erro ao carregar pessoas');
      })
  }

  consultarObjetosPorProcesso = async (codigo) => {
    await this.objetoAcaoProcessoService.consultarObjetos(codigo)
      .then(response => {
        this.setState({objetosProcesso: response.data});
        let objetos = '';
        let contador = 0;
        const tamanhoLista = response.data.length;
        for(let i = 0; i < response.data.length; i++) {
          if(contador === tamanhoLista - 1) {
            objetos = objetos + response.data[i].objeto.nome;
          } else {
            objetos = objetos + response.data[i].objeto.nome + ',';
          }
          contador++;
        }
        this.setState({objetos: objetos});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  consultarHistoricoProcesso = async () => {
    await this.historicoProcessoService.listarHistorico(this.state.processo.codigo)
      .then(response => {
        this.setState({listaHistorico: response.data})
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesHistoricoProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Histórico"
                onClick={() => this.confirmaExclusaoHistorico(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

	historicoProcesso(rowData) {
		if(rowData.publicacoes != null) {
	   return(
        <div>{rowData.historico}<a onClick={() => this.consultarPublicacao(rowData.publicacoes.codigo)} 
				                           style={{cursor: 'pointer', color: 'blue'}}>Leia Mais</a></div>
      );
		} else {
			return(
				<div>{rowData.historico}</div>
			);
		}
	}

	consultarPublicacao = (publicacao) => {
    window.open(`#/publicacao/${publicacao}`, '_blank');
  }

	consultarPublicacaoAtividadeAberta = () => {
    const codigo = this.state.atividade && this.state.atividade.codigoPublicacao;
    if (!codigo) return;
    window.open(`#/publicacao/${codigo}`, '_blank');
  }

	imprimirPublicacao = async () => {
    try {
      const response = await this.publicacoesService
        .gerarPdfPublicacao(this.state.atividade.codigoPublicacao);

      if (response.status !== 200) {
        this.toast.show({
          severity: 'error',
          summary: 'Gerar PDF de Publicação',
          detail: 'Erro ao gerar PDF de Publicação',
          life: 4000
        });
        return;
      }

      const blob = response.data;

      const url = window.URL.createObjectURL(
        new Blob([blob], { type: 'application/pdf' })
      );

      window.open(url);

    } catch (error) {
      console.error(error);
      alert('Erro ao gerar o PDF da publicação');
    }
  }


  usuarioHistorico(rowData) {
    if(rowData.usuario.nome !== 'ILAW') {
      return(
        <React.Fragment>
          <i className="pi pi-user-plus" title="Incluído manualmente"></i>
        </React.Fragment>
      )
    }
  }

  confirmaExclusaoHistorico(historico) {
    this.setState({registroHistorico: historico});
    confirmDialog({
        message: 'Deseja realmente excluir o histórico da atividade?',
        header: 'Exclusão de Histórico de Atividade',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.excluirHistorico,
        reject: this.reject
    });
  } 

  excluirHistorico = async () => {
    this.setState({openSpinner: true});
    await this.historicoProcessoService.excluirHistorico(this.state.registroHistorico.codigo)
      .then(response => {
        this.listarHistoricoProcesso();
        this.toast.show({severity:'success', summary: 'Histórico do Processo', detail:'Andamento excluído com sucesso!', life: 4000});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarHistoricoAtividade(historico) {
    this.setState({openSpinner: true});
    await this.atividadeService.consultarHistoricoPorCodigo(historico.codigo)
      .then(response => {
        this.setState({dsHistorico: response.data.dsHistorico});
        this.setState({historicoAtividade: response.data});
        this.abrirModal('modalAlterarHistorico');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico da Atividade', detail:`${this.state.detail}`, life: 4000});
      })
  }

  alterarHistoricoAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    const historico =  {
      codigo: this.state.historicoAtividade.codigo,
      usuario: usuarioLogado,
      tpHistorico: 'M',
      atividade: {
        codigo: this.state.codigoAtividade
      },
      dsHistorico: this.state.dsHistorico,
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarHistorico(historico)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Histórico de Atividade', detail:'Histórico alterado com sucesso!', life: 4000});
        this.listarHistorico();
        this.fecharModalAtividade('modalAlterarHistorico');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Histórico de Atividade', detail:`${error}`, life: 4000});
      })
  }

  listarHistoricoProcesso = () => {
    var classific = 2;
    var ordena = 2;
    
    if(this.state.classificacaoAndamento != null) {
      classific = this.state.classificacaoAndamento.codigo;
    }

    if(this.state.ordenacaoAndamento != null) {
      ordena = this.state.ordenacaoAndamento.codigo;
    }

    this.historicoProcessoService.listarHistorico(this.state.processo.codigo,classific,ordena)
      .then(response => {
        this.setState({listaHistorico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Andamento Processual', detail:`${this.state.detail}`, life: 4000});
      })
  }

  reordenaHistorico = async () => {
    
    if(this.state.classificacaoAndamento == null) {
      this.toast.show({severity:'error', summary: 'Andamento Processual', detail:'Informe a clasificação do andamento', life: 4000});
      return;
    }

    if(this.state.ordenacaoAndamento == null) {
      this.toast.show({severity:'error', summary: 'Andamento Processual', detail:'Informe a ordenação do andamento', life: 4000});
      return;
    }

    this.setState({openSpinner: true});
    await this.historicoProcessoService.listarHistorico(this.state.processo.codigo,
      this.state.classificacaoAndamento.codigo,this.state.ordenacaoAndamento.codigo)
      .then(response => {
        this.setState({listaHistorico: response.data});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Andamento Processual', detail:`${this.state.detail}`, life: 4000});
      })
  }

  renderFooterCadastroHistorico(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.incluirHistorico}/>
          &nbsp;
          <Button label="Fechar" 
                          className="p-button-secondary p-button-text"
                          onClick={() => this.fecharModalCadastro(name)}/> 
        </div>
    );
  }

  abrirModalCadastroHistorico(name, position) {
    
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }

    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.listarTiposAndamento();
    this.limparCamposHistorico();
    this.setState(state);
  }

  limparCamposHistorico = () => {
    this.setState({
      descAndamento: '',
      dataOcorrencia: ''
    })
  }

  incluirHistorico = async () => {  
    const usuarioLogado = this.context.usuarioAutenticado;
    
    if(this.state.dataOcorrencia == '') {
      this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:'Informe a Data de Ocorrência', life: 4000});
      return false;
    }

    if(this.state.descAndamento == '') {
      this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:'Informe o Histórico', life: 4000});
      return false;
    }

    if(this.state.tipoAndamento == null) {
      this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:'Informe o Tipo de Andamento', life: 4000});
      return false;
    }

    if(this.state.dataOcorrencia != '') {
      var date = this.state.dataOcorrencia;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDataOcorrencia =  year+"-"+month+"-"+day;
    }

    this.setState({openSpinner: true});
    const historico = {
      processo: {
        codigo: this.state.processo.codigo
      },
      historico: this.state.descAndamento,
      tipoAndamento: this.state.tipoAndamento,
      dataOcorrencia: dataFormatadaDataOcorrencia,
      usuario: usuarioLogado
    }

    await this.historicoProcessoService.incluirHistorico(historico)
      .then(response => {
      this.toast.show({severity:'success', summary: 'Histórico do Processo', detail:'Histórico incluído com sucesso', life: 4000});
    }).catch(error => {
      console.log('Erro no andamento. ', error);
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:`${this.state.detail}`, life: 4000});
    });

    await this.listarHistoricoProcesso();
    this.fecharModalCadastro('modalHistorico')
    this.setState({openSpinner: false});
  }

  consultarArquivosProcesso = async codigo => {
    await this.arquivoProcessoService.listarArquivos(codigo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico do Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarProcesso = async (codigo) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.perfil.codigo == 1 || usuarioLogado.perfil.codigo == 2) {
      this.setState({isFinancero: true});
    }
    await this.processoService.consultarProcessoPorCodigo(codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({processo: response.data});
        this.setState({codigo: response.data.codigo})
        this.setState({grupoTrabalho: response.data.grupoTrabalho});
        this.setState({pasta: response.data.pasta});
        this.setState({nrProcesso: response.data.nrProcesso});
        this.setState({nrCnj: response.data.nrCnj});
        this.setState({instancia: response.data.instancia});
        this.setState({dsComarca: response.data.dsComarca});
        this.setState({tipoAcao: response.data.tipoAcao});
        this.setState({statusProcessual: response.data.statusProcessual});
        this.setState({areaAtuacao: response.data.areaAtuacao});
        this.setState({tipoDecisao: response.data.tipoDecisao});
        this.setState({vlProvavel: response.data.vlProvavel});
        this.setState({vlPossivel: response.data.vlPossivel});
        this.setState({vlRemoto: response.data.vlRemoto});
        this.setState({vlCausa: response.data.vlCausa});
        this.setState({dsPedidos: response.data.dsPedidos});
        this.setState({observacao: response.data.observacao});
        this.setState({orgaoColegiado: response.data.orgaoColegiado});
        this.setState({relatorProcesso: response.data.relator});
        this.setState({bancada: response.data.bancada});
        if(response.data.dataDistribuicao != null) {
          var dataDist = new Date(response.data.dataDistribuicao);
          dataDist.setDate(dataDist.getDate()+1)
          this.setState({dataDistribuicao: new Date(Date.parse(dataDist))})
        }

        if(response.data.dataSentenca != null) {
          var dataSet = new Date(response.data.dataSentenca);
          dataSet.setDate(dataSet.getDate()+1);
          this.setState({dataSentenca: dataSet});
        }

        if(response.data.dataUltimaDecisao != null) {
          var dataUltDec = new Date(response.data.dataUltimaDecisao);
          dataUltDec.setDate(dataUltDec.getDate()+1);
          this.setState({dataUltimaDecisao: dataUltDec})
        }
        
        if(response.data.dataCadastro != null) {
          var dataCad = new Date(response.data.dataCadastro);
          dataCad.setDate(dataCad.getDate()+1);
          this.setState({dataCadastro: dataCad})
        }
        
        if(response.data.dataUltimaMovimentacao != null) {
          var dataUltMov = new Date(response.data.dataUltimaMovimentacao);
          dataUltMov.setDate(dataUltMov.getDate()+1);
          this.setState({dataUltimaMovimentacao: dataUltMov})
        }
        
        this.setState({responsavelProcesso: response.data.responsavel});
        let p = [];
        if(response.data.snPush == 'S') {
          p.push('push')
        }
        if(response.data.snEmail == 'S') {
          p.push('email')
        }
        if(response.data.snHistorico == 'S') {
          p.push('historico');
        }
        if(response.data.snImportante == 'S') {
          this.setState({iconeImportanteParaEmpresa: 'p-button-rounded p-button-warning'});
          this.setState({iconeImportanteParaEmpresaTitle: 'Processo importante para empresa'});
        } else {
          this.setState({iconeImportanteParaEmpresa: 'p-button-rounded p-button-secondary'});
          this.setState({iconeImportanteParaEmpresaTitle: 'Clique para classificar o processo como importante'})
        }

        if(response.data.estrategico == 'S') {
          this.setState({iconeEstrategico: 'p-button-rounded p-button-info'});
          this.setState({iconeEstrátegicoTitle: 'Processo Estrategico'});
        } else {
          this.setState({iconeEstrategico: 'p-button-rounded p-button-secondary'});
          this.setState({iconeEstrátegicoTitle: 'Clique para tornar o processo estratégico'});
        }

        this.setState({push: p});
        if(response.data.uf != null) {
          this.setaEstado(response.data.uf);
        }
        
        this.setState({partesProcesso: response.data.partes});
        var partes = '';
        for(let i = 0; i < response.data.partes.length; i++) {
          partes = partes + response.data.partes[i].pessoa.nome + ", ";
        }
        this.setState({montaPartes: partes});
        this.setState({objetosProcesso: response.data.objetos});
        this.setState({pedidosProcesso: response.data.pedidos});
        this.retornaPagamentosProcesso(response.data);
        this.retornaCustasProcessuais(response.data);
        this.retornaGarantiasprocesso(response.data);
        this.setState({listaHistorico: response.data.historico});
        this.setState({atividades: response.data.atividades});
        this.setState({arquivos: response.data.arquivos});
        this.setState({lancamentosFinanceiros: response.data.lancamentos});
        this.setState({agravosApensos: response.data.agravosApensos})
        if(response.data.tipoContingenciaContabil != null && response.data.tipoContingenciaContabil != '') {
          if(response.data.tipoContingenciaContabil == 'PO') {
            this.setState({contingenciaContabil: {
              codigo: 'PO',
              nome: 'Possível'
            }});
          } else if(response.data.tipoContingenciaContabil == 'PR') {
            this.setState({contingenciaContabil: {
              codigo: 'PR',
              nome: 'Provável'
            }});
          } else {
            this.setState({contingenciaContabil: {
              codigo: 'RE',
              nome: 'Remoto'
            }});
          }
        }
  
        if(response.data.motivoDto != null) {
          this.setState({motivo: response.data.motivoDto});
        }

        if(response.data.processoPrincipal != null) {
          if(response.data.processoPrincipal.nrCnj != null) {
            this.setState({linkProcessoPrincipal: response.data.processoPrincipal.nrCnj});
          } else {
            this.setState({linkProcessoPrincipal: response.data.processoPrincipal.nrProcesso});
          }
          this.setState({exibeLInkProcessoPrincipal: 'block'});
        } else {
          this.setState({exibeLInkProcessoPrincipal: 'none'});
        }

        this.setState({rito: response.data.rito});
        this.consultarAgravoApenso(response.data.codigo);

        //Verifica se o processo está na lixeira
        if(response.data.status == 3) {
          this.setState({exibirProcessoExcluido: 'block'})
        } else {
          this.setState({exibirProcessoExcluido: 'none'});
        }

      }).catch(error => {
        this.setState({ openSpinner: false });

        let mensagem = 'Ocorreu um erro inesperado. Tente novamente mais tarde.';

        if (error.response && error.response.data) {
          if (typeof error.response.data === 'string') {
            mensagem = error.response.data;
          } else if (error.response.data.message) {
            mensagem = error.response.data.message;
          } else if (error.response.data.detail) {
            mensagem = error.response.data.detail;
          }
        }

        this.toast.show({severity: 'error',summary: 'Transferência de Atividades',detail: mensagem,life: 4000});
      })
  }

  consultarAgravoApenso = async (processo) => {
    await this.agravoApensoService.consultaAgravoApenso(processo)
      .then(response => {
        this.setState({agravoApensoConsulta: response.data});
        if(response.data.codigo != null) {
          this.setState({camaraConsulta: response.data.camara});
          this.setState({relatorConsulta: response.data.relator});
          this.setState({exibirAgravoApenso: 'block'});
          this.setState({exibirAgravoApensoNegacao: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })

      console.log('CSS', this.state.exibirAgravoApenso)
  }

  setaEstado = (uf) => {
    for(let i = 0; i < this.estados.length; i++) {
      if(uf == this.estados[i].codigo) {
        this.setState({uf: this.estados[i]});
        break;
      }
    }
  }

  consultarLancamentosFinanceiros = (processo) => {
    this.processoService.consultarLancamentosFinanceiros(processo)
      .then(response => {
        this.setState({lancamentosFinanceiros: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Lançamentos Financeiros', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesFinanceiro(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-search-plus" className="p-button-rounded p-button-text"
                tooltip="Consultar Lançamento"
                onClick={() => this.consultarLancamento(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    )
  }

  situacaoFinanceiro(rowData) {
    if(rowData.situacao == 'Pago') {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: 'green', width: '50px'}} value="PAGO"></Tag>
        </React.Fragment>
      );
    } else if(rowData.situacao == 'Ativo') {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: 'blue', width: '50px'}} value="ABETO"></Tag>
        </React.Fragment>
      );
    } else {
      <React.Fragment>
          <Tag style={{backgroundColor: 'red', width: '50px'}} value="CANCELADO"></Tag>
        </React.Fragment>
    }
  }

  tipoCategoriaFinanceiro(rowData) {
    if(rowData.categoria == 'Despesa') {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: 'red', width: '50px'}} value="DESPESA"></Tag>
        </React.Fragment>
      );
    } else {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: 'green', width: '50px'}} value="RECEITA"></Tag>
        </React.Fragment>
      );
    }
  }

  formatCurrency(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  async consultarLancamento(lancamento) {
    this.setState({openSpinner: true});
    await this.financeiroService.consultarLancamento(lancamento.codigo)
      .then(response => {
        this.setState({lancamento: response.data});
        this.setState({tipo: response.data.tipo});
        if(response.data.tipo.tipo == 'D') {
          this.setState({categoriaNome: 'Despesa'})
        } else {
          this.setState({categoriaNome: 'Receita'})
        }
        this.setState({tipoNome: response.data.tipo.nome});
        this.setState({vlLancamento: response.data.vlLancamento});
        this.setState({vlLancamentoMascara: this.formatCurrency(response.data.vlLancamento)});
        this.setState({dtVencimento: response.data.dtVencimento});
        this.setState({vlPago: response.data.vlPago});
        this.setState({vlPagoMascara: this.formatCurrency(response.data.vlPago)});
        this.setState({dtPago: response.data.dtPago});
        this.setState({dsLancamento: response.data.dsLancamento});
        this.setState({observacao: response.data.observacao});
        if(response.data.processo != null) {
          this.setState({dsProcesso: response.data.processo.nrCnj});
        } else {
          this.setState({dsProcesso: ''});
        }
        if(response.data.situacao == 'P') {
          this.setState({situacao: 'Pago'});
        } else {
          this.setState({situacao: 'Ativo'});
        }
        this.abrirModaConsultaLancamanto('displayConsultaLancamento');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Lancamento', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  renderFooterConsultaLancamento(name) {
    return (
        <div className="right">
            <Button label="Reabrir" 
                    className="p-button-info p-button-text" 
                    onClick={this.reabrirLancamento}/>
            &nbsp;
            <Button label="Pagar" 
                    className="p-button-success p-button-text" 
                    onClick={this.consultarLancamentoPagamento}/>
            &nbsp;
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  abrirModaConsultaLancamanto(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  reabrirLancamento = () => {
    if(this.state.lancamento.situacao == 'A') {
      this.toast.show({severity:'error', summary: 'Pagamento', detail:'O lançamento está ativo', life: 4000});
      return false;
    }
    this.financeiroService.reabrirLancamento({
      codigo: this.state.lancamento.codigo,
      situacao: 'A'
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Pagamento', detail:'Lançamento Reaberto', life: 4000});
      this.fecharModal('displayConsultaLancamento');
      this.consultarLancamentosFinanceiros(this.state.processo.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Pagamento', detail:`${this.state.detail}`, life: 4000});
    })
  }

  consultarLancamentoPagamento = () => {
    this.setState({vlLancamentoNovo: ''});
    this.setState({dtVencimentoNovo: ''});
    if(this.state.lancamento.tipo.tipo == 'D') {
      this.abrirModaConsultaLancamanto('modalDespesaPagamento')
    } else {
      this.abrirModal('modalReceitaPagamento')
    }
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  pagarDespesaReceita = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.lancamento.situacao == 'P') {
      this.toast.show({severity:'error', summary: 'Pagamento', detail:'Lançamento já pago', life: 4000});
      return false;
    }

    //Se o campo de novo valor estiver preenchido, paga o novo valor e cria um novo lancamento com a diferença
    if(this.state.vlLancamentoNovo != '') {
      //Efetua pagamento
      if(this.state.dtVencimentoNovo == '') {
        this.toast.show({severity:'error', summary: 'Pagamento', detail:'Informe a data de Vencimento', life: 4000});
        return false;
      }

      await this.financeiroService.pagarOuCancelarLancamentoIndividual({
        codigo: this.state.lancamento.codigo,
        situacao: 'P',
        vlPago: this.state.vlLancamentoNovo,
        observacao: this.state.observacao
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Pagamento', detail:'Pagamento Efetuado', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pagamento', detail:`${this.state.detail}`, life: 4000});
      });

      //Data de vencimento
      var novoValor = this.state.vlLancamento - this.state.vlLancamentoNovo;
      var dataFormatadaDataVencimento = '';
      if(this.state.dtVencimentoNovo != '') {
        var date = this.state.dtVencimentoNovo;
        var month = this.pad2(date.getMonth()+1);//months (0-11)
        var day = this.pad2(date.getDate());//day (1-31)
        var year= date.getFullYear();
        dataFormatadaDataVencimento =  year+"-"+month+"-"+day;
      };

      this.financeiroService.cadastrarLancamento({
        tipo: this.state.tipo,
        vlLancamento: novoValor,
        dtVencimento: dataFormatadaDataVencimento,
        observacao: 'Diferença do pagamento anterior',
        situacao: 'A',
        usuario: usuarioLogado.codigo,
        vlPago: '0',
        processo: this.state.lancamento.processo
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Cadastro de Lançamento', detail:'Novo lançamento cadastrado', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Lançamento', detail:`${this.state.detail}`, life: 4000});
      });

      this.fecharModal('modalDespesaPagamento');
      this.fecharModal('displayConsultaLancamento');
      this.consultarLancamentosFinanceiros(this.state.processo.codigo);

    } else {
      await this.financeiroService.pagarOuCancelarLancamentoIndividual({
        codigo: this.state.lancamento.codigo,
        situacao: 'P',
        vlPago: this.state.vlLancamento,
        observacao: this.state.observacao
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Pagamento de Despesa', detail:'Pagamento Efetuado', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pagamento de Despesa', detail:`${this.state.detail}`, life: 4000});
      });

      this.fecharModal('modalDespesaPagamento');
      this.fecharModal('displayConsultaLancamento');
      this.consultarLancamentosFinanceiros(this.state.processo.codigo);
    }
  }

  consultarPagamentosProcesso = async (codigo) => {
    await this.pagamentoProcessoService.listarPagamentos(codigo)
      .then(response => {
        this.setState({pagamentos: response.data});
        //Resumo
        let vlCredito = 0;
        let vlDebito = 0;
        let saldo = 0;
        for(let i = 0; i < this.state.pagamentos.length; i++) {
          if(this.state.pagamentos[i].tipo === 'Crédito') {
            vlCredito = vlCredito + this.state.pagamentos[i].vlPagamento;
          } else {
            vlDebito = vlDebito + this.state.pagamentos[i].vlPagamento;
          }
        }
        saldo = vlCredito - vlDebito;
        this.setState({vlCredito: vlCredito});
        this.setState({vlDebito: vlDebito});
        this.setState({saldo: saldo});
        this.setState({corSaldo: saldo < 0 ? 'vermelho' : 'verde'});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  retornaPagamentosProcesso = (processo) => {
    if(processo.pagamentos.length > 0) {
      this.setState({pagamentos: processo.pagamentos});
      let vlCredito = 0;
      let vlDebito = 0;
      let saldo = 0;
      for(let i = 0; i < processo.pagamentos.length; i++) {
        if(processo.pagamentos[i].tipo === 'Crédito') {
          vlCredito = vlCredito + processo.pagamentos[i].vlPagamento;
        } else {
          vlDebito = vlDebito + processo.pagamentos[i].vlPagamento;
        }
      }
    
      saldo = vlCredito - vlDebito;
      this.setState({vlCredito: vlCredito});
      this.setState({vlDebito: vlDebito});
      this.setState({saldo: saldo});
      this.setState({corSaldo: saldo < 0 ? 'vermelho' : 'verde'});
    }
  }

  adicionarAutor = () => {
    if(this.state.classeDivAutor === 'hide') {
      this.setState({classeDivAutor: 'show'});
      this.setState({iconAutor: 'pi pi-angle-double-left'});
      this.setState({classeAutor: 'p-button-rounded  p-button-secondary p-button-text'});
      this.setState({toolTipAutor: 'Cancelar adicionar autor(es)'});
      this.setState({selectedAutor: null});
    } else {
      this.setState({classeDivAutor: 'hide'});
      this.setState({iconAutor: 'pi pi-plus-circle'});
      this.setState({classeAutor: 'p-button-rounded p-button-text'});
      this.setState({toolTipAutor: 'Clique para adicionar autor(es)'})
    }
  }

  adicionarReu = () => {
    if(this.state.classeDivReu === 'hide') {
      this.setState({classeDivReu: 'show'});
      this.setState({iconReu: 'pi pi-angle-double-left'});
      this.setState({classeReu: 'p-button-rounded  p-button-secondary p-button-text'});
      this.setState({toolTipReu: 'Cancelar adicionar réu(s)'});
      this.setState({selectedReu: null});
    } else {
      this.setState({classeDivReu: 'hide'});
      this.setState({iconReu: 'pi pi-plus-circle'});
      this.setState({classeReu: 'p-button-rounded p-button-text'});
      this.setState({toolTipReu: 'Clique para adicionar réu(s)'})
    }
  }

  adicionarAdvogado = () => {
    if(this.state.classeDivAdvogado === 'hide') {
      this.setState({classeDivAdvogado: 'show'});
      this.setState({iconAdvogado: 'pi pi-angle-double-left'});
      this.setState({classeAdvogado: 'p-button-rounded  p-button-secondary p-button-text'});
      this.setState({toolTipAdvogado: 'Cancelar adicionar advogado(s)'});
      this.setState({selectedAdvogado: null});
    } else {
      this.setState({classeDivAdvogado: 'hide'});
      this.setState({iconAdvogado: 'pi pi-plus-circle'});
      this.setState({classeAdvogado: 'p-button-rounded p-button-text'});
      this.setState({toolTipAdvogado: 'Clique para adicionar advogado(s)'})
    }
  }

  acoesObjetosAcao(rowData) {
    return (
      <React.Fragment>
       <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
               tooltip="Retirar Objeto"
               tooltipOptions={{position: 'top'}}
               onClick={() => this.confirmaExclusaoObjetoAcao(rowData)}
               style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  onTipoDecisaoChange(e) {
    this.setState({tipoDecisao: e.value});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  formatCurrency(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  vlPagamento(rowData) {
    return this.formatCurrency(rowData.vlPagamento);
  }

  vlCustas(rowData) {
    return this.formatCurrency(rowData.vlCustas);
  }

  vlPenhora(rowData) {
    return this.formatCurrency(rowData.vlPenhora);
  }

  acoesPagamentosProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Pagamento"
                onClick={() => this.confirmaExclusaoPagamento(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  headerResumoPagamentos() {
    return(
      <React.Fragment>
        <label>Pagamentos: &nbsp;&nbsp; 
        <span className="verde">Credito: {this.formatCurrency(this.state.vlCredito)}</span>&nbsp;&nbsp;&nbsp; 
        <span className="vermelho">Débito: {this.formatCurrency(this.state.vlDebito)}</span> &nbsp;&nbsp;&nbsp;
        <span className={this.state.corSaldo}>Saldo: {this.formatCurrency(this.state.saldo)}</span></label>
      </React.Fragment>
    );
  }

  headerResumoCustas() {
    return(
      <React.Fragment>
        <label>Custas: &nbsp;&nbsp; 
        <span className="verde">Credito: {this.formatCurrency(this.state.vlCreditoCustas)}</span>&nbsp;&nbsp;&nbsp; 
        <span className="vermelho">Débito: {this.formatCurrency(this.state.vlDebitoCustas)}</span> &nbsp;&nbsp;&nbsp;
        <span className={this.state.corSaldoCustas}>Saldo: {this.formatCurrency(this.state.saldoCustas)}</span></label>
      </React.Fragment>
    )
  }

  acoesCustasProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Custas"
                onClick={() => this.confirmaExclusaoCusta(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  renderFooterCadastroPagamentos(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.incluirPagamento}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastroPagamentos(name, position) {
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }
    this.listarTiposPagamentos();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposPagamentos();
    this.setState(state);
  }

  limparCamposPagamentos = () => {
    this.setState({
      tipoPagamento: null,
      dtPagamento: '',
      tipo: '',
      vlPagamento: ''});
  }

  renderFooterCadastroCustas(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.incluirCustas}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastroCustas(name, position) {
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }
    this.listarTiposCustas();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposCustas();
    this.setState(state);
  }

  limparCamposCustas = () => {
    this.setState({
      tipoCusta: null,
      dtPagamento: '',
      tipo: '',
      vlCustas: '',
    })
  }

  limparCamposPagamentos = () => {
    this.setState({
      tipoPagamento: null,
      dtPagamento: '',
      tipo: '',
      vlPagamento: ''});
  }

  listarTiposCustas = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tipoCustaService.listarTiposCusta(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposCustas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Custa', detail:`${this.state.detail}`, life: 4000});
      })
  }

  incluirCustas = async() => {
    if(this.state.tipoCusta == null) {
      this.toast.show({severity:'error', summary: 'Custas', detail:'Informe o Tipo de Custa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.tipo == null) {
      this.toast.show({severity:'error', summary: 'Custas', detail:'Informe o tipo Débito ou Crédito', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.vlCustas == '') {
      this.toast.show({severity:'error', summary: 'Custas', detail:'Informe o Valor da Custa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.dtPagamento == '') {
      this.toast.show({severity:'error', summary: 'Custas', detail:'Informe a Data do pagamanto da custa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    var date = this.state.dtPagamento
    var month = this.pad2(date.getMonth()+1);//months (0-11)
    var day = this.pad2(date.getDate());//day (1-31)
    var year= date.getFullYear();
    var dataFormatada =  year+"-"+month+"-"+day;

    this.setState({openSpinner: true});
    await this.custasProcessoService.incluirCustas({
      processo: {
        codigo: this.state.processo.codigo
      },
      custas: this.state.tipoCusta,
      tipo: this.state.tipo.codigo,
      vlCustas: this.state.vlCustas,
      dtPagamento: dataFormatada
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Custas', detail:'Custas incluída com sucesso', life: 4000});
      this.consultarCustasProcesso(this.state.processo.codigo);
      this.fecharModalCadastro('modalCustas');
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Custas', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({openSpinner: false});

  }

  incluirPagamento = async() => {
    if(this.state.tipoPagamento == null) {
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:'Informe o Tipo de Pagamento', life: 4000});
      return false;
    }

    if(this.state.tipo == null) {
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:'Informe o tipo Débito ou Crédito', life: 4000});
      return false;
    }

    if(this.state.vlPagamento == '') {
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:'Informe o Valor do Pagamento', life: 4000});
      return false;
    }

    if(this.state.dtPagamento == '') {
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:'Informe a Data de Pagamento', life: 4000});
      return false;
    }

    var date = this.state.dtPagamento
    var month = this.pad2(date.getMonth()+1);//months (0-11)
    var day = this.pad2(date.getDate());//day (1-31)
    var year= date.getFullYear();
    var dataFormatada =  year+"-"+month+"-"+day;

    this.setState({openSpinner: true});

    await this.pagamentoProcessoService.incluirPagamento({
      processo: {
        codigo: this.state.processo.codigo
      },
      pagamento: this.state.tipoPagamento,
      vlPagamento: this.state.vlPagamento,
      dtPagamento: dataFormatada,
      tipo: this.state.tipo.codigo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Pagamentos', detail:'Pagamento incluído', life: 4000});
      this.consultarPagamentosProcesso(this.state.processo.codigo);
      this.fecharModalCadastro('modalPagamentos');
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Pagamentos', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({openSpinner: false});
  }

  acceptExcluirPagamento() {
    this.excluirPagamentoProcesso();
  }

  acceptExcluirCustas() {
    this.excluirCusta();
  }

  confirmaExclusaoPagamento(pagamento) {
    this.setState({codigoPagamento: pagamento.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir Pagamento do Processo?',
        header: 'Exclusão de Pagamento',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirPagamento,
        reject: this.reject
    });
  }

  confirmaExclusaoCusta(custa) {
    this.setState({codigoCusta: custa.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a Custa?',
        header: 'Exclusão de Custas',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirCustas,
        reject: this.reject
    });
  }

  excluirPagamentoProcesso = async () => {
    this.setState({openSpinner: true});
    await this.pagamentoProcessoService.excluirPagamento(this.state.codigoPagamento)
    .then(response => {
        this.consultarPagamentosProcesso(this.state.processo.codigo);
        this.toast.show({severity:'success', summary: 'Pagamentos', detail:'Pagamento excluído', life: 4000});
    }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pagamentos', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({visiblePagamento: false});
    this.setState({openSpinner: false});
  }

  excluirCusta = async() => {
    this.setState({classeDiv: 'show'});
    await this.custasProcessoService.excluirCustas(this.state.codigoCusta)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Custas', detail:'Custa Excluída', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Custas', detail:`${this.state.detail}`, life: 4000});
      })

      this.setState({visibleCustas: false});
      this.consultarCustasProcesso(this.state.processo.codigo);
      this.setState({classeDiv: 'hide'});
  }

  consultarCustasProcesso = async (codigo) => {
    await this.custasProcessoService.listarCustas(codigo)
      .then(response => {
        this.setState({custasProcessos: response.data});
        let vlCredito = 0;
        let vlDebito = 0;
        let saldo = 0;
        for(let i = 0; i < this.state.custasProcessos.length; i++) {
          if(this.state.custasProcessos[i].tipo === 'Crédito') {
            vlCredito = vlCredito + this.state.custasProcessos[i].vlCustas;
          } else {
            vlDebito = vlDebito + this.state.custasProcessos[i].vlCustas;
          }
        }
        saldo = vlCredito - vlDebito;
        this.setState({vlCreditoCustas: vlCredito});
        this.setState({vlDebitoCustas: vlDebito});
        this.setState({saldoCustas: saldo});
        this.setState({corSaldoCustas: saldo < 0 ? 'vermelho' : 'verde'});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Custas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  retornaCustasProcessuais = (processo) => {
    if(processo.custas.length > 0) {
      this.setState({custasProcessos: processo.custas});
      let vlCredito = 0;
      let vlDebito = 0;
      let saldo = 0;
      for(let i = 0; i < processo.custas.length; i++) {
        if(processo.custas[i].tipo === 'Crédito') {
          vlCredito = vlCredito + this.state.custasProcessos[i].vlCustas;
        } else {
          vlDebito = vlDebito + processo.custas[i].vlCustas;
        }
      }

      saldo = vlCredito - vlDebito;
      this.setState({vlCreditoCustas: vlCredito});
      this.setState({vlDebitoCustas: vlDebito});
      this.setState({saldoCustas: saldo});
      this.setState({corSaldoCustas: saldo < 0 ? 'vermelho' : 'verde'});
    }
  }

  consultarGarantiasProcesso = async (codigo) => {
    await this.garantiaProcessoService.listarGarantiasProcesso(codigo)
      .then(response => {
        this.setState({garantiasProcesso: response.data});
        let total = 0;
        for(let i = 0; i < this.state.garantiasProcesso.length; i++) {
          total = total + this.state.garantiasProcesso[i].vlPenhora;
        }
        this.setState({totalPenhora: total});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  retornaGarantiasprocesso = (processo) => {
    if(processo.garantias.length > 0) {
      this.setState({garantiasProcesso: processo.garantias});
      let total = 0;
      for(let i = 0; i < processo.garantias.length; i++) {
        total = total + processo.garantias[i].vlPenhora;
      }
      this.setState({totalPenhora: total});
    }
  }

  headerTotalPenhora() {
    return(
      <React.Fragment>
        <label>Garantias: &nbsp;&nbsp; 
        <span className="verde">{this.formatCurrency(this.state.totalPenhora)}</span>&nbsp;&nbsp;&nbsp; </label>
      </React.Fragment>
    )
  }

  onChangeTipoGarantia(e) {
    this.setState({tipoGarantia: e.value});
  }

  acoesGarantiasProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Garantia"
                onClick={() => this.confirmaExclusaoGarantia(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusaoGarantia(garantia) {
    this.setState({codigoGarantia: garantia.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a Garantia?',
        header: 'Exclusão de Garantias',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirGarantias,
        reject: this.reject
    });
  }

  acceptExcluirGarantias() {
    this.excluirGarantia();
  }

  excluirGarantia = async() => {
    this.setState({classeDiv: 'show'});
    await this.garantiaProcessoService.excluirGarantia(this.state.codigoGarantia)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Garantias', detail:'Garantia Excluída', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Garantias', detail:`${this.state.detail}`, life: 4000});
      })

      this.setState({visibleGarantias: false});
      this.listarGarantiasProcesso(this.state.processo.codigo);
      this.setState({classeDiv: 'hide'});
  }

  renderFooterCadastroGarantias(name) {
    return (
        <div>
          <Button label="Cadastrar" 
                  className="p-button-primary p-button-text"
                  onClick={this.incluirGarantias}/>
          &nbsp;
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  incluirGarantias = async () => {
    if(this.state.tipoGarantia == null) {
      this.toast.show({severity:'error', summary: 'Garantias', detail:'Informe o Tipo de Garantia', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.vlPenhora == '') {
      this.toast.show({severity:'error', summary: 'Garantias', detail:'Informe o Valor da Penhora', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }
    this.setState({openSpinner: true});
    await this.garantiaProcessoService.incluirGarantias({
      processo: {
        codigo: this.state.processo.codigo
      },
      garantia: this.state.tipoGarantia,
      vlPenhora: this.state.vlPenhora
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Garantias', detail:'Garantia Incluída com Sucesso', life: 4000});
      this.consultarGarantiasProcesso(this.state.processo.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Garantias', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalGarantias');
    this.setState({openSpinner: false})
  }

  abrirModalCadastroGarantias(name, position) {
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }
    this.listarTiposGarantias();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCamposGarantias();
    this.setState(state);
  }

  limparCamposGarantias = () => {
    this.setState({
      tipoGarantia: null,
      vlPenhora: ''
    })
  }

  voltar = async () => {
    const consultaIndice = LocalStorageService.obterConsulta('_consulta_processo_indice');
    const consultaIndiceJson = JSON.parse(consultaIndice);

    const consultaFiltro = LocalStorageService.obterConsulta('_consulta_processo_filtro');
    const consultaFiltroJson = JSON.parse(consultaFiltro);

    if(consultaIndiceJson != null) {
      this.setState({openSpinner: true});
      await this.processoService.consultarProcessoPorIndice(consultaIndiceJson)
        .then(response => {
            this.props.history.push(`/processos?indice=${consultaIndiceJson.indice}&empresa=${consultaIndiceJson.empresa}&usuario=${consultaIndiceJson.usuario}`);
        }).catch(error => {
          this.setState({openSpinner: false});
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
        })
    } else if(consultaFiltroJson != null) {
      
      let params = `/processos?empresa=${consultaFiltroJson.empresa.codigo}&usuario=${consultaFiltroJson.usuario}`;

      if(consultaFiltroJson.pessoa != '') {
        params = `${params}&pessoa=${consultaFiltroJson.pessoa}`;
      }

      if(consultaFiltroJson.grupoTrabalho != null) {
        params = `${params}&grupoTrabalho=${consultaFiltroJson.grupoTrabalho.codigo}`;
      }

      if(consultaFiltroJson.tipoAcao != null) {
        params = `${params}&tipoAcao=${consultaFiltroJson.tipoAcao.codigo}`;
      }

      if(consultaFiltroJson.statusProcessual != null) {
        params = `${params}&statusProcessual=${consultaFiltroJson.statusProcessual.codigo}`;
      }

      if(consultaFiltroJson.tipoDecisao != null) {
        params = `${params}&tipoDecisao=${consultaFiltroJson.tipoDecisao.codigo}`;
      }

      if(consultaFiltroJson.pasta != '') {
        params = `${params}&pasta=${consultaFiltroJson.pasta}`;
      }

      if(consultaFiltroJson.numeroProcesso != '') {
        params = `${params}&numeroProcesso=${consultaFiltroJson.numeroProcesso}`;
      }

      if(consultaFiltroJson.numeroCnj != '') {
        params = `${params}&numeroCnj=${consultaFiltroJson.numeroCnj}`;
      }

      if(consultaFiltroJson.importanteParaMim === 'SIM') {
        params = `${params}&importanteParaMim=${consultaFiltroJson.importanteParaMim}`
      } 

      this.props.history.push(params);

    } else {
      this.props.history.push('/processos');
    }
  }

  copiarTextoParte = (texto) => {
    if (!texto) return;

    //input.select();
    //input.setSelectionRange(0, 99999); // mobile

    try {
      if (navigator.clipboard && window.isSecureContext) {
        // Ambiente seguro (https / localhost)
        navigator.clipboard.writeText(texto);
      } else {
        // Fallback para HTTP / intranet
        document.execCommand("copy");
      }

      this.toast.show({severity:'success', summary: 'Partes', detail:'Copiado!', life: 4000});

    } catch (err) {
      console.error("Erro ao copiar:", err);
    }
  }

  acoesPartes(rowData) {
    return(
      <React.Fragment>
        <a className="cursor"
           title="Copiar"
           onClick={() => this.copiarTextoParte(rowData.pessoa.nome)}>
             <i className="pi pi-copy"></i>
        </a>
        &nbsp;
        &nbsp;
        <a className="cursor" 
           title="Excluir Parte"
           onClick={() => this.confirmaExclusaoParte(rowData)}>
             <i className="pi pi-trash"></i>
        </a>
        &nbsp;
        &nbsp;
        <a href={this.state.linkFichaPessoa} 
           className="cursor" 
           target="_blank"
           title="Consultar Pessoa"
           onClick={() => this.consultarPessoaFicha(rowData)}>
             <i className="pi pi-user"></i>
        </a>
      </React.Fragment>
    );
  }

  exibirNovaParte = () => {
    this.setState({selectParte: null});
    this.setState({tipoParte: null});
    if(this.state.exibirNovaParte == 'none') {
      this.setState({exibirNovaParte: 'block'});
      this.setState({iconeExibirNovaParte: '-'});
    } else {
      this.setState({exibirNovaParte: 'none'});
      this.setState({iconeExibirNovaParte: '+'});
    }
  }

  confirmaExclusaoParte(parte) {
    this.setState({codigoParte: parte.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir esta parte do processo?',
        header: 'Exclusão de Partes',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirParte,
        reject: this.reject
    });
  }

  acceptExcluirParte() {
    this.excluirParte();
  }

  excluirParte = async () => {
    this.setState({openSpinner: true});
    await this.processoService.excluirParte(this.state.codigoParte)
      .then(response => {
        this.consultarPartes();
        this.toast.show({severity:'success', summary: 'Processos', detail:'Parte retirada do processo', life: 4000});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao excluir parte', life: 4000});
      })

      this.setState({openSpinner: false});
  }
	
	consultarPessoa2 = async (codigo) => {
    await this.pessoaService.consultarPessoa(codigo)
      .then(response => {
        this.setState({pessoaProcesso: response.data});
      }).catch(error => {
        console.log('Erro ', error)
      })
  }

  async incluirParte(e){
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enqaunto um processo estiver na lixeira', life: 4000});
      return;
    }
    if(this.state.selectParte == null) {
      this.toast.show({severity:'error', summary: 'Processo', detail:'Informe o nome da parte', life: 4000});
      this.setState({tipoParte: null});
      this.setState({selectParte: null});
      return;
    }
    this.setState({openSpinner: true});
    this.setState({tipoParte: e.value})
    for(let i = 0; i < this.state.selectParte.length; i++) {
			await this.consultarPessoa2(this.state.selectParte[i].codigo);
      const parteIncluir = {
        pessoa: this.state.pessoaProcesso,
				processo: {
					codigo: this.state.codigo
				},
        tipoParte: e.value.codigo
      }

	    await this.processoService.cadastrarPartes(parteIncluir)
        .then(response => {
          this.consultarPartes();
          this.toast.show({severity:'success', summary: 'Processos', detail:`${this.state.selectParte[i].nome} incluído no processo`, life: 4000});
        }).catch(error => {
          this.setState({openSpinner: false});
          this.toast.show({severity:'error', summary: 'Processos', detail:`${error}`, life: 4000});
        })
    }
    this.setState({selectParte: null});
    this.setState({exibirNovaParte: 'none'});
    this.setState({iconeExibirNovaParte: '+'});
    this.setState({tipoParte: null});
    this.setState({openSpinner: false});
  }

  consultarPartes = async () => {
    await this.processoService.consultarPartesPorProcesso(this.state.codigo)
      .then(response => {
        this.setState({partesProcesso: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao consultar partes do processo', life: 4000});
      })
  }

  async consultarPessoaFicha(parte) {
    this.setState({linkFichaPessoa: `#/consultarPessoas/${parte.pessoa.codigo}`});
  }

  alterarProcesso = async () => {
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Este processo não pode ser alterado! É necessário primeiramente restaurá-lo', life: 4000});
      return false;
    }
    if(this.state.responsavelProcesso == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'É preciso informar o responsável do processo', life: 4000});
      return false;
    }

    if(this.state.numeroCnj == '' && this.pasta == '' && this.state.numeroProcesso) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'É preciso informar uma pasta ou um processo ou um cnj', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.grupoTrabalho == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'É preciso informe o Grupo de Trabalho', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    // Troca de Grupo de Trabalho do processo: se houver atividades vinculadas, o usuário
    // precisa escolher o novo Sub-Grupo delas antes de a alteração ser salva
    const grupoAntigo = this.state.processo.grupoTrabalho;
    const grupoMudou = grupoAntigo == null || this.state.grupoTrabalho.codigo != grupoAntigo.codigo;
    if(grupoMudou && this.state.subGrupoParaTrocaGrupo == null) {
      this.setState({openSpinner: true});
      let atividadesProcesso = [];
      await this.atividadeService.consultarAtividadePorProcesso(this.state.processo.codigo)
        .then(response => {
          atividadesProcesso = response.data;
        }).catch(error => {
          this.toast.show({severity:'error', summary: 'Processos', detail:'Não foi possível verificar as atividades vinculadas ao processo', life: 4000});
        });

      if(atividadesProcesso.length > 0) {
        await this.grupoTrabalhoService.listarSubGrupos(this.state.grupoTrabalho.grupoPai)
          .then(response => {
            this.setState({
              atividadesParaTrocaGrupo: atividadesProcesso,
              subGruposTrocaGrupo: response.data,
              modalTrocaGrupoVisible: true
            });
          }).catch(error => {
            this.toast.show({severity:'error', summary: 'Processos', detail:'Não foi possível carregar os sub-grupos do novo Grupo de Trabalho', life: 4000});
          });
        this.setState({openSpinner: false});
        return false;
      }
      this.setState({openSpinner: false});
    }

    if(this.state.statusProcessual == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o Status Processual', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.areaAtuacao == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe a Área de Atuação', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.tipoAcao == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o Tipo de Ação', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.dsComarca == '') {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Informe o local de trâmite', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    const usuarioLogado = this.context.usuarioAutenticado;

    //Campos de Data
    //Data de Distribuição
    if(this.state.dataDistribuicao != '' && this.state.dataDistribuicao != null) {
      var date = this.state.dataDistribuicao;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDataDistribuicao =  year+"-"+month+"-"+day;
    }
    //Data de Última de Decisão
    if(this.state.dataUltimaDecisao != '' && this.state.dataUltimaDecisao != null) {
      var date = this.state.dataUltimaDecisao;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDataUltimaDecisao =  year+"-"+month+"-"+day;
    }
    //Data de Sentença
    if(this.state.dataSentenca != '' && this.state.dataSentenca != null) {
      var date = this.state.dataSentenca;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      var dataFormatadaDataSentenca =  year+"-"+month+"-"+day;
    }

    //Push
    let push = 'N';
    let email = 'N';
    let historico = 'N';
    if(this.state.push != null & this.state.push.length > 0) {
      for(let i = 0; i < this.state.push.length; i++) {
        if(this.state.push[i] == 'push') {
          push = 'S'
        }
        if(this.state.push[i] == 'email') {
          email = 'S'
        }
        if(this.state.push[i] == 'historico') {
          historico = 'S'
        }
      }
    }
    var uf = null;
    if(this.state.uf == null) {
      uf = null;
    } else {
      uf = this.state.uf.codigo;
    }
    var contingenciaContabil = null;
    if(this.state.contingenciaContabil != null) {
      contingenciaContabil = this.state.contingenciaContabil.codigo;
    } else {
      contingenciaContabil = null;
    }
    this.setState({openSpinner: true});
    await this.processoService.alterarProcesso({
      codigo: this.state.processo.codigo,
      grupoTrabalho: this.state.grupoTrabalho,
      pasta: this.state.pasta,
      nrProcesso: this.state.nrProcesso,
      nrCnj: this.state.nrCnj,
      instancia: this.state.instancia,
      dsComarca: this.state.dsComarca,
      tipoAcao: this.state.tipoAcao,
      statusProcessual: this.state.statusProcessual,
      areaAtuacao: this.state.areaAtuacao,
      tipoDecisao: this.state.tipoDecisao,
      vlProvavel: this.state.vlProvavel,
      vlPossivel: this.state.vlPossivel,
      vlRemoto: this.state.vlRemoto,
      vlCausa: this.state.vlCausa,
      dsPedidos: this.state.dsPedidos,
      dataDistribuicao : dataFormatadaDataDistribuicao,
      dataUltimaDecisao: dataFormatadaDataUltimaDecisao,
      dataSentenca: dataFormatadaDataSentenca,
      snPush: push,
      snEmail: email,
      snHistorico: historico,
      observacao: this.state.observacao,
      usuario: usuarioLogado,
      responsavel: this.state.responsavelProcesso,
      empresa: usuarioLogado.empresa,
      tipoContingenciaContabil: contingenciaContabil,
      motivoDto: this.state.motivo,
      rito: this.state.rito,
      uf: uf,
      orgaoColegiado: this.state.orgaoColegiado,
      relator: this.state.relatorProcesso,
      bancada: this.state.bancada
    }).then(async response => {
      if(this.state.subGrupoParaTrocaGrupo != null && this.state.atividadesParaTrocaGrupo.length > 0) {
        await this.atividadeService.alterarMassa({
          atividades: this.state.atividadesParaTrocaGrupo.map(atividade => ({codigo: atividade.codigo})),
          usuario: usuarioLogado,
          subGrupo: this.state.subGrupoParaTrocaGrupo
        }).then(() => {
          this.toast.show({severity:'success', summary: 'Atividades', detail:'Sub-grupo das atividades do processo atualizado com sucesso', life: 4000});
        }).catch(error => {
          this.toast.show({severity:'error', summary: 'Atividades', detail:'O grupo do processo foi alterado, mas não foi possível atualizar o sub-grupo das atividades vinculadas. Tente novamente.', life: 8000});
        });
        this.setState({subGrupoParaTrocaGrupo: null, atividadesParaTrocaGrupo: [], subGruposTrocaGrupo: []});
        this.consultarAtividades(this.state.processo);
      }
      this.setState({classeDivAutor: 'hide'});
      this.setState({classeDivReu: 'hide'});
      this.setState({classeDivAdvogado: 'hide'});
      this.setState({iconReu: 'pi pi-plus-circle'});
      this.setState({iconAutor: 'pi pi-plus-circle'});
      this.setState({iconAdvogado: 'pi pi-plus-circle'});
      if(this.state.agravoApensoConsulta.codigo != null) {
        const agravoApenso = {
          codigo: this.state.agravoApensoConsulta.codigo,
          processo: this.state.agravoApensoConsulta.processo,
          processoPrincipal: this.state.agravoApensoConsulta.processoPrincipal,
          camara: this.state.camaraConsulta,
          relator: this.state.relatorConsulta,
          tipo: this.state.agravoApensoConsulta.tipo
        }
        this.agravoApensoService.alterar(agravoApenso)
          .then(response => {
            this.toast.show({severity:'success', summary: 'Processo Agravo Apenso', detail:'Processo Agravo/Apenso alterado', life: 4000});
          }).catch(error => {
            this.toast.show({severity:'success', summary: 'Processo Agravo Apenso', detail:'Processo Agravo/Apenso alterado', life: 4000});
          })
      }
      this.consultarProcesso(this.state.processo.codigo);
      this.toast.show({severity:'success', summary: 'Processos', detail:'Processo alterado com sucesso', life: 4000});
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
    })

    this.setState({openSpinner: false})
  }

  cadastrarPartes = async (processo) => {
    if(this.state.selectedAutor != null) {
      for(let i = 0; i < this.state.selectedAutor.length; i++) {
        await this.processoService.cadastrarPartes({
          processo: processo,
          pessoa: this.state.selectedAutor[i],
          tipoParte: 'A'
        }).then(response => {
          console.log('Partes cadastrada',this.state.selectedAutor[i].nome);
        }).catch(error => {
          this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao cadastrar uma das partes do processo - Autor', life: 4000});
        })
      };
    }
    
    if(this.state.selectedReu != null) {
      for(let i = 0; i < this.state.selectedReu.length; i++) {
        await this.processoService.cadastrarPartes({
          processo: processo,
          pessoa: this.state.selectedReu[i],
          tipoParte: 'R'
        }).then(response => {
          console.log('Partes cadastrada',this.state.selectedReu[i].nome);
        }).catch(error => {
          this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao cadastrar uma das partes do processo - Réu', life: 4000});
        })
      }
    }

    if(this.state.selectedAdvogado != null) {
      for(let i = 0; i < this.state.selectedAdvogado.length; i++) {
        await this.processoService.cadastrarPartes({
          processo: processo,
          pessoa: this.state.selectedAdvogado[i],
          tipoParte: 'D'
        }).then(response => {
          console.log('Partes cadastrada',this.state.selectedAdvogado[i].nome);
        }).catch(error => {
          this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao cadastrar uma das partes do processo - Réu', life: 4000});
        })
      }
    }

    //exlui o [indice e cadastra com o novo
    await this.excluirIndiceProcesso(processo.codigo);
    //diciona novo índice
    this.cadastrarIndiceProcesso(processo);
  }

  excluirIndiceProcesso = (processo) => {
    this.processoService.excluirIndiceProcesso(processo)
      .then(response => {
        console.log('Indice de processo excluído com sucesso');
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao excluir índice de processo', life: 4000});
      })
  }

  cadastrarIndiceProcesso = (processo) => {
    this.processoService.cadastrarIndiceProcesso({
      codigo: processo.codigo
    }).then(response => {
      console.log('Indice cadastrado')
    })
  }

  cadastrarObjetosProcesso = async () => {
    if(this.state.objetoAcao == null && this.state.selectSubObjetos == null) {
      this.toast.show({severity:'error', summary: 'Objetos de Ação', detail:'Nenhum objeto selecionado', life: 4000});
      return;
    }
  
    let objeto = null;
    if(this.state.objetoAcao != null) {
      objeto = {
        processo: {
          codigo: this.state.processo.codigo
        },
        objeto: this.state.objetoAcao
      }

      this.objetosProcesso.push(objeto);
    }

    if(this.state.selectSubObjetos != null) {
      for(let i = 0; i < this.state.selectSubObjetos.length; i++) {
        objeto = {
          processo: {
            codigo: this.state.processo.codigo
          },
          objeto: this.state.selectSubObjetos[i]
        }
        this.objetosProcesso.push(objeto);
      }
    }
    var cadastrou = false;
    this.setState({openSpinner: true});
    for(let i = 0; i < this.objetosProcesso.length; i++) {
      await this.objetoAcaoProcessoService.cadastrarObjetoAcaoProcesso({
        processo: {
          codigo: this.state.processo.codigo
        },
        objeto: this.objetosProcesso[i].objeto
      }).then(response => {
        console.log('Objeto Cadastrado')
        cadastrou = true;
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao cadastrar Objetos de Ação no Processo', life: 4000});
      })
    }
    this.fecharModal('modalObjetos');
    if(cadastrou) {
			this.objetosProcesso = [];
      this.toast.show({severity:'success', summary: 'Objeto de Ação', detail:'Objeto(s) cadastrado(s) com sucesso', life: 4000});
    }
    await this.listarObjetosAcao(this.state.processo.empresa);
    await this.consultarObjetosPorProcesso(this.state.processo.codigo);
    this.setState({objetoAcao: null});
    this.setState({openSpinner: false});
  }

  onCityChange(e) {
    let selectedCities = [...this.state.push];

    if (e.checked)
        selectedCities.push(e.value);
    else
        selectedCities.splice(selectedCities.indexOf(e.value), 1);

    this.setState({ push: selectedCities });
  }

  //Upload de Documentos
  handleUpload = async files => {
    
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }
    
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  updateFile = (id, data) => {
    this.setState({upLoadFiles: this.state.upLoadFiles.map(upLoadFile => {
      return id === upLoadFile.id ? { ...upLoadFile, ...data } : upLoadFile;
    })})
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('processo',upLoadFile.file, this.state.processo.codigo) //Envia código do processo para criar diretório
    data.append('usuario', upLoadFile.file, usuarioLogado.codigo);
    await this.arquivoProcessoService.incluirArquivo(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
        this.listarArquivosProcesso(this.state.processo.codigo);
      }).catch(error => {
				console.log('Erro ao processar arquivos ', error);
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarArquivosProcesso = (processo) => {
    var classific = 1;
    var ordem = 2;

    if(this.state.classificacaoDocumentos != null) {
      classific = this.state.classificacaoDocumentos.codigo;
    }
    
    if(this.state.ordenacaoDocumentos != null) {
      ordem = this.state.ordenacaoDocumentos.codigo;
    }

    this.arquivoProcessoService.listarArquivos(processo,classific,ordem)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  reordenarArquivos = async () => {
    if(this.state.classificacaoDocumentos == null) {
      this.toast.show({severity:'error', summary: 'Arquivos', detail:'Informe a classificação', life: 4000});
      return;
    }

    if(this.state.ordenacaoDocumentos == null) {
      this.toast.show({severity:'error', summary: 'Arquivos', detail:'Informe a ordenação', life: 4000});
      return;
    }

    this.setState({openSpinner: true});
    await this.arquivoProcessoService.listarArquivos(this.state.codigo,
      this.state.classificacaoDocumentos.codigo,this.state.ordenacaoDocumentos.codigo)
      .then(response => {
        this.setState({openSpinner: false});
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  consultarArquivo = async (arquivo) => {
    await this.arquivoProcessoService.consultarArquivo(arquivo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async consultarArquivoDescricao(arquivo) {
    await this.arquivoProcessoService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
  }

  adicionarDescricao = async () => {
    await this.arquivoProcessoService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      nome: this.state.arquivo.nome,
      dsArquivo: this.state.dsArquivo,
      dataArquivo: this.state.arquivo.dataArquivo,
      usuario: this.state.arquivo.usuario,
      processo: this.state.arquivo.processo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição de arquiivo alterada', life: 4000});
      this.listarArquivosProcesso(this.state.processo.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  async download (rowData){
    await this.arquivoProcessoService.download(this.state.codigo,rowData.nome)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', rowData.nome); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  baixarTodosArquivos = async () => {
    await this.arquivoProcessoService.baixarTodosArquivos(this.state.codigo)
      .then(response => {
        const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
        let filename = `arquivos_${this.state.codigo}.zip`;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*?=([^;]+)/i);
          if (match && match[1]) {
            filename = match[1].replace(/['"\u00A0]/g, '').trim();
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.error('Erro ao baixar todos os arquivos', error);
        this.toast && this.toast.show && this.toast.show({severity:'error', summary:'Arquivos', detail:'Falha ao baixar todos os arquivos', life: 4000});
      });
  }

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-images" className="p-button-rounded p-button-text"
                tooltip="Consultar Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.exibirArquivoProcesso(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  excluirArquivo = async () => {
    this.setState({classeDiv: 'show'});
    await this.arquivoProcessoService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosProcesso(this.state.processo.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
        this.setState({classeDiv: 'hide'});
      })

      this.setState({classeDiv: 'hide'});
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
          &nbsp;
          <Button label="Alterar" 
                  className="p-button-primary p-button-text"
                  onClick={this.adicionarDescricao}/>
        </div>
    );
  }

  renderFooterDescricaoArquivoNovaAtividade(name) {
    return (
        <div>
            <button type="button" 
                    className="btn btn-primary bg-gradient-secondary" 
                    onClick={() => this.fecharModalCadastro(name)}>
                <i className="fas fa-times"></i> Cancelar
            </button>
            <button type="button" className="btn btn-primary bg-gradient-success"
                    onClick={this.adicionarDescricaoNovaAtividade}>
                <i className="fas fa-check"></i> Alterar
            </button>
        </div>
    );
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  consultarProcessoImportancia = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const filtro = {
      usuario: usuarioLogado.codigo,
      processo: this.state.processo.codigo
    }

    await this.processoImportanciaService.consultarProcessoImportancia(filtro)
      .then(response => {
        if(response.data != '') {
          this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-danger'});
          this.setState({iconeImportanteParaMimTitle: 'Processo classificado como meus favoritos'});
          this.setState({exibirFavorito: 'hide'});
        } else {
          this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-secondary'});
          this.setState({iconeImportanteParaMimTitle: 'Clique para favoritar o processo'});
          this.setState({exibirFavorito: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processo Importancia', detail:`${this.state.detail}`, life: 4000});
      })
  }

  iincluirProcessoImportancia = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    const filtro = {
      usuario: usuarioLogado.codigo,
      processo: this.state.processo.codigo
    }
    this.setState({openSpinner: true});
    await this.processoImportanciaService.consultarProcessoImportancia(filtro)
      .then(response => {
        this.setState({processoImportancia: response.data});
        if(this.state.processoImportancia != '') {
          this.processoImportanciaService.excluirProcesso(response.data.codigo)
            .then(response => {
              this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-secondary'});
              this.setState({iconeImportanteParaMimTitle: 'Clique para favoritar o processo'});
            }).catch(error => {
              this.setState(error.response.data);
              this.toast.show({severity:'error', summary: 'Processo Importancia', detail:`${this.state.detail}`, life: 4000});
            })
        } else {
          this.processoImportanciaService.incluirProcesso({
            usuario: usuarioLogado,
            processo: this.state.processo
          }).then(response => {
            this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-danger'});
            this.setState({iconeImportanteParaMimTitle: 'Processo classificado como meus favoritos'});
          }).catch(error => {
            this.setState(error.response.data);
            this.toast.show({severity:'error', summary: 'Processo Importancia', detail:`${this.state.detail}`, life: 4000});
          })
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processo Importancia', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  incluirProcessoImportanteParaEmpresa = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.codigo != 142) { // Unimed Fama
      if(usuarioLogado.perfil.codigo != 1) {
        this.toast.show({severity:'error', summary: 'Processo Importancia', detail:'O usuário não tem permissão para executar esta ação', life: 4000});
        return false;
      }
    }

    let importancia = '';
    if(this.state.processo.snImportante == 'S') {
      importancia = 'N';
    } else {
      importancia = 'S';
    }

    this.setState({openSpinner: true});
    await this.processoService.alterarImportanciaEmpresa({
      codigo: this.state.processo.codigo,
      snImportante: importancia
    }).then(response => {
      if(importancia == 'S') {
        this.setState({iconeImportanteParaEmpresa: 'p-button-rounded p-button-warning'});
        this.setState({iconeImportanteParaEmpresaTitle: 'Processo importante para empresa'});
      } else {
        this.setState({iconeImportanteParaEmpresa: 'p-button-rounded p-button-secondary'});
        this.setState({iconeImportanteParaEmpresaTitle: 'Clique para incluir o processo como importante'});
      }
      this.consultarProcesso(this.state.processo.codigo);
    });
    this.setState({openSpinner: false});
  }

  incluirProcessoEstrategico = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.codigo != 142) {
      if(usuarioLogado.perfil.codigo != 1) {
        this.toast.show({severity:'error', summary: 'Processo Importancia', detail:'O usuário não tem permissão para executar esta ação', life: 4000});
        return false;
      }
    }

    let estrategico = '';
    if(this.state.processo.estrategico == 'S') {
      estrategico = 'N';
    } else {
      estrategico = 'S';
    }

    this.setState({openSpinner: true});
    await this.processoService.alterarEstrategicoEmpresa({
      codigo: this.state.processo.codigo,
      estrategico: estrategico
    }).then(response => {
      if(estrategico == 'S') {
        this.setState({iconeEstrategico: 'p-button-rounded p-button-warning'});
        this.setState({iconeEstrátegicoTitle: 'Processo Estratégico'});
      } else {
        this.setState({iconeEstrategico: 'p-button-rounded p-button-secondary'});
        this.setState({iconeEstrátegicoTitle: 'Clique para tornar o processo estratégico'});
      }
      this.consultarProcesso(this.state.processo.codigo);
    });
    this.setState({openSpinner: false});
  }

  consultarAtividades = async (processo) => {
    await this.atividadeService.consultarAtividadePorProcesso(this.state.processo.codigo)
      .then(response => {
        this.setState({atividades: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  onSubGrupoTrocaGrupoChange = (e) => {
    this.setState({subGrupoParaTrocaGrupo: e.value});
  }

  confirmarTrocaSubGrupoAtividades = () => {
    if(this.state.subGrupoParaTrocaGrupo == null) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Selecione o novo Sub-Grupo de Trabalho das atividades', life: 4000});
      return;
    }
    this.setState({modalTrocaGrupoVisible: false});
    this.alterarProcesso();
  }

  cancelarTrocaSubGrupoAtividades = () => {
    this.setState({
      modalTrocaGrupoVisible: false,
      subGrupoParaTrocaGrupo: null,
      subGruposTrocaGrupo: [],
      atividadesParaTrocaGrupo: []
    });
  }

  templateHistoricoAtividade(data) {
    if(data.dataAlteracao != null) {
      return (
        <div className="col-12">
          <div className="balao" style={{borderRadius: '6px'}}>
            <Editor value={data.dsHistorico} 
                    headerTemplate={
                      <div>
                          <strong style={{textAlign: 'left', color: 'blue'}}
                                  className="grupoTrabalho">
                            {data.usuario.nome} - {data.dtHistorico}
                          </strong>
                          &nbsp;&nbsp;&nbsp;
                          <a onClick={() => this.consultarHistoricoAtividade(data)} style={{cursor: 'pointer'}}>
                            <i className="pi pi-pencil" 
                            title="Alterar Histórico"/>
                          </a>
                          &nbsp;&nbsp;
                          <a onClick={() => this.confirmaExclusaoHistorico(data)} style={{cursor: 'pointer'}}>
                            <i className="pi pi-times-circle" 
                            title="Excluir histórico. Apenas o usuário que o escreveu pode executar esta ação"/>
                          </a>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <strong>Editado em &nbsp;{data.dataAlteracao}</strong>
                      </div>
                    }
                    readOnly
                    style={{ height: '120px' }} />
          </div>
          <br/>
        </div>
      );
    } else {
      return (
        <div className="col-12">
          <div className="balao" style={{borderRadius: '6px'}}>
            <Editor value={data.dsHistorico} 
                    headerTemplate={
                      <div>
                          <strong style={{textAlign: 'left', color: 'blue'}}
                                  className="grupoTrabalho">
                            {data.usuario.nome} - {data.dtHistorico}
                          </strong>
                          &nbsp;&nbsp;&nbsp;
                          <a onClick={() => this.consultarHistoricoAtividade(data)} style={{cursor: 'pointer'}}>
                            <i className="pi pi-pencil" 
                            title="Alterar Histórico"/>
                          </a>
                          &nbsp;&nbsp;
                          <a onClick={() => this.confirmaExclusaoHistorico(data)} style={{cursor: 'pointer'}}>
                            <i className="pi pi-times-circle" 
                            title="Excluir histórico. Apenas o usuário que o escreveu pode executar esta ação"/>
                          </a>
                      </div>
                    }
                    readOnly
                    style={{ height: '120px' }} />
          </div>
          <br/>
        </div>
      );
    }
  }

  novaAtividadeHeader() {
    return (
      <React.Fragment>
        <div>
          <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                  tooltip="Criar Atividade Atônoma"
                  onClick={this.abrirCriacaoAtividade}
                  tooltipOptions={{position: 'top'}} />
				</div>
      </React.Fragment>
    )
  }

  acoesAtividade(data) {
    return(
      <React.Fragment>
        <div>
          <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                  tooltip="Consultar Atividade"
                  onClick={() => this.consultarAtividadeCustom(data)}
                  tooltipOptions={{position: 'top'}} />
        </div>
      </React.Fragment>
    )
  }

  prazoFatalFormat(data) {
    if(data.dtFatal != null) {
      return(
        <React.Fragment>
          <div>
            <Tag severity="danger" value={data.dtFatal}></Tag>
          </div>
        </React.Fragment>
      )
    }
  }

	exibirPublicacao(data) {
    if(data.publicacao != null && data.publicacao.codigo != 0) {
      return(
        <React.Fragment>
          <div>
            <a title="Abrir publicação" style={{color: '#1b4fd1', cursor: 'pointer'}} onClick={() => this.consultarPublicacao(data.publicacao.codigo)}>
              <Tag className="p-mr-2" severity="info" value={data.publicacao.codigo}></Tag>
            </a>
          </div>
        </React.Fragment>
      )
    }
  }

  statusTemplate(data) {
    return(
      <React.Fragment>
        <Tag className="p-mr-2" style={{backgroundColor: `${data.status?.cor}`}} value={data.status?.status}></Tag>
      </React.Fragment>
    )
  }

  grauTemplate(data) {
    if(data.importante == 'S' && data.urgente == 'S') {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: 'red', width: '50px'}} value="Urgente"></Tag>
          &nbsp;
          <Tag style={{backgroundColor: 'green', width: '65px'}} value="Importante"></Tag>
        </React.Fragment>
      );
    } else if(data.importante == 'S' && data.urgente == 'N') {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: 'green', width: '65px'}} value="Importante"></Tag>
        </React.Fragment>
      );
    } else if(data.importante == 'N' && data.urgente == 'S') {
      return(
        <React.Fragment>
          <Tag style={{backgroundColor: 'red', width: '65px'}} value="Urgente"></Tag>
        </React.Fragment>
      );
    }
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirOpcaoCriarAtividade = (event) => {
    this.opCriarAtividade.toggle(event);
  }

  abrirCriacaoAtividade = async () => {
    if(this.opCriarAtividade) {
      this.opCriarAtividade.hide();
    }

    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }

    this.setState({openSpinner: true});

    let subGrupos = [];
    let responsaveis = [];
    let titulos = [];

    await this.grupoTrabalhoService.listarSubGrupos(this.state.grupoTrabalho.grupoPai)
      .then(r => { subGrupos = r.data; }).catch(() => {});

    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.processo.grupoTrabalho.codigo)
      .then(r => { responsaveis = r.data; }).catch(() => {});

    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(r => { titulos = r.data; }).catch(() => {});

    const processoParaInclusao = {
      codigo: this.state.processo.codigo,
      nrCnj: this.state.nrCnj,
      nrProcesso: this.state.nrProcesso,
      partes: this.state.partesProcesso || [],
      grupoTrabalho: this.state.grupoTrabalho,
      subGruposAtividades: subGrupos,
      usuariosAtividades: responsaveis,
      titulos: titulos
    };

    this.setState({processoParaInclusao, modalInclusaoComponente: true, openSpinner: false});
  }

  abrirRodizioAtividade = () => {
    this.opCriarAtividade.hide();

    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }

    this.setState({displayRodizioAtividade: true});
  }

  fecharRodizioAtividade = async () => {
    this.setState({displayRodizioAtividade: false});
    await this.consultarAtividades(this.state.processo);
  }

  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarAtividade}/>
            &nbsp;
            <Button label="Anexos" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalArquivosAnexos('displayArquivosAnexadosAtividade')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Novo Histórico"
                    icon="pi pi-history"
                    className="p-button-help p-button-text"
                    onClick={this.novoHistorico}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  async onChangeFasesPorTitulo(e) {
    this.setState({openSpinner: true});
    if(e.value != null) {
      this.setState({tituloAtividade: e.value});
      await this.listarFasesTarefasPorTitulo(e.value);
    } else {
      this.setState({tituloAtividade: null});
    };
    this.setState({openSpinner: false});
  }

  listarTitulosPorFase = async (fase) => {
    await this.tituloAtividadeFaseService.consularTituloPorFase(fase.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos das fases de atividade', life: 4000});
      })
  }

  async onChangeTitulosPorFase(e) {
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    if(e.value != null) {
      this.setState({fase: e.value});
      await this.listarTitulosPorFase(e.value);
    } else {
      this.setState({fase: null});
      this.setState({titulos: null});
    }
    this.setState({separador: 'none'});
    this.setState({classeDiv: 'hide'})
  }

  abrirModalAtividade(name, position) {

    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }

    const usuarioLogado = this.context.usuarioAutenticado;
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({openSpinner: true});
    this.excluirArquivosTemp();
    this.setState(state);
    this.consultarSubGrupos(this.state.grupoTrabalho.grupoPai);
    this.setState({grupoTrabalhoNome: this.state.grupoTrabalho.nome});
    if(this.state.nrCnj == null) {
      this.setState({pesquisaProcesso: this.state.nrProcesso});
    } else {
      this.setState({pesquisaProcesso: this.state.nrCnj});
    }
    this.listarResponsaveisAtivos();
    this.listarInteressadosAtivos();
    this.limparCamposAtividade();
    this.listarTitulosAtividade();
    this.setState({openSpinner: false});
  }

  limparCamposAtividade = () => {
    this.setState({tituloAtividade: null});
    this.setState({titulo: ''});
    this.setState({hora: ''});
    this.setState({descricao: ''});
    this.setState({dtLimite: ''});
    this.setState({hora: ''});
    this.setState({dtFatal: ''});
    this.setState({tipo: ''});
    this.setState({status: ''});
    this.setState({responsavel: null});
    this.setState({interessado: null});
    this.setState({responsaveis: []});
    this.setState({selectSubGrupo: null});
    this.setState({recorrencia: null});
    this.setState({repeticao: null});
    this.setState({grau: []});
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  onGrauChange(e) {
    let selectedGrau = [...this.state.grau];

    if (e.checked)
      selectedGrau.push(e.value);
    else
      selectedGrau.splice(selectedGrau.indexOf(e.value), 1);

    this.setState({ grau: selectedGrau });
  }

  cadastrarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      if(this.state.tituloAtividade == null) {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }  
    } else {
      if(this.state.titulo == '') {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.recorrencia != null) {
      if(this.state.recorrencia.codigo == 'R' && this.state.repeticao == null) {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Você selecionou recorrência e não definiu a repetição', life: 4000});
        return false;
      }
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

     //Data Limite
     var tipoTarefa = '';
     var dataFormatadaDataLimite = '';
     if(this.state.dtLimite != '' && this.state.dtLimite != null) {
       var date = this.state.dtLimite;
       var month = this.pad2(date.getMonth()+1);//months (0-11)
       var day = this.pad2(date.getDate());//day (1-31)
       var year= date.getFullYear();
       if(this.state.hora != '') {
         dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
         tipoTarefa = 'A'
       } else {
          dataFormatadaDataLimite =  year+"-"+month+"-"+day;
          tipoTarefa = 'T';
       }
     }

     var dataFormatadaDataFatal = '';
     if(this.state.dtFatal != '' && this.state.dtFatal != null) {
       var date = this.state.dtFatal;
       var month = this.pad2(date.getMonth()+1);//months (0-11)
       var day = this.pad2(date.getDate());//day (1-31)
       var year= date.getFullYear();
       if(this.state.hora != '') {
          dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        } else {
          dataFormatadaDataFatal =  year+"-"+month+"-"+day;
        }
    }

    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    };

    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    }

    var titulo = '';
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      titulo = this.state.tituloAtividade.titulo;
    } else {
      titulo = this.state.titulo;
    }

    var recorrencia = null;;
    if(this.state.recorrencia == null) {
      recorrencia = '0';
    } else {
      recorrencia = this.state.recorrencia.codigo;
    }

    var processo = null;
    if(this.state.processo != null) {
      processo = {
        codigo: this.state.processo.codigo
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';

    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    const atividadeCadastro = {
      atividade: {
        titulo: titulo,
        processo: processo,
        subGrupo: this.state.selectSubGrupo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        status: {
          codigo: 1 // Ativo
        },
        importante: importante,
        urgente: urgente,
        privado: privado,
        tituloAtividade: this.state.tituloAtividade,
        lancamentoFinanceiro: null,
				publicacao: null,
      },
      recorrencia: recorrencia,
      responsaveis: responsaveis,
      interessados: interessados,
      empresaId: usuarioLogado.empresa.codigo
    }

    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    await this.atividadeService.cadastrarAtividade(atividadeCadastro)
      .then(response => {
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
        this.consultarAtividades(this.state.processo);
        this.setState({classeDiv: 'hide'});
        this.setState({separador: 'none'});
      }).catch(error => {
        this.setState({classeDiv: 'hide'});
        this.setState({separador: 'none'});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Check Lista', detail:`${this.state.detail}`, life: 4000});
      });
  }

  abrirModalAnexo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  onChangeStatusAtividade(e) {
    this.setState({optionStatus: e.value})
  }

  consultarSubGrupos = async(codigo) => {
    await this.grupoTrabalhoService.listarSubGrupos(codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  listarResponsaveis = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.processo.grupoTrabalho.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.processo.grupoTrabalho.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  listarResponsaveisAtivos = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.processo.grupoTrabalho.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressadosAtivos = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.grupoTrabalho.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  listarExecucaoCheckList = async (atividade) => {
    this.itensCheckList = [];
    this.setState({activeIndex: -1})
    await this.execucaoCheckListService.consultarCheckList(atividade)
      .then(response => {
        this.setState({checkList: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Check Lista', detail:`${this.state.detail}`, life: 4000});
      });

      for(let i = 0; i < this.state.checkList.length; i++) {
        if(this.state.checkList[i].status == 'F') {
          this.setState({activeIndex: this.state.checkList[i].checkList.ordem -1});
          break;
        } 
      }

      let item = null;
      for(let i = 0; i < this.state.checkList.length; i++) {
        item = {
          codigo: this.state.checkList[i].codigo,
          checklist: this.state.checkList[i].checkList.codigo,
          status:  this.state.checkList[i].status,
          label: this.state.checkList[i].checkList.tarefa
        }
        this.itensCheckList.push(item);
      }
      this.abrirCriacaoAtividade();
  }

  async consultarAtividadeCustom(atividade) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.consultarAtividadeCustom(atividade.codigo,usuarioLogado.empresa.codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({atividade: response.data});
				this.setState({isPublicacao: response.data.codigoPublicacao == null ? false : true});
        this.setState({codigoAtividade: response.data.codigo});
        this.setState({codigoProcesso: response.data.codigoProcesso});
        this.setState({titulo: response.data.titulo});
        this.setState({pontuacao: response.data.pontos + " pontos"});
        this.setState({usuarioCriouAtividade: response.data.usuarioCriou});
        this.setState({dataRegistroAtividade: response.data.dataCriacao});
        this.setState({descricao: response.data.descricao});
        this.setState({grupoTrabalhoDescricao: response.data.grupo});
        this.setState({subGrupoTrabalhoDescricao: response.data.subGrupo});
        this.setState({codigoSubGrupo: response.data.codigoSubGrupo});
        this.setState({codigoGrupo: response.data.codigoGrupo});
        this.setState({tipo: response.data.tipo});
        if(response.data.processo != null) {
          this.setState({codigoProcesso: response.data.codigoProcesso});
          this.setState({partes: response.data.partes});
          this.setState({pesquisaProcesso: response.data.processo});
        }

        if(response.data.tipo == 'A') {
          this.setState({horaAntiga: response.data.hora})
          this.setState({hora: response.data.hora});
        }

        this.setState({dataLimiteAntiga: response.data.dataLimite});
        var dataLimite = new Date(response.data.dataLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        if(response.data.prazoFatal != null) {
          var dataFatal = new Date(response.data.prazoFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }

        this.setState({statusCodigo: response.data.statusCodigo});
        this.setState({optionStatus: response.data.statusEntty});
        this.setState({statusAtividade: response.data.status});

        let grau = [];
        if(response.data.importante == 'S') {
          grau.push('importante');
        }

        if(response.data.urgente == 'S') {
          grau.push('urgente');
        }

        if(response.data.privado == 'S') {
          grau.push('privado');
        }
        this.setState({grau: grau});
        //Responsáveis
        this.setState({responsaveisLista: response.data.responsaveisAtividade});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.setState({responsaveis: response.data.usuariosGrupo});
        //Interessados
        this.setState({interessadosLista: response.data.interessadosAtividade});
        if(response.data.interessadosAtividade != null) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.setState({interessados: response.data.usuariosGrupo});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      //Abre Modal de atividade
      this.setState({modalAtividadeComponente: true});
      this.setState({openSpinner: false});
  }

  async consultarAtividade(atividade) {
    
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }

    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.consultarAtividade(atividade.codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigoAtividade: response.data.codigo});
        this.setState({titulo: response.data.titulo});
        this.setState({pontuacao: response.data.pontuacao + " pontos"});
        this.setState({descricao: response.data.descricao});
        this.setState({usuarioCriouAtividade: response.data.usuario.nome});
        this.setState({dataRegistroAtividade: response.data.dtRegistro});
        this.consultarGrupoTrabalhoPai(response.data.subGrupo.grupoPai);
        this.consultarSubGrupos(response.data.subGrupo.grupoPai);
        this.setState({tipo: response.data.tipo});
        //this.consultarGruposTrabalho();
        this.setState({selectSubGrupo: response.data.subGrupo});
        this.setState({grupoTrabalhoNome: response.data.processo.grupoTrabalho.nome});
        
        //this.setState({processo: response.data.processo});
        if(response.data.processo.nrCnj != '' && response.data.processo.nrCnj != null) {
          console.log('Atividade ', response.data);
          this.setState({pesquisaProcesso: response.data.processo.nrCnj});
        } else {
          this.setState({pesquisaProcesso: response.data.processo.nrProcesso});
        }
        this.setState({partes: response.data.processo.autor});
        if(response.data.processo.snImportante != 'N' && response.data.processo.snImportante != null) {
          this.setState({importante: 'p-button-rounded p-button-warning'});
          this.setState({titleImportante: 'Processo classificado como importante para empresa'});
          this.setState({exibirImportanteEmpresa: 'hide'});
        } else {
          this.setState({exibirImportanteEmpresa: 'none'});
        }
    
        var dataLimite = new Date(response.data.dtLimite);
        dataLimite.setDate(dataLimite.getDate() + 1);
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        this.setState({hora: response.data.hora});
        if(response.data.dtFatal != null) {
          var dataFatal = new Date(response.data.dtFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }
        this.listarStatusAtividade();
        this.setState({optionStatus: response.data.status});

        let grau = [];
        if(response.data.importante == 'S') {
          grau.push('importante');
        }

        if(response.data.urgente == 'S') {
          grau.push('urgente');
        }

        if(response.data.privado == 'S') {
          grau.push('privado');
        }

        this.setState({grau: grau});
  
        this.listarArquivosAtividade();
      }
    ).catch(error => {
        console.log('Erro Fernando ', error);
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
    await this.consultarProcessoImportancia();
    await this.consultarResponsaveis();
    await this.consultarInteressados();
    this.setState({modalAtividadeComponente: true});
    this.setState({openSpinner: false});
  }

  consultarTituloAtividadePorNome = async (nome) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.consultarPorNome(nome, usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tituloAtividade: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Título da Atividade pelo nome', life: 4000});
      })
  }

  abrirModalAtividadeAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  listarArquivosAtividade = async () => {
    await this.arquivoAtividadeService.listarArquivos(this.state.atividade.codigo)
      .then(response => {
        this.setState({arquivosAtividades: response.data});
        if(response.data.length > 0) {
          this.setState({exibirLinkAnexo: 'block'});
        } else {
          this.setState({exibirLinkAnexo: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarResponsaveis = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.atividade.codigo, 'R')
      .then(response => {
        this.setState({responsaveisLista: response.data});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.listarResponsaveis(); 
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarInteressados = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.atividade.codigo, 'I')
      .then(response => {
        this.setState({interessadosLista: response.data});
        if(this.state.interessadosLista.length == 0) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.listarInteressados();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarHistorico = async (codigo) => {
    //this.setState({openSpinner: true});
    await this.atividadeService.consultarHistorico(codigo)
      .then(response => {
        this.setState({historico: response.data});
        //this.abrirModalHistorico('displayHistorico');
        //this.setState({openSpinner: false});
      }).catch(error => {
        //this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesHistoricoUsuario(rowData) {
      if(rowData.tpHistorico == 'A') {
        return (
          <React.Fragment>
            <i className="fa fa-solid fa-robot" title="Incluído de forma automática"/>
          </React.Fragment>
        )
      } else {
        return (
          <React.Fragment>
            <i className="pi pi-user-plus" title="Incluído manualmente"/>
          </React.Fragment>
        )
      }
  }

  acoesHistoricoAtividade(rowData) {
    if(rowData.tpHistorico != 'A') {
      return (
        <React.Fragment>
           <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                   tooltip="Excluir Histórico"
                   onClick={() => this.confirmaExclusaoHistoricoAtividade(rowData)}
                   tooltipOptions={{position: 'top'}}
                   style={{width: '20px', height: '10px'}}/>
        </React.Fragment>
      )
    } 
}

  consultarGrupoTrabalhoPai = async (codigo) => {
    await this.grupoTrabalhoService.consultarGrupo(codigo)
      .then(response => {
        this.setState({selectGrupo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Grupo de Trabalho', life: 4000});
      })
  }

  abrirModalDescricao(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModalHistorico(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  novoHistorico = () => {
    this.setState({dsHistorico: ''});
    this.abrirModalHistorico('displayHistoricoIncluir');
  }

  async incluirHistoricoAtividade () {
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    let tipoHistorico = 'M';
    this.setState({openSpinner: true});
    await this.atividadeService.incluirHistorico({
      atividade: {
        codigo: this.state.codigoAtividade
      },
      dsHistorico: this.state.dsHistorico,
      usuario: usuarioLogado,
      tpHistorico: tipoHistorico
    }).then(response => {
      this.listarHistorico();
      this.fecharModalAtividade('displayHistoricoIncluir');
      this.toast.show({severity:'success', summary: 'Histórico de Atividades', detail:'Histórico incluído com sucesso', life: 4000});
      this.setState({openSpinner: false});
    }).catch(error => {
      this.setState({openSpinner: false});
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Histórico de Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  listarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.codigoAtividade)
      .then(response => {
        this.setState({historico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  confirmaExclusaoHistoricoAtividade(historico) {
    this.setState({registroHistorico: historico});
    confirmDialog({
        message: 'Deseja realmente excluir o Histórico da Atividade?',
        header: 'Exclusão de Histórico de Atividades',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirHistoricoAtividade,
        reject: this.reject
    });
  }

  acceptExcluirHistoricoAtividade() {
    this.excluirHistoricoAtividade();
  }

  excluirHistoricoAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.excluirHistorico(this.state.registroHistorico.codigo, this.state.registroHistorico.usuario.codigo, usuarioLogado.codigo)
      .then(response => {
        this.listarHistorico();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico excluído', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  //Tudo referente a upload de documentos da atividade
  acoesArquivosAtividade(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-images" className="p-button-rounded p-button-text"
                tooltip="Consultar Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.exibirArquivo(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoAtividadeDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.downloadArquivoAtividade(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivoAtividade(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async downloadArquivoAtividade(rowData) {
    await this.consultarArquivoAtividade(rowData);
    await this.arquivoAtividadeService.download(this.state.codigoAtividade,rowData.arquivo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  consultarArquivoAtividade = async (arquivo) => {
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async consultarArquivoAtividadeDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivoAtividade');
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivoAtividade = () => {
    this.arquivoAtividadeService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosAtividade();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivoAtividade(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivoAtividade,
        reject: this.reject
    });
  }

  acceptExcluirArquivoAtividade() {
    this.excluirArquivoAtividade();
  }

  renderFooterDescricaoArquivoAtividade(name) {
    return (
        <div>
            <button type="button" 
                    className="btn btn-primary bg-gradient-secondary" 
                    onClick={() => this.fecharModalCadastro(name)}>
                <i className="fas fa-times"></i> Cancelar
            </button>
            <button type="button" className="btn btn-primary bg-gradient-success"
                    onClick={this.adicionarDescricaoAtividade}>
                <i className="fas fa-check"></i> Alterar
            </button>
        </div>
    );
  }

  adicionarDescricaoAtividade = () => {
    this.arquivoAtividadeService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      dsArquivo: this.state.dsArquivo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.fecharModalCadastro('modalDescricaoArquivoAtividade');
      this.listarArquivosAtividade();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });
  }

  adicionarDescricaoNovaAtividade = () => {
    this.arquivoAtividadeService.adicionarDescricaoTemp({
      codigo: this.state.arquivo.codigo,
      descricao: this.state.descricao
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosTemp();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivoNovaAtividade');
  }

  handleUploadAtividade = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processarAtividade);
  }

  processarAtividade = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('atividade',upLoadFile.file, this.state.atividade.codigo); //Envia código de atividade para salvar os arquivos
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo); //Envia código de atividade para salvar os arquivos
    await this.arquivoAtividadeService.incluirArquivo(data)
      .then(response => {
        this.listarArquivosAtividade();
        this.handleDeleteAtividade(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDeleteAtividade  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  async abrirModalArquivosAnexos(name, position){
    await this.listarArquivosAtividade()
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  //Nova Atividade
  handleUploadNovaAtividade = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processarNovaAtividade);
  }

  processarNovaAtividade = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de usuário para guardar arquivos
    await this.arquivoAtividadeService.incluirArquivoTemp(data)
      .then(response => {
        this.listarArquivosTemp();
        this.handleDeleteNovaAtividade(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarArquivosTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.arquivoAtividadeService.listarArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        this.setState({arquivosNovaAtividade: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDeleteNovaAtividade  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  acoesArquivosNovaAtividade(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-images" className="p-button-rounded p-button-text"
                tooltip="Consultar Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.exibirArquivoTemp(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoNovaAtividadeDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.downloadTemp(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivoNovaAtividade(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async downloadTemp(rowData) {
    await this.consultarArquivoTemp(rowData);
    await this.arquivoAtividadeService.downloadTemp(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  consultarArquivoTemp = async (arquivo) => {
    await this.arquivoAtividadeService.consultarArquivoTemp(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async consultarArquivoNovaAtividadeDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivoTemp(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivoNovaAtividade');
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivosTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoAtividadeService.excluirArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        console.log('Arquivos Temporários excluídos');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  excluirArquivoNovaAtividade = () => {
    this.arquivoAtividadeService.excluirArquivoTemp(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivoNovaAtividade(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivoNovaAtividade,
        reject: this.reject
    });
  }

  acceptExcluirArquivoNovaAtividade() {
    this.excluirArquivoNovaAtividade();
  }

  renderFooterAtividadeNovaAtividade(name) {
    return (
        <div className="left">
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarAtividade}/>
            &nbsp;
            <Button label="Anexar" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalAnexo('displayAnexoNovaAtividade')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  //Alterar Atividade
  alterarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.titulo == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }

    if(this.state.responsaveisLista == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' && this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    let tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '' && this.state.hora != null && this.state.hora != "00:00") {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
        tipoTarefa = 'A';
      } else {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
        tipoTarefa = this.state.tipo;
      }
    }

    var dataFormatadaDataFatal = null;
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != null && this.state.hora != '') {
        var dataFormatadaDataFatal =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
      } else {
        var dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';
    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    const atividadeAlterar = {
      atividade: {
        codigo: this.state.atividade.codigo,
        titulo: this.state.titulo,
        tipo: tipoTarefa,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        processo: {
          codigo: this.state.processo.codigo
        },
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        status: this.state.optionStatus,
        subGrupo: {
          codigo: this.state.codigoSubGrupo,
          grupoPai: this.state.codigoGrupo
        },
        importante: importante,
        urgente: urgente,
        privado: privado,
				publicacao: null,
      },
      responsaveis: this.state.responsaveisLista,
      interessados: this.state.interessadosLista
    }

    var hora = "00:00";
    if(this.state.horaAntiga != null && this.state.horaAntiga != "") {
      hora = this.state.horaAntiga;
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarAtividade(this.state.dataLimiteAntiga + " " + hora + ":00",
    this.state.statusCodigo, usuarioLogado.codigo,atividadeAlterar)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
        this.fecharModalAtividade('displayAtividadeAlterar');
        this.consultarAtividades(this.state.processo);
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner: false});
      });
  }

  refreshPage = () => {
    window.location.reload();
  }

  async abrirModalObjetos(name, position) {
    if(this.state.processo.status == 3) {
      this.toast.show({severity:'error', summary: 'Processos', detail:'Esta ação não é permitida enquanto o processo estiver na lixeira', life: 8000});
      return;
    }
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    this.listarObjetosAcao(usuarioLogado.empresa);
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({subObjetosAcao: null});
    this.setState({selectSubObjetos: null});
		this.setState({objetoAcao: null});
    this.setState({openSpinner: false});
    this.setState(state);
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let horizontalOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let multiAxisOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            },
            tooltips: {
                mode: 'index',
                intersect: true
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                    color: '#ebedef'
                },
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                }
            }
        }
    };

    return {
        basicOptions,
        horizontalOptions,
        stackedOptions,
        multiAxisOptions
    }
  }

  listarBancadas = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.pessoaService.listarBancadas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({bancadas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarExecucao = async (codigo) => {
    await this.execucaoCheckListService.consultar(codigo)
      .then(response => {
        this.setState({execucaoCheckList: response.data});
        if(response.data.status != 'A') {
          this.setState({usuarioCheckList: response.data.usuario.nome});
          this.setState({dataExecucaoCheckList: response.data.dataExecucao});
          if(response.data.status == 'F') {
            this.setState({statusExecucao: 'Fazendo'});
          } else {
            this.setState({statusExecucao: 'Consluído'});
          }
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Execução Check List', detail:`${this.state.detail}`, life: 4000});
      })
  }


  async marcarCheckList(e){
    await this.consultarExecucao(e.item.codigo);
    if(this.state.execucaoCheckList.status != 'A') {
      this.abrirModal('modalCheckList');
      return;
    }
  
    const usuarioLogado = this.context.usuarioAutenticado
    const exec = {
      codigo: e.item.codigo,
      atividade: this.state.atividade,
      checkList: {
        codigo: e.item.checklist
      },
      usuario: usuarioLogado,
      status: 'F'
    };

    this.setState({openSpinner: true});
    await this.execucaoCheckListService.selecionarCheckList(exec)
      .then(response => {
        this.setState({activeIndex: e.index});
        this.listarExecucaoCheckList(this.state.atividade.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Check Lista', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  templateCriacaoAtividade = () => {
    return(
      <div>Atividade criada por:&nbsp;&nbsp;<strong style={{color: '#ccc'}}>{this.state.usuarioCriouAtividade}&nbsp; em:&nbsp;{this.state.dataRegistroAtividade}</strong></div>
    );
  }

  novoTituloAtividade = async () => {
    this.setState({novoTitulo: ''});
    this.setState({pontuacao: ''});
    this.setState({openSpinner: true});
    this.setState({openSpinner: false});
    this.abrirModal('modalNovoTitulo');
  }

  cadastrarNovoTitulo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.novoTitulo == '') {
      this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'Informe o título da atividade', life: 5000});
      return;
    }

    if(this.state.pontuacao == '') {
      this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'Informe a pontuação do título', life: 5000});
      return;
    }

    const titulo = {
      titulo: this.state.novoTitulo,
      pontos: this.state.pontuacao,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    await this.tituloAtividadeService.cadastrar(titulo)
      .then(response => {
        this.listarTitulos();
        this.fecharModal('modalNovoTitulo');
        this.toast.show({severity:'success', summary: 'Títulos de Atividades', detail:'Novo títilo cadatrado com sucesso!', life: 5000});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${error}`, life: 5000});
      })
  }

  async exibirArquivoProcessoOld(arquivo){
    this.setState({openSpinner: true});
    await this.arquivoProcessoService.exibirArquivo(arquivo.nome,this.state.codigo)
      .then(response => {
        const url = URL.createObjectURL(response.data); // Cria uma URL local para o arquivo
        this.setState({fileData: url});
        this.setState({fileName: arquivo.nome});
        this.abrirModal('modalExibirArquivo');
      }).catch(error => {
        this.setState({openSpinner: false});
        console.log("Erro ao buscar o arquivo", error);
      });
      this.setState({openSpinner: false});
  }

  async exibirArquivoProcesso(arquivo) {
    this.setState({ openSpinner: true });

    try {
      const response = await this.arquivoProcessoService.exibirArquivo(
        arquivo.nome,
        this.state.codigo
      );

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      const url = URL.createObjectURL(blob);

      this.setState({
        fileData: url,
        fileName: arquivo.nome,
        modalExibirArquivoProcesso: true
      });

    } catch (error) {
      console.error("Erro ao buscar o arquivo", error);
    } finally {
      this.setState({ openSpinner: false });
    }
  }

  async exibirArquivoOld(arquivo){
    this.setState({openSpinner: true});
    await this.arquivoAtividadeService.exibirArquivo(arquivo.arquivo,this.state.codigoAtividade)
      .then(response => {
        const url = URL.createObjectURL(response.data); // Cria uma URL local para o arquivo
        this.setState({fileData: url});
        this.setState({fileName: arquivo.arquivo});
        this.abrirModal('modalExibirArquivo');
      }).catch(error => {
        this.setState({openSpinner: false});
        console.log("Erro ao buscar o arquivo", error);
      });
      this.setState({openSpinner: false});
  }

  async exibirArquivo(arquivo) {
    this.setState({ openSpinner: true });

    try {
      const response = await this.arquivoAtividadeService.exibirArquivo(
        arquivo.arquivo,
        this.state.codigoAtividade
      );

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      const url = URL.createObjectURL(blob);

      this.setState({
        fileData: url,
        fileName: arquivo.arquivo,
        modalExibirArquivo: true
      });

    } catch (error) {
      console.error("Erro ao buscar o arquivo", error);
    } finally {
      this.setState({ openSpinner: false });
    }
  }

  async exibirArquivoTemp(arquivo){
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.arquivoAtividadeService.exibirArquivoTemp(arquivo.arquivo,usuarioLogado.codigo)
      .then(response => {
        const url = URL.createObjectURL(response.data); // Cria uma URL local para o arquivo
        this.setState({fileData: url});
        this.setState({fileName: arquivo.arquivo});
        this.abrirModal('modalExibirArquivo');
      }).catch(error => {
        this.setState({openSpinner: false});
        console.log("Erro ao buscar o arquivo", error);
      });
      this.setState({openSpinner: false});
  }

  copiarTexto = (texto) => {
    if (!texto) return;

    navigator.clipboard.writeText(texto).then(() => {
      this.setState({ copiado: true });

      setTimeout(() => {
        this.setState({ copiado: false });
      }, 1500);
    });
  }

  copiarTextoPorIdCnj = (id) => {
    const input = document.getElementById(id);
    if (!input) return;

    input.select();
    input.setSelectionRange(0, 99999); // mobile

    try {
      if (navigator.clipboard && window.isSecureContext) {
        // Ambiente seguro (https / localhost)
        navigator.clipboard.writeText(input.value);
      } else {
        // Fallback para HTTP / intranet
        document.execCommand("copy");
      }

      this.setState({ copiadoCnj: true });

      setTimeout(() => {
        this.setState({ copiadoCnj: false });
      }, 1500);

    } catch (err) {
      console.error("Erro ao copiar:", err);
    }
  }


  copiarTextoPorIdProcesso = (id) => {
    const input = document.getElementById(id);
    if (!input) return;

    input.select();
    input.setSelectionRange(0, 99999); // mobile

    try {
      if (navigator.clipboard && window.isSecureContext) {
        // Ambiente seguro (https / localhost)
        navigator.clipboard.writeText(input.value);
      } else {
        // Fallback para HTTP / intranet
        document.execCommand("copy");
      }

      this.setState({ copiadoProcesso: true });

      setTimeout(() => {
        this.setState({ copiadoProcesso: false });
      }, 1500);

    } catch (err) {
      console.error("Erro ao copiar:", err);
    }
  }


  copiarTextoPorIdPasta = (id) => {
    const input = document.getElementById(id);
    if (!input) return;

    input.select();
    input.setSelectionRange(0, 99999); // mobile

    try {
      if (navigator.clipboard && window.isSecureContext) {
        // Ambiente seguro (https / localhost)
        navigator.clipboard.writeText(input.value);
      } else {
        // Fallback para HTTP / intranet
        document.execCommand("copy");
      }

      this.setState({ copiadoPasta: true });

      setTimeout(() => {
        this.setState({ copiadoPasta: false });
      }, 1500);

    } catch (err) {
      console.error("Erro ao copiar:", err);
    }
  }

  render() {
    const { basicOptions, horizontalOptions, multiAxisOptions, stackedOptions } = this.options;
    const usuarioLogado = this.context.usuarioAutenticado;
    const usuarioPerfil = usuarioLogado.perfil.codigo;
    var adm = 'none';
    var criaTitulo = 'none';
    if(usuarioPerfil == 1 || usuarioPerfil == 2) {
      adm = 'hide';
    }

    var exibieDataHistorico = 'none';
    if(usuarioLogado.empresa.codigo == 138) {
      exibieDataHistorico = 'block'
    } else {
      exibieDataHistorico = 'none'
    }

    var tituloPredefinidoSim = 'none';
    var tituloNaoPredefinido = 'block';
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
     tituloPredefinidoSim = 'block';
     tituloNaoPredefinido = 'none';
    } else {
     tituloPredefinidoSim = 'none';
     tituloNaoPredefinido = 'block';
    }

    var bloqueiaTitulo = '';
    if(usuarioLogado.empresa.codigo == 138) {
      bloqueiaTitulo = 'false';
    }

    if(usuarioLogado.perfil.codigo == 1 || usuarioLogado.perfil.codigo == 2) {
      criaTitulo = 'block';
    }

    const { copiadoCnj } = this.state;
    const { copiadoProcesso } = this.state;
    const { copiadoPasta } = this.state;

    const { upLoadFiles } = this.state;
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        {/**Incluir Custas Processuais */}
        <Dialog header="Incluir Custas"
                visible={this.state.modalCustas} 
                style={{ width: '40vw' }} 
                footer={this.renderFooterCadastroCustas('modalCustas')} 
                onHide={() => this.fecharModalCadastro('modalCustas')}>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label htmlFor="tipoCusta">Tipo de Custa</label>
                <Dropdown value={this.state.tipoCusta} 
                          options={this.state.tiposCustas} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          filter showClear filterBy="nome"
                          onChange={this.onChangeTipoCustas}
                          id="tipoCusta"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Débito/Cédito</label>
                <Dropdown value={this.state.tipo} 
                          options={this.tiposPagamentosCustas} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          onChange={(e) => this.setState({tipo: e.value})} 
                          id="tipoCusta"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
              <label>Valor Custas</label>
              <InputNumber inputId="locale-german" 
                            value={this.state.vlCustas} 
                            style={{width: '100%', height: '32px'}} 
                            onChange={(e) => this.setState({vlCustas: e.value})} 
                            mode="decimal" locale="de-BR" minFractionDigits={2}/>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label>Dt. Pagamento</label>
                <Calendar id="maskCusta" 
                          value={this.state.dtPagamento} 
                          onChange={(e) => this.setState({ dtPagamento: e.value })} 
                          locale="es"
                          style={{width: '100%', height: '32px'}} 
                          dateFormat="dd/mm/yy"
                          mask="99/99/9999"/>
              </div>
            </div>
          </div>
        </Dialog>
        <ConfirmDialog visible={this.state.visibleCusas} 
                       onHide={() => this.setState({ visibleCusas: false })} 
                       message="Are you sure you want to proceed?"
                       header="Confirmation"
                       icon="pi pi-exclamation-triangle" 
                       accept={() => this.excluirCusta} 
                       reject={() => this.setState({visible: false})}/>

        {/**Incluir Garantias do Processo */}
        <Dialog header="Incluir Garantias"
                visible={this.state.modalGarantias} 
                style={{ width: '40vw' }} 
                footer={this.renderFooterCadastroGarantias('modalGarantias')} 
                onHide={() => this.fecharModalCadastro('modalGarantias')}>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label htmlFor="tipoCusta">Tipo de Garantia</label>
                <Dropdown value={this.state.tipoGarantia} 
                          options={this.state.tiposGarantias} style={{width: '100%', height: '32px'}}
                          optionLabel="nome" 
                          emptyMessage=" "
                          filter showClear filterBy="nome"
                          onChange={this.onChangeTipoGarantia}
                          id="tipoCusta"
                          className="p-inputtext-sm p-d-block p-mb-1"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
              <label>Valor Penhora</label>
              <InputNumber inputId="locale-german" 
                            value={this.state.vlPenhora} 
                            style={{width: '100%', height: '32px'}} 
                            onChange={(e) => this.setState({vlPenhora: e.value})} 
                            mode="decimal" locale="de-BR" minFractionDigits={2}/>
              </div>
            </div>
          </div>
        </Dialog>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-users"></i>
                    <span> Ficha do Processo</span>
                  </h3>
                  <div></div>
                  <div style={{textAlign: 'right'}}>
                    <Button icon="pi pi-heart"
                                  className={this.state.iconeImportanteParaMim} 
                                  onClick={this.iincluirProcessoImportancia}
                                  tooltip={this.state.iconeImportanteParaMimTitle} 
                                  tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                                  />
                    &nbsp;&nbsp;&nbsp;
                    <Button icon="pi pi-star" 
                            onClick={this.incluirProcessoImportanteParaEmpresa}
                            className={this.state.iconeImportanteParaEmpresa}
                            tooltip={this.state.iconeImportanteParaEmpresaTitle}
                            tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                             />
                    &nbsp;&nbsp;&nbsp;
                    <Button icon="pi pi-info" 
                            onClick={this.incluirProcessoEstrategico}
                            className={this.state.iconeEstrategico}
                            tooltip={this.state.iconeEstrátegicoTitle}
                            tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                             />
                    &nbsp;&nbsp;&nbsp;
                    <Button className="p-button-secondary p-button-text" 
                            icon="pi pi-arrow-left"
                            title="Voltar"
                            onClick={this.voltar}
                            />
                  </div>  
                 </div>
                <TabView className="tabview-custom">
                 <TabPanel header="Processo">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <h6><label>
                                  Partes
                                  &nbsp;
                                  &nbsp;
                                  <a  
                                      className="cursor" 
                                      target="_blank"
                                      title="Incluir nova Parte"
                                      onClick={this.exibirNovaParte}>({this.state.iconeExibirNovaParte})</a>
                                </label>
                            </h6>
                            <div style={{display: `${this.state.exibirNovaParte}`}}>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <AutoComplete value={this.state.selectParte}
                                                  suggestions={this.state.filterPessoas} 
                                                  completeMethod={this.consultarPessoa}
                                                  style={{width: '100%'}}
                                                  field="nome" multiple onChange={(e) => this.setState({selectParte: e.value })} 
                                                  className="p-autoComplete-sm p-d-block p-mb-0"/>
                                  <a className="linkCadastroNovoCliente" onClick={() => this.novoAutor()}>Caso a pessoa não exista, clique aqui para criar uma nova
                                  </a>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>Tipo<span className="obrigatorioAsterisco"> *</span></label>
                                    <Dropdown value={this.state.tipoParte} 
                                              options={this.tipoPartes} style={{width: '100%', height: '32px'}}
                                              optionLabel="nome" 
                                              filter showClear filterBy="nome"
                                              onChange={this.incluirParte} 
                                              id="tipoParte"
                                              className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div> 
                            </div>
                            <DataTable value={this.state.partesProcesso} 
                                       emptyMessage=" "
                                       size="small"
                                       showGridlines>
                              <Column field="pessoa.nome" header="Nome"></Column>
                              <Column field="nomeTipo" header="Parte"></Column>
                              <Column body={this.acoesPartes} 
                                      exportable={false} 
                                      style={{ minWidth: '4rem', textAlign: 'center' }}></Column>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                      <br/>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Dt. Cadastro</label>
                            <label value={this.state.dataCadastro}></label>
                            <Calendar id="mask2"
                                      value={this.state.dataCadastro}
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      disabled="true"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Ult. Mov.</label>
                            <Calendar id="mask2"
                                      value={new Date(this.state.dataUltimaMovimentacao)}
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      disabled="true"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Responsável</label>
                            <Dropdown value={this.state.responsavelProcesso}
                                      options={this.state.usuarios} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      onChange={e => this.setState({responsavelProcesso: e.target.value})}
                                      id="responsavelProcesso"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>UF</label>
                            <Dropdown value={this.state.uf} 
                                      options={this.estados} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      onChange={e => this.setState({uf: e.target.value})}
                                      id="uf"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <hr></hr>
                          </div>
                        </div>
                      </div>
                      <br></br>
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label htmlFor="push">
                                <Checkbox inputId="push" 
                                          name="push" 
                                          value="push" 
                                          onChange={this.onCityChange} 
                                          checked={this.state.push.indexOf('push') !== -1} />
                                &nbsp;
                                Processo no Push
                                &nbsp;
                                <Checkbox inputId="email" 
                                          name="email" 
                                          value="email" 
                                          onChange={this.onCityChange} 
                                          checked={this.state.push.indexOf('email') !== -1} />
                                &nbsp;
                                Receber push por email
                                &nbsp;
                                <Checkbox inputId="historico" 
                                          name="historico" 
                                          value="historico" 
                                          onChange={this.onCityChange} 
                                          checked={this.state.push.indexOf('historico') !== -1} />
                                &nbsp;
                                Incluir no Histórico
                              </label>
                            </div>
                          </div>
                        </div>
                        <br></br>
                        <div className="row">
                          
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Numeração Única</label>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <InputMask
                                  id="numeroCnj"
                                  mask="9999999-99.9999.9.99.9999"
                                  style={{ width: "100%", height: "32px" }}
                                  value={this.state.nrCnj}
                                  onChange={e => this.setState({ nrCnj: e.target.value })}
                                  className="p-inputtext-sm"
                                />

                                <FaCopy
                                  onClick={() => this.copiarTextoPorIdCnj("numeroCnj")}
                                  style={{ cursor: "pointer" }}
                                  title="Copiar"
                                />
                                {copiadoCnj && (
                                  <small style={{ color: "green" }}>copiado!</small>
                                )}
                              </div>

                              <div>
                                <strong style={{ display: this.state.exibeLInkProcessoPrincipal }}>
                                  Processo Principal:&nbsp;
                                  <a
                                    href={this.state.paramProcessoPrincipal}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={this.consultarProcessoPrincipal}
                                  >
                                    {this.state.linkProcessoPrincipal}
                                  </a>
                                </strong>
                              </div>
                            </div>
                          </div>


                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Processo Original</label>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <InputText
                                  id="numeroProcesso"
                                  style={{ width: "100%", height: "32px" }}
                                  value={this.state.nrProcesso}
                                  onChange={e => this.setState({ nrProcesso: e.target.value })}
                                  className="p-inputtext-sm"
                                />

                                <FaCopy
                                  onClick={() => this.copiarTextoPorIdProcesso("numeroProcesso")}
                                  style={{ cursor: "pointer" }}
                                  title="Copiar"
                                />
                                {copiadoProcesso && (
                                  <small style={{ color: "green" }}>copiado!</small>
                                )}
                              </div>
                            </div>     
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Pasta</label>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <InputText
                                  id="pasta"
                                  style={{ width: "100%", height: "32px" }}
                                  value={this.state.pasta}
                                  onChange={e => this.setState({ pasta: e.target.value })}
                                  className="p-inputtext-sm"
                                />

                                <FaCopy
                                  onClick={() => this.copiarTextoPorIdPasta("pasta")}
                                  style={{ cursor: "pointer" }}
                                  title="Copiar"
                                />
                                {copiadoPasta && (
                                  <small style={{ color: "green" }}>copiado!</small>
                                )}
                              </div>
                            </div>     
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApenso}`}}>
                          <div className="row">
                            <div className="col-sm-5">
                              <div className="form-group">
                                <label>Câmara</label>
                                <InputText id="camaraConsulta" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.camaraConsulta}
                                          onChange={e => this.setState({camaraConsulta: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                            <div className="col-sm-5">
                              <div className="form-group">
                                <label>Relator</label>
                                <InputText id="relatorConsulta" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.relatorConsulta}
                                          onChange={e => this.setState({relatorConsulta: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">
                            <div className="form-group">
                              <label>Grupo de Trabalho
                                <span className="obrigatorioAsterisco"> * </span>
                                <span style={{display: `${adm}`}}>
                                  <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                          tooltip="Clique para adicionar um novo Grupo de Trabalho" 
                                          tooltipOptions={{position: 'top'}}
                                          style={{width: '20px', height: '10px'}}/>
                                </span>
                              </label>
                              <Dropdown value={this.state.grupoTrabalho} 
                                        options={this.state.gruposTrabalho} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={this.onChangeGrupoTrabalho}
                                        id="grupoTrabalho"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-5">
                            <div className="form-group">
                              <label>Status Processual
                                <span className="obrigatorioAsterisco"> * </span>
                                <span style={{display: `${adm}`}}>
                                  <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                          tooltip="Clique para adicionar um Novo Status Processual" 
                                          tooltipOptions={{position: 'top'}}
                                          style={{width: '20px', height: '10px'}}/>
                                </span>
                              </label>
                              <Dropdown value={this.state.statusProcessual} 
                                        options={this.state.statusProcessuais} style={{width: '100%', height: '32px'}}
                                        optionLabel="descricao" 
                                        filter showClear filterBy="descricao"
                                        onChange={this.onChangeStatusProcessual}
                                        id="statusProcessual"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-5">
                            <div className="form-group">
                              <label>Área de Atuação
                                <span className="obrigatorioAsterisco"> * </span>
                                <span style={{display: `${adm}`}}> 
                                  <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                          tooltip="Clique para adicionar uma nova Área de Atuação" 
                                          tooltipOptions={{position: 'top'}}
                                          style={{width: '20px', height: '10px'}}/>
                                </span>
                              </label>
                              <Dropdown value={this.state.areaAtuacao} 
                                        options={this.state.areasAtuacao} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={this.onChangeAreaAtuacao}
                                        id="areaAtuacao"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-5">
                            <div className="form-group">
                              <label>Tipo de Ação
                                <span className="obrigatorioAsterisco"> * </span>
                                <span style={{display: `${adm}`}}>
                                  <Button icon="pi pi-plus-circle" className="p-button-rounded p-button-text"
                                          tooltip="Clique para adicionar um Novo Tipo de Ação" 
                                          tooltipOptions={{position: 'top'}}
                                          style={{width: '20px', height: '10px'}}/>
                                </span>
                              </label>
                              <Dropdown value={this.state.tipoAcao} 
                                        options={this.state.tiposAcao} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={this.onChangeTipoAcao}
                                        id="tipoAcao"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-10">
                            <div className="form-group">
                              <label>Comarca
                              </label>
                              <InputText id="comarca" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.dsComarca}
                                        onChange={e => this.setState({dsComarca: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row">
                            <div className="col-sm-5">
                              <div className="form-group">
                                <label>Tipo de Decisão</label>
                                <Dropdown value={this.state.tipoDecisao} 
                                          options={this.state.tiposDecisao} style={{width: '100%', height: '32px'}}
                                          optionLabel="nome" 
                                          filter showClear filterBy="nome"
                                          onChange={this.onTipoDecisaoChange}
                                          id="grupoTrabalho"
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                      
                            <div className="col-sm-5">
                              <div className="form-group">
                                <label>Data Última Decisão</label>
                                <Calendar id="mask" 
                                          value={this.state.dataUltimaDecisao} 
                                          onChange={(e) => this.setState({ dataUltimaDecisao: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row">
                            <div className="col-sm-3">
                              <div className="form-group">
                                <label>Data de Distribuição</label>
                                <Calendar id="mask2"
                                          value={new Date(this.state.dataDistribuicao)} 
                                          onChange={(e) => this.setState({ dataDistribuicao: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                              </div>
                            </div>
                            <div className="col-sm-3">
                              <div className="form-group">
                                <label>Data da Setença</label>
                                <Calendar id="mask" 
                                          value={this.state.dataSentenca} 
                                          onChange={(e) => this.setState({ dataSentenca: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label>Valor da Causa</label>
                                <InputNumber inputId="locale-german" 
                                            value={this.state.vlCausa} 
                                            style={{width: '100%', height: '32px'}} 
                                            onChange={(e) => this.setState({vlCausa: e.value})} 
                                            mode="decimal" locale="de-BR" minFractionDigits={2}/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row">
                            <div className="col-sm-10">
                              <div className="form-group">
                                <Accordion multiple>
                                  <AccordionTab header="Pedidos">
                                    <DataTable value={this.state.pedidosProcesso} emptyMessage=" ">
                                      <Column field="pedido.nome" header="Pedido"></Column>
                                      <Column field="vlProvavel" header="Vl. Provável"></Column>
                                      <Column field="vlPossivel" header="Vl. Possível"></Column>
                                      <Column field="vlRemoto" header="Vl. Remoto"></Column>
                                      <Column body={this.acoesPedidos} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar um novo Pagamento" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalPedidos('modalPedidos')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header="Objetos de Ação">
                                    <DataTable value={this.state.objetosProcesso} emptyMessage=" ">
                                      <Column field="objeto.nome" header="Objeto"></Column>
                                      <Column body={this.acoesObjetosAcao} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar um novo Pagamento" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalObjetos('modalObjetos')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header={this.headerResumoPagamentos()}>
                                    <DataTable value={this.state.pagamentos} emptyMessage="Nenhum pagamento cadastrado">
                                      <Column field="pagamento.nome" header="Pagamento" className="cabecalho"></Column>
                                      <Column field="vlPagamento" header="R$" body={this.vlPagamento}></Column>
                                      <Column field="tipo" header="Deb/Cre"></Column>
                                      <Column field="dtPagamento" header="Dt. Pag"></Column>
                                      <Column body={this.acoesPagamentosProcesso} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                        tooltip="Clique para adicionar um novo Pagamento" 
                                        tooltipOptions={{position: 'top'}}
                                        style={{width: '20px', height: '20px'}}
                                        data-toggle="modal" 
                                        onClick={() => this.abrirModalCadastroPagamentos('modalPagamentos')}
                                        data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                    {/**Incluir Pagamentos de Processo */}
                                    <Dialog header="Incluir Pagamento"
                                            visible={this.state.modalPagamentos} 
                                            style={{ width: '40vw' }} 
                                            footer={this.renderFooterCadastroPagamentos('modalPagamentos')} 
                                            onHide={() => this.fecharModalCadastro('modalPagamentos')}>

                                      <div className="row">
                                        <div className="col-sm-12">
                                          <div className="form-group">
                                            <label htmlFor="nomeGrupo">Tipo de Pagamento</label>
                                            <Dropdown value={this.state.tipoPagamento} 
                                                      options={this.state.tiposPagamentos} style={{width: '100%', height: '32px'}}
                                                      optionLabel="nome" 
                                                      emptyMessage=" "
                                                      filter showClear filterBy="nome"
                                                      onChange={this.onChangeTipoPagamento}
                                                      id="tipoPagamento"
                                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-sm-12">
                                          <div className="form-group">
                                          <label>Débito/Crédito</label>
                                            <Dropdown value={this.state.tipo} 
                                                      options={this.tiposPagamentosCustas} style={{width: '100%', height: '32px'}}
                                                      optionLabel="nome" 
                                                      emptyMessage=" "
                                                      onChange={(e) => this.setState({tipo: e.value})} 
                                                      id="tipoPagamento"
                                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                          <label>Valor Pagamento</label>
                                          <InputNumber inputId="locale-german" 
                                                        value={this.state.vlPagamento} 
                                                        style={{width: '100%', height: '32px'}} 
                                                        onChange={(e) => this.setState({vlPagamento: e.value})} 
                                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                                          </div>
                                        </div>
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                            <label>Dt. Pagamento</label>
                                            <Calendar id="mask" 
                                                      value={this.state.dtPagamento} 
                                                      onChange={(e) => this.setState({ dtPagamento: e.value })} 
                                                      locale="es"
                                                      style={{width: '100%', height: '32px'}} 
                                                      dateFormat="dd/mm/yy"
                                                      mask="99/99/9999"/>
                                          </div>
                                        </div>
                                      </div>
                                    </Dialog>
                                    <ConfirmDialog visible={this.state.visiblePagamento} 
                                                  onHide={() => this.setState({ visiblePagamento: false })} 
                                                  message="Are you sure you want to proceed?"
                                                  header="Confirmation"
                                                  icon="pi pi-exclamation-triangle" 
                                                  accept={() => this.excluirPagamentoProcesso} 
                                                  reject={() => this.setState({visible: false})}/>
                                  </AccordionTab>
                                  <AccordionTab header={this.headerResumoCustas()}>
                                    <DataTable value={this.state.custasProcessos} emptyMessage="Nenhuma custa cadastrada">
                                      <Column field="custas.nome" header="Custa" className="cabecalho"></Column>
                                      <Column field="vlCustas" header="R$" body={this.vlCustas}></Column>
                                      <Column field="tipo" header="Deb/Cre"></Column>
                                      <Column field="dtPagamento" header="Dt. Pag"></Column>
                                      <Column body={this.acoesCustasProcesso} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                                tooltip="Clique para adicionar uma nova Custa" 
                                                tooltipOptions={{position: 'top'}}
                                                style={{width: '20px', height: '20px'}}
                                                data-toggle="modal" 
                                                onClick={() => this.abrirModalCadastroCustas('modalCustas')}
                                                data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                  <AccordionTab header={this.headerTotalPenhora()}>
                                    <DataTable value={this.state.garantiasProcesso} emptyMessage="Nenhuma garantia cadastrada">
                                      <Column field="garantia.nome" header="Garantia" className="cabecalho"></Column>
                                      <Column field="vlPenhora" header="R$" body={this.vlPenhora}></Column>
                                      <Column body={this.acoesGarantiasProcesso} exportable={false} style={{ minWidth: '8rem' }}header={
                                        <Button icon="pi pi-plus" className="p-button-rounded p-button-text"
                                                tooltip="Clique para adicionar uma nova garantia" 
                                                tooltipOptions={{position: 'top'}}
                                                style={{width: '20px', height: '20px'}}
                                                data-toggle="modal" 
                                                onClick={() => this.abrirModalCadastroGarantias('modalGarantias')}
                                                data-target="#modal-default"/>
                                      }></Column>
                                    </DataTable>
                                  </AccordionTab>
                                </Accordion>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row">
                            <div className="col-sm-10">
                              <div className="form-group">
                              <label>Motivo do Resultado</label>
                              <Dropdown value={this.state.motivo} 
                                        options={this.state.motivos} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={(e) => this.setState({motivo: e.value})} 
                                        id="motivoResultado"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{display: `${this.state.exibirAgravoApensoNegacao}`}}>
                          <div className="row">
                            <div className="col-sm-10">
                              <div className="form-group">
                                <label>Observação</label>
                                <InputTextarea id="pedidos" 
                                              type="text" 
                                              style={{width: '100%'}} 
                                              value={this.state.observacao}
                                              onChange={e => this.setState({observacao: e.target.value})}
                                              className="p-inputtext-sm p-d-block p-mb-1"
                                              rows={10} cols={30}/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="row">
                          <div className="col-sm-10">
                            <div className="form-group">
                              <div style={{textAlign: 'right'}}>
                                <Button label="Salvar" 
                                        className="p-button-primary p-button-text"
                                        onClick={this.alterarProcesso}/> 
                                &nbsp;
                                <Button label="Voltar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={this.voltar}/>
                            
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Andamento Processual">
                    <div className="cardMiniAgenda">
                      <div className="card-header-MiniAgenda">
                        <span>Dados do Processo</span>
                      </div>
                      <div className="card-content-MiniAgenda">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label>Pasta</label>
                              <InputText id="pasta" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.pasta}
                                          onChange={e => this.setState({pasta: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Numeração Única</label>
                              <InputMask id="numeroCnj" 
                                          type="text" 
                                          mask="9999999-99.9999.9.99.9999"
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrCnj}
                                          onChange={e => this.setState({nrCnj: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Processo Original</label>
                              <InputText id="numeroProcesso" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrProcesso}
                                          onChange={e => this.setState({nrProcesso: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>               
                        </div>
                      </div>
                    </div>
                    <br></br>
                    <div className="cardMiniAgenda">
                      <div className="card-header-MiniAgenda">
                        <span>Andamentos</span>
                      </div>
                      <div className="card-content-MiniAgenda">
                        <div className="row">
                          <div className="col-md-5">
                            <span className="input-group">
                              <button type="button" className="btn btn-primary bg-gradient-primary"  
                                      aria-haspopup aria-controls="overlay_panel"
                                      data-toggle="modal" 
                                      onClick={() => this.abrirModalCadastroHistorico('modalHistorico')}
                                      data-target="#modal-default">
                                <i className="fas fa-plus"></i> Adicionar</button>
                            </span>
                          </div>
                        </div>
                        <br/>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Classificação</label>
                              <Dropdown value={this.state.classificacaoAndamento} 
                                        options={this.classificacaoAndamentoOpcoes} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={(e) => this.setState({classificacaoAndamento: e.value})} 
                                        id="classificacaoAndamento"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>

                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Ordenação</label>
                              <Dropdown value={this.state.ordenacaoAndamento} 
                                        options={this.ordenacaoAndamentoOpcoes} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        filter showClear filterBy="nome"
                                        onChange={(e) => this.setState({ordenacaoAndamento: e.value})} 
                                        id="ordenacaoAndamento"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>&nbsp;</label>
                              <button type="button" className="btn btn-secondary bg-gradient-secondary"  
                                      onClick={this.reordenaHistorico}>
                              <i className="pi pi-sort-alt-slash"></i> Reordenar</button>
                            </div>
                          </div>
                        </div>
                        <br/>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <DataTable value={this.state.listaHistorico} paginator responsiveLayout="scroll" size="small"
                                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                        emptyMessage="Nenhuma Andamento">
                                  <Column body={this.usuarioHistorico} exportable={false} style={{ textAlign: 'center', minWidth: '8rem' }}/>
                                  <Column field="tipoAndamento.nome" header="Tipo de Andamento"></Column>
                              		<Column body={this.historicoProcesso} exportable={false} header="Histórico"/>
                                  <Column field="dataOcorrencia" header="Dt. Ocorrência"></Column>
                                  <Column field="dataHistorico" header="Dt. Cadastro"></Column>
                                  <Column field="usuario.nome" header="Usuário"></Column>
                                  <Column body={this.acoesHistoricoProcesso} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                              </DataTable>
                            </div>
                          </div>                  
                        </div>
                      </div>
                    </div>
                    {/**Incluir Histórico */}
                    <Dialog header="Incluir Andamento"
                                  visible={this.state.modalHistorico} 
                                  style={{ width: '40vw' }} 
                                  footer={this.renderFooterCadastroHistorico('modalHistorico')} 
                                  onHide={() => this.fecharModalCadastro('modalHistorico')}>

                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="dataPagamentoHistorico">Data de Ocorrência</label>
                                  <Calendar id="mask" 
                                            value={this.state.dataOcorrencia} 
                                            onChange={(e) => this.setState({ dataOcorrencia: e.value })} 
                                            locale="es"
                                            style={{width: '100%', height: '32px'}} 
                                            dateFormat="dd/mm/yy"
                                            mask="99/99/9999"/>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="tipoAndamento">Tipo de Andamento</label>
                                  <Dropdown value={this.state.tipoAndamento} 
                                            options={this.state.tiposAndamento} style={{width: '100%', height: '32px'}}
                                            optionLabel="nome" 
                                            filter showClear filterBy="nome"
                                            onChange={(e) => this.setState({tipoAndamento: e.value})} 
                                            id="grupoTrabalho"
                                            className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="descAndamento">Descrição</label>
                                  <InputTextarea id="descAndamento" 
                                                type="text" 
                                                style={{width: '100%'}} 
                                                value={this.state.descAndamento}
                                                onChange={e => this.setState({descAndamento: e.target.value})}
                                                className="p-inputtext-sm p-d-block p-mb-1"
                                                rows={7} cols={30}/>
                                </div>
                              </div>
                            </div>
                  </Dialog>
                  <ConfirmDialog visible={this.state.visibleHistorico} 
                                onHide={() => this.setState({ visibleHistorico: false })} 
                                message="Are you sure you want to proceed?"
                                header="Confirmation"
                                icon="pi pi-exclamation-triangle" 
                                accept={() => this.excluirHistpricoProcesso} 
                                reject={() => this.setState({visible: false})}/>
                  </TabPanel>
                  <TabPanel header="Agravo/Apenso">
                    <div className="cardMiniAgenda">
                      <div className="card-header-MiniAgenda">
                        <span>Dados do Processo</span>
                      </div>
                      <div className="card-content-MiniAgenda">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label>Pasta</label>
                              <InputText id="pasta" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.pasta}
                                          onChange={e => this.setState({pasta: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Numeração Única</label>
                              <InputMask id="numeroCnj" 
                                          type="text" 
                                          mask="9999999-99.9999.9.99.9999"
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrCnj}
                                          onChange={e => this.setState({nrCnj: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Processo Original</label>
                              <InputText id="numeroProcesso" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrProcesso}
                                          onChange={e => this.setState({nrProcesso: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>               
                        </div>
                      </div>
                    </div>
                    <br></br>
                    <div className="cardMiniAgenda">
                      <div className="card-content-MiniAgenda">
                        <div className="row">
                          <div className="col-md-5">
                            <span className="input-group">
                              <button type="button" className="btn btn-primary bg-gradient-primary"  
                                      aria-haspopup aria-controls="overlay_panel"
                                      data-toggle="modal" 
                                      onClick={() => this.abrirModalAgravoApenso('modalAgravoApenso')}
                                      data-target="#modal-default">
                                <i className="fas fa-plus"></i> Adicionar</button>
                            </span>
                          </div>
                        </div>
                        <br />
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <DataTable value={this.state.agravosApensos} paginator responsiveLayout="scroll" size="small"
                                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                        emptyMessage="Nenhum Processo">
                                  <Column field="processo.nrProcesso" header="Processo"></Column>
                                  <Column field="tipo" header="Tipo"></Column>
                                  <Column field="camara" header="Câmara"></Column>
                                  <Column field="relator" header="Relator"></Column>
                                  <Column body={this.acoesProcessoAgravosApensos} 
                                          exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                              </DataTable>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/**Incluir Agravo Apenso */}
                    <Dialog header="Incluir Processo Agravo/Apenso"
                                  visible={this.state.modalAgravoApenso} 
                                  style={{ width: '40vw' }} 
                                  footer={this.renderFooterCadastroAgravoApenso('modalAgravoApenso')} 
                                  onHide={() => this.fecharModalCadastro('modalAgravoApenso')}>

                            <div className="row">
                              <div className="col-sm-6">
                                <div className="form-group">
                                <label>Número do Processo</label>
                                <InputText id="numeroCnjAgravoApenso" 
                                           type="text" 
                                           style={{width: '100%', height: '32px'}} 
                                           value={this.state.numeroAgravoApenso}
                                           onChange={e => this.setState({numeroAgravoApenso: e.target.value})}
                                           onBlur={this.consultarAgravoApensoExistente}
                                           className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <label>Tipo Agraco/Apenso</label>
                                  <Dropdown value={this.state.tipoProcessoAgravoApenso} 
                                            options={this.tiposProcessoAgravoApenso} style={{width: '100%', height: '32px'}}
                                            optionLabel="nome" 
                                            onChange={(e) => this.setState({tipoProcessoAgravoApenso: e.value})} 
                                            id="tipoProcessoAgravoApenso"
                                            className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Câmara</label>
                                  <InputText id="camara" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.camara}
                                        onChange={e => this.setState({camara: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Relator</label>
                                  <InputText id="camara" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.relator}
                                        onChange={e => this.setState({relator: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-8">
                                <div className="form-group">
                                  <label>Parte</label>
                                  <InputText id="nomeParteAgravoApenso" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.nomeParteAgravoApenso}
                                        onChange={e => this.setState({nomeParteAgravoApenso: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                              <div className="col-sm-3"> 
                                <div className="form-group">
                                  <label>Tipo Parte</label>
                                  <Dropdown value={this.state.tipoParteAgravoApenso} 
                                            options={this.tipoParte} style={{width: '100%', height: '32px'}}
                                            optionLabel="nome" 
                                            onChange={(e) => this.setState({tipoParteAgravoApenso: e.value})} 
                                            id="grupoTrabalho"
                                            className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                              <div className="col-sm-1"> 
                                <div className="form-group">
                                  <br/>
                                  <Button icon="pi pi-check" 
                                          className="p-button-rounded p-button-text" 
                                          placeholder="Incluir Parte"
                                          onClick={this.incluirParteAgravoApenso}
                                          aria-label="Submit" />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <DataTable value={this.partesAgravoApenso} paginator responsiveLayout="scroll" size="small"
                                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                          emptyMessage="Nenhum Histórico">
                                      <Column field="nome" header="Nome"></Column>
                                      <Column field="tipo.nome" header="Tipo"></Column>
                                      <Column body={this.acoesPartesAgravoApenso} exportable={false} style={{ minWidth: '8rem' }}></Column>
                                  </DataTable>
                                </div>
                              </div>
                            </div>
                    </Dialog>
                    <Dialog header="Agravo/Apenso"
                            visible={this.state.modalAgravoApensoExistente} 
                            style={{ width: '40vw' }} 
                            footer={this.renderFooterAgravoApensoExistente('modalAgravoApensoExistente')}>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            Processo já existente no sistema. Deseja incluí-lo mesmo assim ? 
                          </div>
                        </div>
                      </div>
                    </Dialog>
                  </TabPanel>
                  <TabPanel header="Atividades">
                    <div className="cardMiniAgenda">
                      <div className="card-header-MiniAgenda">
                        <span>Dados do Processo</span>
                      </div>
                      <div className="card-content-MiniAgenda">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label>Pasta</label>
                              <InputText id="pasta" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.pasta}
                                          onChange={e => this.setState({pasta: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label>Numeração Única</label>
                              <InputMask id="numeroCnj" 
                                          type="text" 
                                          mask="9999999-99.9999.9.99.9999"
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrCnj}
                                          onChange={e => this.setState({nrCnj: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label>Processo Original</label>
                              <InputText id="numeroProcesso" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrProcesso}
                                          onChange={e => this.setState({nrProcesso: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>               
                        </div>
                      </div>
                    </div>
                    <br></br>
                    <div className="cardMiniAgenda">
                      <div className="card-header-MiniAgenda">
                        <span>Atividades</span>
                      </div>
                      <div className="card-content-MiniAgenda">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <button type="button" className="btn btn-success bg-gradient-success"  
                                      onClick={this.abrirOpcaoCriarAtividade}
                                      aria-haspopup aria-controls="op_criar_atividade">
                                <i className="pi pi-plus"></i> Criar Atividade
                              </button>
                              <OverlayPanel ref={(el) => this.opCriarAtividade = el}
                                            showCloseIcon
                                            id="op_criar_atividade"
                                            className="overlaypanel-demo">
                                <div style={{minWidth: '180px'}}>
                                  <button type="button" className="btn btn-light btn-block text-left"
                                          onClick={this.abrirCriacaoAtividade}>
                                    <i className="pi pi-plus"></i> Criar Atividade
                                  </button>
                                  <button type="button" className="btn btn-light btn-block text-left"
                                          onClick={this.abrirRodizioAtividade}>
                                    <i className="pi pi-refresh"></i> Rodízio
                                  </button>
                                </div>
                              </OverlayPanel>
                              &nbsp;
                              &nbsp;
                              <button type="button" className="btn btn-primary bg-gradient-primary"
                                        aria-haspopup aria-controls="overlay_panel"
                                        data-toggle="modal"
                                        onClick={this.novoFiltroAtividades}
                                        data-target="#modal-default">
                                <i className="pi pi-filter"></i> Filtrar
                              </button>
                              <Dialog header="Filtrar Atividades"
                                  visible={this.state.modalFiltroFaseAtividade}
                                  style={{ width: '40vw' }}
                                  footer={
                                    <div>
                                      <Button label="Limpar Filtro"
                                              className="p-button-secondary p-button-text"
                                              onClick={async () => {
                                                this.setState({atividadesFiltroStatus: null});
                                                this.setState({atividadesFiltroImportante: null});
                                                this.setState({atividadesFiltroUrgente: null});
                                                this.setState({atividadesFiltroDataLimiteInicial: null});
                                                this.setState({atividadesFiltroDataLimiteFinal: null});
                                                this.setState({atividadesFiltroPrazoFatalInicial: null});
                                                this.setState({atividadesFiltroPrazoFatalFinal: null});
                                                this.setState({atividadesFiltroDataConclusaoInicial: null});
                                                this.setState({atividadesFiltroDataConclusaoFinal: null});
                                                this.setState({atividadesFiltroClassificacao: null});
                                                this.setState({atividadesFiltroOrdenacao: null});
                                                await this.consultarAtividadesFiltro();
                                              }}/>
                                      &nbsp;
                                      <Button label="Aplicar Filtro"
                                              className="p-button-primary"
                                              onClick={async () => {
                                                await this.consultarAtividadesFiltro();
                                                this.fecharModal('modalFiltroFaseAtividade');
                                              }}/>
                                      &nbsp;
                                      <Button label="Fechar"
                                              className="p-button-secondary p-button-text"
                                              onClick={() => this.fecharModal('modalFiltroFaseAtividade')}/>
                                    </div>
                                  }
                                  onHide={() => this.fecharModal('modalFiltroFaseAtividade')}>

                                  <div className="row">
                                    <div className="col-sm-4">
                                      <div className="form-group">
                                        <Dropdown value={this.state.atividadesFiltroStatus}
                                                  options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                                                  optionLabel="status"
                                                  filter showClear filterBy="status"
                                                  onChange={(e) => this.setState({atividadesFiltroStatus: e.value})}
                                                  id="atividadesFiltroStatus"
                                                  placeholder="Status"
                                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                                      </div>
                                    </div>
                                    <div className="col-sm-4">
                                      <div className="form-group">
                                        <Dropdown value={this.state.atividadesFiltroImportante}
                                                  options={this.atividadesImportante} style={{width: '100%', height: '32px'}}
                                                  optionLabel="nome"
                                                  filter showClear filterBy="nome"
                                                  onChange={(e) => this.setState({atividadesFiltroImportante: e.value})}
                                                  id="atividadesFiltroImportante"
                                                  placeholder="Importante"
                                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                                      </div>
                                    </div>
                                    <div className="col-sm-4">
                                      <div className="form-group">
                                        <Dropdown value={this.state.atividadesFiltroUrgente}
                                                  options={this.atividadesUrgente} style={{width: '100%', height: '32px'}}
                                                  optionLabel="nome"
                                                  filter showClear filterBy="nome"
                                                  onChange={(e) => this.setState({atividadesFiltroUrgente: e.value})}
                                                  id="atividadesFiltroUrgente"
                                                  placeholder="Urgente"
                                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <label>Data Limite (de/até)</label>
                                      <div className="row">
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                            <Calendar value={this.state.atividadesFiltroDataLimiteInicial}
                                                      onChange={(e) => this.setState({atividadesFiltroDataLimiteInicial: e.value})}
                                                      style={{width: '100%', height: '32px'}}
                                                      dateFormat="dd/mm/yy" mask="99/99/9999" placeholder="Início"/>
                                          </div>
                                        </div>
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                            <Calendar value={this.state.atividadesFiltroDataLimiteFinal}
                                                      onChange={(e) => this.setState({atividadesFiltroDataLimiteFinal: e.value})}
                                                      style={{width: '100%', height: '32px'}}
                                                      dateFormat="dd/mm/yy" mask="99/99/9999" placeholder="Fim"/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <label>Prazo Fatal (de/até)</label>
                                      <div className="row">
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                            <Calendar value={this.state.atividadesFiltroPrazoFatalInicial}
                                                      onChange={(e) => this.setState({atividadesFiltroPrazoFatalInicial: e.value})}
                                                      style={{width: '100%', height: '32px'}}
                                                      dateFormat="dd/mm/yy" mask="99/99/9999" placeholder="Início"/>
                                          </div>
                                        </div>
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                            <Calendar value={this.state.atividadesFiltroPrazoFatalFinal}
                                                      onChange={(e) => this.setState({atividadesFiltroPrazoFatalFinal: e.value})}
                                                      style={{width: '100%', height: '32px'}}
                                                      dateFormat="dd/mm/yy" mask="99/99/9999" placeholder="Fim"/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <label>Data de Conclusão (de/até)</label>
                                      <div className="row">
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                            <Calendar value={this.state.atividadesFiltroDataConclusaoInicial}
                                                      onChange={(e) => this.setState({atividadesFiltroDataConclusaoInicial: e.value})}
                                                      style={{width: '100%', height: '32px'}}
                                                      dateFormat="dd/mm/yy" mask="99/99/9999" placeholder="Início"/>
                                          </div>
                                        </div>
                                        <div className="col-sm-6">
                                          <div className="form-group">
                                            <Calendar value={this.state.atividadesFiltroDataConclusaoFinal}
                                                      onChange={(e) => this.setState({atividadesFiltroDataConclusaoFinal: e.value})}
                                                      style={{width: '100%', height: '32px'}}
                                                      dateFormat="dd/mm/yy" mask="99/99/9999" placeholder="Fim"/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <Dropdown value={this.state.atividadesFiltroClassificacao}
                                                  options={this.classificacaoAtividadesOpcoes} style={{width: '100%', height: '32px'}}
                                                  optionLabel="nome"
                                                  filter showClear filterBy="nome"
                                                  onChange={(e) => this.setState({atividadesFiltroClassificacao: e.value})}
                                                  id="atividadesFiltroClassificacao"
                                                  placeholder="Classificar por"
                                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <Dropdown value={this.state.atividadesFiltroOrdenacao}
                                                  options={this.ordenacaoAtividadesOpcoes} style={{width: '100%', height: '32px'}}
                                                  optionLabel="nome"
                                                  filter showClear filterBy="nome"
                                                  onChange={(e) => this.setState({atividadesFiltroOrdenacao: e.value})}
                                                  id="atividadesFiltroOrdenacao"
                                                  placeholder="Ordenação"
                                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                                      </div>
                                    </div>
                                  </div>
                                </Dialog>
                              </div>
                            </div>
                          </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                            <DataTable
                                value={this.state.atividades}
                                responsiveLayout="scroll" size="small"
                                        emptyMessage="Nenhuma Atividade">
                                    <Column body={this.statusTemplate} exportable={false} style={{ minWidth: '8rem' }} header="Status"/>
                                    <Column field="titulo" header="Título" sortable></Column>
                                    <Column body={this.grauTemplate} exportable={false} style={{ minWidth: '8rem' }} header="Grau"/>
                                    <Column body={(data) => data.subGrupo?.nome} header="Sub-Grupo"></Column>
																		<Column body={this.exibirPublicacao} exportable={false} style={{ minWidth: '8rem' }}header="Publicação"></Column>
                                    <Column field="responsaveis" header="Responsáveis"></Column>
                                    <Column field="dtLimite" header="Data Limite" sortable></Column>
                                    <Column body={this.prazoFatalFormat} exportable={false} style={{ minWidth: '8rem' }}header="Prazo Fatal"></Column>
                                    <Column body={this.acoesAtividade} exportable={false} style={{ minWidth: '8rem' }}header="Açõess"></Column>
                                </DataTable>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Documentos">
                    <Dialog
                        header={this.state.fileName || "Arquivo"}
                        visible={this.state.modalExibirArquivoProcesso}
                        style={{ width: '70vw' }}
                        modal
                        footer={
                          <div>
                            <Button
                              label="Fechar"
                              className="p-button-secondary p-button-text"
                              onClick={() => {
                                if (this.state.fileData) {
                                  URL.revokeObjectURL(this.state.fileData);
                                }
                                this.fecharModalCadastro('modalExibirArquivoProcesso');
                              }}
                            />
                          </div>
                        }
                        onHide={() => {
                          if (this.state.fileData) {
                            URL.revokeObjectURL(this.state.fileData);
                          }
                          this.fecharModalCadastro('modalExibirArquivoProcesso');
                        }}
                      >
                        <div className="row">
                          <div className="col-sm-12">

                            {this.state.fileData && (
                              <div style={{ marginTop: "10px" }}>
                                
                                {this.state.fileName?.toLowerCase().endsWith(".pdf") ? (
                                  <iframe
                                    src={this.state.fileData}
                                    title="PDF Viewer"
                                    width="100%"
                                    height="600px"
                                    style={{ border: "none" }}
                                  />
                                ) : (
                                  <img
                                    src={this.state.fileData}
                                    alt={this.state.fileName}
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "600px",
                                      display: "block",
                                      margin: "0 auto",
                                      border: "1px solid #ddd"
                                    }}
                                  />
                                )}

                              </div>
                            )}

                          </div>
                        </div>
                      </Dialog>
                    <div className="cardMiniAgenda">
                      <div className="card-header-MiniAgenda">
                        <span>Dados do Processo</span>
                      </div>
                      <div className="card-content-MiniAgenda">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label>Pasta</label>
                              <InputText id="pasta" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.pasta}
                                          onChange={e => this.setState({pasta: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Numeração Única</label>
                              <InputMask id="numeroCnj" 
                                          type="text" 
                                          mask="9999999-99.9999.9.99.9999"
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrCnj}
                                          onChange={e => this.setState({nrCnj: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Processo Original</label>
                              <InputText id="numeroProcesso" 
                                          type="text" 
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.nrProcesso}
                                          onChange={e => this.setState({nrProcesso: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          disabled="true"/>
                            </div>
                          </div>               
                        </div>
                      </div>
                    </div>
                    <br></br>
                    
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">  
                          <div className="container1">
                            <Upload onUpload={this.handleUpload}/>
                            {!!upLoadFiles && (
                              <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <br/>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Classificação</label>
                          <Dropdown value={this.state.classificacaoDocumentos} 
                                    options={this.classificacaoDocumentosOpcoes} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={(e) => this.setState({classificacaoDocumentos: e.value})} 
                                    id="classificacaoDocumentos"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Ordenação</label>
                          <Dropdown value={this.state.ordenacaoDocumentos} 
                                    options={this.ordenacaoDocumentosOpcoes} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    filter showClear filterBy="nome"
                                    onChange={(e) => this.setState({ordenacaoDocumentos: e.value})} 
                                    id="ordenacaoDocumentos"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>&nbsp;</label>
                          <Button icon="pi pi-sort-alt-slash" label="Reordenar" className="p-button-sm p-button-warning" 
                                  onClick={this.reordenarArquivos} style={{width: '100%'}} />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>&nbsp;</label>
                          <Button icon="pi pi-cloud-download" label="Baixar todos os Arquivos" className="p-button-sm p-button-success" 
                                  onClick={this.baixarTodosArquivos} style={{width: '100%'}} />
                        </div>
                      </div>
                    </div>
                    <br/>

                    <div className="cardMiniAgenda">
                      <div className="card-header-MiniAgenda">
                        <span>Arquivos</span>
                      </div>
                      <div className="card-content-MiniAgenda">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">  
                              <DataTable value={this.state.arquivos} 
                                         size="small"
                                         emptyMessage="Nenhum Arquivo">
                                    <Column field="nome" header="Arquivo"/>
                                    <Column field="dsArquivo" header="Descrição"></Column>
                                    <Column field="dataArquivo" header="Data de Inclusão"></Column>
                                    <Column field="usuario.nome" header="Usuário"></Column>
                                    <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                              </DataTable> 
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/**Adicionar descrição ao arquivo */}
                    <Dialog header="Descrição do Arquivo"
                                visible={this.state.modalDescricaoArquivo} 
                                style={{ width: '40vw' }} 
                                footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                                onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label htmlFor="descricaoArquivo">Descrição</label>
                                <InputText id="descricaoArquivo" 
                                      type="text" 
                                      style={{width: '100%', height: '37px'}} 
                                      value={this.state.dsArquivo}
                                      onChange={e => this.setState({dsArquivo: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                    </Dialog>
                    <ConfirmDialog visible={this.state.visibleExcluirArquivo} 
                                   onHide={() => this.setState({ visibleExcluirArquivo: false })} 
                                   message="Are you sure you want to proceed?"
                                   header="Confirmation"
                                   icon="pi pi-exclamation-triangle" 
                                   accept={() => this.excluirArquivo} 
                                   reject={() => this.setState({visibleExcluirArquivo: false})}/>              
                  </TabPanel>
                  <TabPanel header="Financeiro" disabled={this.state.isFinancero}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Partes:&nbsp;&nbsp;<span className="partes">{this.state.montaPartes}</span></label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Pasta</label>
                          <InputText id="pasta" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.pasta}
                                      onChange={e => this.setState({pasta: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Numeração Única</label>
                          <InputMask id="numeroCnj" 
                                      type="text" 
                                      mask="9999999-99.9999.9.99.9999"
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrCnj}
                                      onChange={e => this.setState({nrCnj: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Processo Original</label>
                          <InputText id="numeroProcesso" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nrProcesso}
                                      onChange={e => this.setState({nrProcesso: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      disabled="true"/>
                        </div>
                      </div>               
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <DataTable value={this.state.lancamentosFinanceiros} paginator responsiveLayout="scroll" size="small"
                                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                          emptyMessage="Nenhum Lançamento Financeiro">
                            <Column body={this.tipoCategoriaFinanceiro} exportable={false} style={{ minWidth: '8rem' }}header="Categoria"></Column>
                            <Column field="tipo.nome" header="Tipo"></Column>
                            <Column field="dsLancamento" header="Descrição"></Column>
                            <Column field="valorLancamentoFormat" header="Valor"></Column>
                            <Column field="dtVencimento" header="Dt. Vencto."></Column>
                            <Column field="valorPagamentoFormat" header="Valor Pago"></Column>
                            <Column field="dtPago" header="Dt. Pgto."></Column>
                            <Column body={this.situacaoFinanceiro} exportable={false} style={{ minWidth: '8rem' }}header="Situação"></Column>
                            <Column body={this.acoesFinanceiro} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </TabView>
                {/**Consultar a execução da atividade por meio do checklist */}
                <Dialog header="Checklist de Atividade"
                        visible={this.state.modalCheckList} 
                        onHide={() => this.fecharModalAtividade('modalCheckList')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Status: <strong>{this.state.statusExecucao}</strong></label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Usuario: <strong>{this.state.usuarioCheckList}</strong></label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Data: <strong>{this.state.dataExecucaoCheckList}</strong></label>
                        </div>
                      </div>
                    </div>
                </Dialog>
                {/**Modal de exibir arquivo de ativdades */}
                <Dialog
                  header={this.state.fileName || "Arquivo"}
                  visible={this.state.modalExibirArquivo}
                  style={{ width: '70vw' }}
                  modal
                  footer={
                    <div>
                      <Button
                        label="Fechar"
                        className="p-button-secondary p-button-text"
                        onClick={() => {
                          if (this.state.fileData) {
                            URL.revokeObjectURL(this.state.fileData);
                          }
                          this.fecharModalCadastro('modalExibirArquivo');
                        }}
                      />
                    </div>
                  }
                  onHide={() => {
                    if (this.state.fileData) {
                      URL.revokeObjectURL(this.state.fileData);
                    }
                    this.fecharModalCadastro('modalExibirArquivo');
                  }}
                >
                  <div className="row">
                    <div className="col-sm-12">

                      {this.state.fileData && (
                        <div style={{ marginTop: "10px" }}>
                          
                          {this.state.fileName?.toLowerCase().endsWith(".pdf") ? (
                            <iframe
                              src={this.state.fileData}
                              title="PDF Viewer"
                              width="100%"
                              height="600px"
                              style={{ border: "none" }}
                            />
                          ) : (
                            <img
                              src={this.state.fileData}
                              alt={this.state.fileName}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "600px",
                                display: "block",
                                margin: "0 auto",
                                border: "1px solid #ddd"
                              }}
                            />
                          )}

                        </div>
                      )}

                    </div>
                  </div>
                </Dialog>

                {/**Aqui entra o modal de atividade */}
                <AtividadeComponent
                  visible={this.state.modalAtividadeComponente}
                  atividade={this.state.atividade}
                  onHide={() => this.setState({modalAtividadeComponente: false})}
                  onAtividadeAlterada={() => {
                    this.setState({modalAtividadeComponente: false});
                    this.consultarAtividades(this.state.processo);
                  }}
                />
                <Dialog header={this.templateCriacaoAtividade} autoComplete="nope"
                          visible={false}
                          style={{ width: '43vw' }}
                          footer={null}
                          onHide={() => {}}>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <h5><strong style={{color: '#000'}}>{this.state.titulo} - {this.state.pontuacao}</strong></h5>
                         </div>
                        </div>
                      </div>
                      <div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Steps model={this.itensCheckList} 
                                  onSelect={(e) => this.marcarCheckList(e)}
                                  activeIndex={this.state.activeIndex} 
                                  readOnly={false} />
                          </div>
                        </div>
                      </div>
                    </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <strong style={{color: '#1A89FF', paddingTop: '20px'}}>
                              {this.state.pesquisaProcesso} &nbsp;&nbsp;
                            </strong>
                            <br></br>
                            <strong>{this.state.partes}</strong>
                          </div>
                        </div>
                      </div>
											{this.state.isPublicacao && (
											<div>
												<strong>
													<a onClick={this.consultarPublicacaoAtividadeAberta} style={{ color: 'blue', cursor: 'pointer', padding: '8px' }}>
														Atividade com publicação, clique aqui para abrir
													</a>
												</strong>
											</div>
											)}
											<br></br>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                          <InputText id="grupoAlterar" style={{width: '100%', height: '32px'}}
                                     type="text"
                                     disabled="true"
                                     value={this.state.grupoTrabalhoDescricao}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <InputText id="subgrupoDescricao" 
                                       type="text" 
                                       disabled
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.subGrupoTrabalhoDescricao}
                                       onChange={e => this.setState({subGrupoTrabalhoDescricao: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.responsaveisLista} 
                                        options={this.state.responsaveis} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ responsaveisLista: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Responsáveis"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.interessadosLista} 
                                        options={this.state.interessados} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ interessadosLista: e.value })}  
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Interssados"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtLimite} 
                                      onChange={(e) => this.setState({ dtLimite: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Limite"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                          <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                    type="text"
                                    mask="99:99"
                                    value={this.state.hora}
                                    onChange={e => this.setState({hora: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtFatal} 
                                      onChange={(e) => this.setState({ dtFatal: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Prazo fatal"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputTextarea value={this.state.descricao} style={{width: '100%'}}
                                           id="descricaoE"
                                           onChange={e => this.setState({descricao: e.target.value})}
                                           rows={4} 
                                           cols={60} />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Dropdown value={this.state.optionStatus} style={{width: '100%', height: '32px'}} 
                                      options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                                      optionLabel="status" 
                                      emptyMessage=" "
                                      filter showClear filterBy="status"
                                      onChange={this.onChangeStatusAtividade}
                                      id="idStatusAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <div className="row" style={{marginLeft: '12px'}}>
                        <div className="col-sm-8">
                          <div className="form-group">
                            <label htmlFor="importante">
                              <Checkbox inputId="importante" 
                                        name="importante" 
                                        value="importante" 
                                        onChange={this.onGrauChange} 
                                        checked={this.state.grau.indexOf('importante') !== -1} />
                              &nbsp;&nbsp;
                              Importante
                              &nbsp;&nbsp;
                              <Checkbox inputId="urgente" 
                                        name="urgente" 
                                        value="urgente" 
                                        onChange={this.onGrauChange} 
                                        checked={this.state.grau.indexOf('urgente') !== -1} />
                              &nbsp;&nbsp;
                              Urgente
                              &nbsp;&nbsp;
                              <Checkbox inputId="privado" 
                                        name="privado" 
                                        value="privado" 
                                        onChange={this.onGrauChange} 
                                        checked={this.state.grau.indexOf('privado') !== -1} />
                              &nbsp;&nbsp;
                              Privado
                            </label>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <br></br>
                      <div className="row" style={{marginLeft: '12px'}}>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <span style={{fontSize: '14px', fontWeight: 'bold'}}>Histórico</span>
                            <hr></hr>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <TabView className="tabview-custom">
                              <TabPanel header="incluido pelo usuário">
                                <DataView value={this.state.historico ? this.state.historico.filter(h => h.tpHistorico === 'M') : []}
                                      layout={this.state.layout}
                                      emptyMessage=" "
                                      itemTemplate={this.templateHistoricoAtividade}/>
                              </TabPanel>
                              <TabPanel header="Incluido pelo sistema">
                                <DataView value={this.state.historico ? this.state.historico.filter(h => h.tpHistorico === 'A') : []}
                                      layout={this.state.layout}
                                      emptyMessage=" "
                                      itemTemplate={this.templateHistoricoAtividade}/>
                              </TabPanel>
                            </TabView>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Arquivos Anexados */}
                  <Dialog header="Arquivos Anexados atividade"
                          style={{ width: '40vw' }} 
                          visible={this.state.displayArquivosAnexadosAtividade} 
                          footer={
                            <frameElement>
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayArquivosAnexadosAtividade')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayArquivosAnexadosAtividade')}>
                      
                      <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">  
                              <div className="container">
                                
                                <Upload onUpload={this.handleUploadAtividade}/>
                                {!!upLoadFiles && (
                                  <FileList files={upLoadFiles} onDelete={this.handleDeleteAtividade}/>
                                )}
                              
                              </div>
                            </div>
                          </div>
                        </div>
                        <DataTable value={this.state.arquivosAtividades} paginator responsiveLayout="scroll" size="small"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                    emptyMessage="Nenhum Arquivo">
                          <Column field="arquivo" header="Arquivo"/>
                          <Column field="dsArquivo" header="Descrição"/>
                          <Column body={this.acoesArquivosAtividade} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                        </DataTable> 
                    </Dialog>   
                    {/**Adicionar descrição ao arquivo */}
                    <Dialog header="Descrição do Arquivo - Atividade"
                            visible={this.state.modalDescricaoArquivoAtividade} 
                            style={{ width: '40vw' }} 
                            footer={this.renderFooterDescricaoArquivoAtividade('modalDescricaoArquivoAtividade')}
                            onHide={() => this.fecharModalCadastro('modalDescricaoArquivoAtividade')}>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="descricaoArquivo">Descrição</label>
                              <InputText id="descricaoArquivo" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dsArquivo}
                                    onChange={e => this.setState({dsArquivo: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                  </Dialog>
                  <RodizioAtividadeComponent
                    visible={this.state.displayRodizioAtividade}
                    processoSelecionado={this.state.processo}
                    onHide={this.fecharRodizioAtividade}
                    onCadastroConcluido={() => {
                      this.consultarAtividades(this.state.processo);
                    }}
                  />
                  {/**Histórico de Atividades */}
                  <Dialog header="Histórico da Atividade" autoComplete="nope"
                          style={{ height: '50vw', width: '25vw' }}
                          visible={this.state.displayHistorico} 
                          footer={
                            <frameElement>
                              <Button label="Incluir" 
                                      className="p-button-primary p-button-text"
                                      onClick={this.novoHistorico}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayHistorico')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayHistorico')}>
                      <TabView className="tabview-custom">
                        <TabPanel header="incluido pelo usuário">
                          <DataView value={this.state.historico ? this.state.historico.filter(h => h.tpHistorico === 'M') : []}
                                layout={this.state.layout}
                                emptyMessage=" "
                                itemTemplate={this.templateHistoricoAtividade}/>
                        </TabPanel>
                        <TabPanel header="Incluido pelo sistema">
                          <DataView value={this.state.historico ? this.state.historico.filter(h => h.tpHistorico === 'A') : []}
                                layout={this.state.layout}
                                emptyMessage=" "
                                itemTemplate={this.templateHistoricoAtividade}/>
                        </TabPanel>
                      </TabView>
                  </Dialog>
                  {/**Confirmação de exclusão de Histórico */}
                  <ConfirmDialog visible={this.state.visibleHistorico} 
                                onHide={() => this.setState({ visibleHistorico: false })} 
                                message="Are you sure you want to proceed?"
                                header="Confirmation"
                                icon="pi pi-exclamation-triangle" 
                                accept={() => this.excluirHistorico} 
                                reject={() => this.setState({visibleHistorico: false})}/>
                  
                  {/**Incluir um novo histórico */}
                  <Dialog header="Incluir Histórico" autoComplete="nope"
                          style={{ width: '40vw' }} 
                          visible={this.state.displayHistoricoIncluir} 
                          footer={
                            <frameElement>
                              <Button label="Incluir" 
                                      className="p-button-primary p-button-text"
                                      onClick={() => this.incluirHistoricoAtividade()}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayHistoricoIncluir')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayHistoricoIncluir')}> 

                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <Editor value={this.state.dsHistorico} 
                                  onTextChange={e => this.setState({dsHistorico: e.htmlValue})} 
                                  style={{ height: '320px' }} />
                        </div>
                      </div>
                    </div>  
                  </Dialog>
                  
                  {/**Alterar histórico */}
                  <Dialog header="Editar Histórico" autoComplete="nope"
                          style={{ width: '40vw' }} 
                          visible={this.state.modalAlterarHistorico} 
                          footer={
                            <frameElement>
                              <Button label="Alterar" 
                                      className="p-button-primary p-button-text"
                                      onClick={this.alterarHistoricoAtividade}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('modalAlterarHistorico')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('modalAlterarHistorico')}> 
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <Editor value={this.state.dsHistorico} onTextChange={e => this.setState({dsHistorico: e.htmlValue})} style={{ height: '320px' }} />
                        </div>
                      </div>
                    </div>  
                  </Dialog>
                  {/**Descrição da Atividade */}
                  <Dialog header="Descrição da Atividade"
                          style={{ width: '50vw' }} 
                          visible={this.state.displayDescricao} 
                          footer={
                            <frameElement>
                              <Button label="Salvar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayDescricao')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayDescricao')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <InputTextarea id="idDescricao" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.descricao}
                                          onChange={e => this.setState({descricao: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={6} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>
                  {/**Nova Atividade Processo */}
                  <AtividadeComponentInclusao
                    visible={this.state.modalInclusaoComponente}
                    processo={this.state.processoParaInclusao}
                    publicacao={null}
                    onHide={() => this.setState({modalInclusaoComponente: false, processoParaInclusao: null})}
                    onAtividadeCriada={() => {
                      this.setState({modalInclusaoComponente: false, processoParaInclusao: null});
                      this.consultarAtividades(this.state.processo);
                    }}
                  />
                  <Dialog header="Incluir Atividade"
                          visible={false}
                          style={{ width: '43vw' }}
                          footer={null}
                          onHide={() => {}}>
                      <Progresso classeSecundaria={this.state.classeDiv}/>
                      <div style={{display: `${this.state.separador}`}}>
                        <br />
                        <strong style={{color: '#343A40'}}>Aguarde....</strong>
                        <br/>
                        <br/>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <strong>{this.state.pesquisaProcesso}</strong>
                            <br></br>
                            <br></br>
                            <strong style={{color: 'blue'}}>{this.state.montaPartes}</strong>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Dropdown value={this.state.tituloAtividade} style={{width: '100%', height: '32px'}} 
                                      options={this.state.titulos} style={{width: '100%', height: '32px'}}
                                      optionLabel="tituloExibir" 
                                      filter showClear filterBy="tituloExibir"
                                      onChange={e => this.setState({tituloAtividade: e.target.value})}
                                      id="tituloAtividade"
                                      emptyMessage=" "
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Título de Atividade"/>
                            <a className="linkCadGrupo" 
                               onClick={this.novoTituloAtividade} 
                               style={{cursor: 'pointer', display: `${criaTitulo}`}}>Caso o título ainda não exista, crie clicando Aqui</a>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                          <InputText id="processo" style={{width: '100%', height: '32px'}}
                                     type="text"
                                     disabled="true"
                                     value={this.state.grupoTrabalhoNome}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                                      options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={this.onSubGrupoChange}
                                      id="subGrupoTrabalho"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Sub-Grupo de Trabalho"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.responsavel} 
                                        options={this.state.responsaveis} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ responsavel: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Responsáveis"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.interessado} 
                                        options={this.state.interessados} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ interessado: e.value })}  
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Interessados"/>
                          </div>
                        </div>
                      </div>
                      {usuarioLogado?.empresa.codigo === 151 && (
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <Dropdown 
                                value={this.state.recorrencia} 
                                options={this.recorrencia} 
                                optionLabel="nome"
                                emptyMessage=" "
                                filter 
                                showClear 
                                filterBy="nome"
                                onChange={(e) => this.setState({ recorrencia: e.value })}
                                id="recorrencia"
                                className="p-inputtext-sm p-d-block p-mb-1"
                                placeholder="Recorrência ?"
                                style={{ width: '100%', height: '32px' }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtLimite} 
                                      onChange={(e) => this.setState({ dtLimite: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Limite"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                          <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                    type="text"
                                    mask="99:99"
                                    value={this.state.hora}
                                    onChange={e => this.setState({hora: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtFatal} 
                                      onChange={(e) => this.setState({ dtFatal: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Prazo fatal"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputTextarea id="descricao" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.descricao}
                                          onChange={e => this.setState({descricao: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={3} cols={30}
                                          placeholder="Descrição da Atividade"/>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <div className="row" style={{marginLeft: '12px'}}>
                        <div className="col-sm-8">
                          <div className="form-group">
                            <label htmlFor="importante">
                              <Checkbox inputId="importante" 
                                        name="importante" 
                                        value="importante" 
                                        onChange={this.onGrauChange} 
                                        checked={this.state.grau.indexOf('importante') !== -1} />
                              &nbsp;&nbsp;
                              Importante
                              &nbsp;&nbsp;
                              <Checkbox inputId="urgente" 
                                        name="urgente" 
                                        value="urgente" 
                                        onChange={this.onGrauChange} 
                                        checked={this.state.grau.indexOf('urgente') !== -1} />
                              &nbsp;&nbsp;
                              Urgente
                              &nbsp;&nbsp;
                              <Checkbox inputId="privado" 
                                        name="privado" 
                                        value="privado" 
                                        onChange={this.onGrauChange} 
                                        checked={this.state.grau.indexOf('privado') !== -1} />
                              &nbsp;&nbsp;
                              Privado
                            </label>
                          </div>
                        </div>
                      </div>
                  </Dialog>

                  {/**Cadastro de novo título de atividade*/}
                  <Dialog header="Incluir Novo Título de Atividade"
                          disabled="true"
                          style={{ width: '40vw' }} 
                          visible={this.state.modalNovoTitulo} 
                          footer={
                            <div className="right">
                                <Button label="Cadastrar"
                                        className="p-button-primary p-button-text"
                                        onClick={this.cadastrarNovoTitulo}/>
                                &nbsp;
                                <Button label="Cancelar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModalAtividade('modalNovoTitulo')}/>
                            </div>
                          } 
                          onHide={() => this.fecharModalAtividade('modalNovoTitulo')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Título da Atividade</label>
                          <InputText id="novoTituloAtividade" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.novoTitulo}
                                    placeholder="Título da Atividade"
                                    onChange={e => this.setState({novoTitulo: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Pontuação</label>
                          <InputText id="pontuacao" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.pontuacao}
                                    placeholder="Pontuação"
                                    onChange={e => this.setState({pontuacao: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                  </Dialog>

                  {/**Anexo de Documentos Nova Atividade */}
                  <Dialog header="Anexar Documentos"
                          visible={this.state.displayAnexoNovaAtividade} 
                          style={{ width: '40vw' }} 
                          footer={
                            <frameElement>
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayAnexoNovaAtividade')}/>
                            </frameElement>
                          } 
                          onHide={() => this.fecharModalAtividade('displayAnexoNovaAtividade')}>
                    
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">  
                          <div className="container">
                            
                            <Upload onUpload={this.handleUploadNovaAtividade}/>
                            {!!upLoadFiles && (
                              <FileList files={upLoadFiles} onDelete={this.handleDeleteNovaAtividade}/>
                            )}
                          
                          </div>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.arquivosNovaAtividade} paginator responsiveLayout="scroll" size="small"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                emptyMessage="Nenhum Arquivo">
                      <Column field="arquivo" header="Arquivo"/>
                      <Column field="descricao" header="Descrição"/>
                      <Column body={this.acoesArquivosNovaAtividade} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                    </DataTable> 
                          
                  </Dialog>
                  
                  {/**Adicionar descrição ao arquivo */}
                  <Dialog header="Descrição do Arquivo"
                              visible={this.state.modalDescricaoArquivoNovaAtividade} 
                              style={{ width: '40vw' }} 
                              footer={this.renderFooterDescricaoArquivoNovaAtividade('modalDescricaoArquivoNovaAtividade')}
                              onHide={() => this.fecharModalCadastro('modalDescricaoArquivoNovaAtividade')}>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="descricaoArquivoNovaAtividade">Descrição</label>
                              <InputText id="descricaoArquivoNovaAtividade" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.descricao}
                                    onChange={e => this.setState({descricao: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                  </Dialog>
                  <ConfirmDialog visible={this.state.visibleExcluirArquivo} 
                                onHide={() => this.setState({ visibleExcluirArquivo: false })} 
                                message="Are you sure you want to proceed?"
                                header="Confirmation"
                                icon="pi pi-exclamation-triangle" 
                                accept={() => this.excluirArquivo} 
                                reject={() => this.setState({visibleExcluirArquivo: false})}/>  

                  {/**Consultar Lançamento */}
                  <Dialog header="Consulta Lançamento"
                          visible={this.state.displayConsultaLancamento} 
                          style={{ width: '60vw' }} 
                          footer={this.renderFooterConsultaLancamento('displayConsultaLancamento')} 
                          onHide={() => this.fecharModal('displayConsultaLancamento')}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Categoria</label>
                          <InputText id="categoriaConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.categoriaNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Tipo</label>
                          <InputText id="tipoNome" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.tipoNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Valor</label>
                          <InputText id="valorConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.vlLancamentoMascara}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Vencimento</label>
                          <InputText id="dataVencimentoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dtVencimento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="formGroup">
                          <label>Situação</label>
                          <InputText id="situacaoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.situacao}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="formGroup">
                          <label>Valor Pago</label>
                          <InputText id="valorPago" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.vlPagoMascara}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="formGroup">
                          <label>Dt. Pagt.</label>
                          <InputText id="dataPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dtPago}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Processo</label>
                          <InputText id="processoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dsProcesso}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Descrição</label>
                          <InputText id="descricaoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dsLancamento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Observação</label>
                          <InputTextarea id="observacao" 
                                        type="text" 
                                        style={{width: '100%'}} 
                                        value={this.state.observacao}
                                        disabled="true"
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        rows={2} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>  
                  {/**Pagar outro valor despesa*/}
                  <Dialog header="Pagamento de Despesas"
                            visible={this.state.modalDespesaPagamento} 
                            style={{ width: '50vw' }}
                            footer={
                              <div alignItems="right">
                                <Button label="Pagar Lançamento" 
                                        className="p-button-success p-button-text"
                                        onClick={this.pagarDespesaReceita}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalDespesaPagamento')}/>
                              </div>
                            }
                            onHide={() => this.fecharModal('modalDespesaPagamento')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Despesa</label>
                          <InputText id="tipoNomePagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.tipoNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Valor</label>
                          <InputText id="valorPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.vlLancamento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Vencimento</label>
                          <InputText id="vencimentoPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dtVencimento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Pagar um novo valor</label>
                          <InputNumber inputId="pagamentoNovoValorDespesa" 
                                      value={this.state.vlLancamentoNovo} 
                                      style={{width: '100%', height: '37px'}} 
                                      onChange={(e) => this.setState({vlLancamentoNovo: e.value})} 
                                      mode="decimal" locale="de-BR" minFractionDigits={2}/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Novo Vencimento saldo devedor</label>
                          <Calendar id="novoVencimentoDespesa" 
                                    value={this.state.dtVencimentoNovo} 
                                    onChange={(e) => this.setState({ dtVencimentoNovo: e.value })} 
                                    locale="es"
                                    style={{width: '100%', height: '37px'}} 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Observação</label>
                          <InputTextarea id="observacaoPagamento" 
                                        type="text" 
                                        style={{width: '100%'}} 
                                        value={this.state.observacao}
                                        onChange={e => this.setState({observacao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        rows={2} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>

                  {/**Pagar outro valor receita*/}
                  <Dialog header="Pagamento de Receitas"
                            visible={this.state.modalReceitaPagamento} 
                            style={{ width: '50vw' }}
                            footer={
                              <div alignItems="right">
                                <Button label="Pagar Lançamento" 
                                        className="p-button-success p-button-text"
                                        onClick={this.pagarDespesaReceita}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalReceitaPagamento')}/>
                              </div>
                            }
                            onHide={() => this.fecharModal('modalReceitaPagamento')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Receita</label>
                          <InputText id="tipoNomePagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.tipoNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Valor</label>
                          <InputText id="valorPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.vlLancamento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Vencimento</label>
                          <InputText id="vencimentoPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '37px'}} 
                                    value={this.state.dtVencimento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Pagar um novo valor</label>
                          <InputNumber inputId="pagamentoNovoValorDespesa" 
                                      value={this.state.vlLancamentoNovo} 
                                      style={{width: '100%', height: '37px'}} 
                                      onChange={(e) => this.setState({vlLancamentoNovo: e.value})} 
                                      mode="decimal" locale="de-BR" minFractionDigits={2}/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Novo Vencimento saldo devedor</label>
                          <Calendar id="novoVencimentoDespesa" 
                                    value={this.state.dtVencimentoNovo} 
                                    onChange={(e) => this.setState({ dtVencimentoNovo: e.value })} 
                                    locale="es"
                                    style={{width: '100%', height: '37px'}} 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Observação</label>
                          <InputTextarea id="observacaoPagamento" 
                                        type="text" 
                                        style={{width: '100%'}} 
                                        value={this.state.observacao}
                                        onChange={e => this.setState({observacao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        rows={2} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>
                  {/**Cadastrar um novo cliente */}
                  <Dialog header="Cadastrar nova Pessoa"
                          visible={this.state.modalNovoCliente} 
                          style={{ width: '40vw' }} 
                          footer={
                            <div>
                                <Button label="Cadastrar" 
                                        className="p-button-primary p-button-text" 
                                        onClick={this.cadastrarNovoCliente}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalNovoCliente')}/>
                              </div>
                          }
                          onHide={() => this.fecharModal('modalNovoCliente')}>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="descricaoArquivo">Nome<span className="obrigatorioAsterisco"> *</span></label>
                            <InputText id="nome"
                                      autoComplete="nope"
                                      type="text" 
                                      options={this.tiposPessoa} style={{width: '100%', height: '32px'}}
                                      value={this.state.nome}
                                      onChange={e => this.setState({nome: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Tipo de Pessoa<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.selectTipo} 
                                      options={this.tiposPessoa} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeTipoPessoa}
                                      id="tipo"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Perfil<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.perfil} 
                                      options={this.state.perfis} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({perfil: e.target.value})}
                                      id="perfil"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <label>Estado<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.selectEstado} 
                                      options={this.state.estados} style={{width: '100%', height: '32px'}}
                                      optionLabel="estado" 
                                      onChange={this.onChangeEstado}
                                      filter showClear filterBy="estado"
                                      id="estado"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-9">
                          <div className="form-group">
                            <label>Cidade<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.selectCidade} 
                                      options={this.state.cidades} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeCidade}
                                      filter showClear filterBy="nome"
                                      id="cidade"
                                      emptyMessage=" "
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Cadastrar Pedidos do Processo */}
                  <Dialog header="Cadastrar Pedidos"
                          visible={this.state.modalPedidos} 
                          
                          footer={
                            <div>
                                <Button label="Cadastrar" 
                                        className="p-button-primary p-button-text" 
                                        onClick={this.cadastrarPedido}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalPedidos')}/>
                              </div>
                          }
                          onHide={() => this.fecharModal('modalPedidos')}>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="descricaoArquivo">Pedido<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.pedido} 
                                      options={this.state.pedidos} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({pedido: e.target.value})}
                                      id="pedido"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Valor Provável</label>
                            <InputNumber inputId="locale-german1" 
                                        value={this.state.vlProvavel} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({vlProvavel: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Valor Possível</label>
                            <InputNumber inputId="locale-german2" 
                                        value={this.state.vlPossivel} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({vlPossivel: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Valor Remoto</label>
                            <InputNumber inputId="locale-german3" 
                                        value={this.state.vlRemoto} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({vlRemoto: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Alterar Pedidos do Processo */}
                  <Dialog header="Alterar Pedidos"
                          visible={this.state.modalAlterarPedido} 
                          
                          footer={
                            <div>
                                <Button label="Alterar"
                                        className="p-button-primary p-button-text" 
                                        onClick={this.alterarPedidoProcesso}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalAlterarPedido')}/>
                              </div>
                          }
                          onHide={() => this.fecharModal('modalAlterarPedido')}>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="pedidoAlterar">Pedido<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.pedido} 
                                      options={this.state.pedidos} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({pedido: e.target.value})}
                                      id="pedidoAlterar"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Valor Provável</label>
                            <InputNumber inputId="locale-german" 
                                        value={this.state.vlProvavel} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({vlProvavel: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Valor Possível</label>
                            <InputNumber inputId="locale-german" 
                                        value={this.state.vlPossivel} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({vlPossivel: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Valor Remoto</label>
                            <InputNumber inputId="locale-german" 
                                        value={this.state.vlRemoto} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({vlRemoto: e.value})} 
                                        mode="decimal" locale="de-BR" minFractionDigits={2}/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Troca de Sub-Grupo das Atividades ao alterar o Grupo de Trabalho do Processo */}
                  <Dialog header="Novo Sub-Grupo das Atividades"
                          visible={this.state.modalTrocaGrupoVisible}

                          footer={
                            <div>
                                <Button label="Confirmar"
                                        className="p-button-primary p-button-text"
                                        onClick={this.confirmarTrocaSubGrupoAtividades}/>
                                &nbsp;
                                <Button label="Cancelar"
                                        className="p-button-secondary p-button-text"
                                        onClick={this.cancelarTrocaSubGrupoAtividades}/>
                              </div>
                          }
                          onHide={this.cancelarTrocaSubGrupoAtividades}>

                      <div className="row">
                        <div className="col-sm-12">
                          <p>
                            O Grupo de Trabalho deste processo foi alterado e existem <b>{this.state.atividadesParaTrocaGrupo.length}</b> atividade(s)
                            vinculada(s) a ele. Selecione o novo Sub-Grupo de Trabalho para o qual essas atividades serão movidas antes de confirmar a alteração.
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="subGrupoTrocaGrupo">Sub-Grupo de Trabalho<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.subGrupoParaTrocaGrupo}
                                      options={this.state.subGruposTrocaGrupo} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome"
                                      filter showClear filterBy="nome"
                                      onChange={this.onSubGrupoTrocaGrupoChange}
                                      id="subGrupoTrocaGrupo"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                  </Dialog>
                  {/**Cadastrar Objetos de Ação */}
                  <Dialog header="Cadastrar Objetos de Ação"
                          visible={this.state.modalObjetos} 
                          style={{ width: '40vw' }} 
                          footer={
                            <div>
                                <Button label="Incluir" 
                                        className="p-button-primary p-button-text" 
                                        onClick={this.cadastrarObjetosProcesso}/>
                                &nbsp;
                                <Button label="Fechar" 
                                        className="p-button-secondary p-button-text"
                                        onClick={() => this.fecharModal('modalObjetos')}/>
                              </div>
                          }
                          onHide={() => this.fecharModal('modalObjetos')}>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="descricaoArquivo">Objeto Principal<span className="obrigatorioAsterisco"> *</span></label>
                              <Dropdown value={this.state.objetoAcao} 
                                        options={this.state.objetosAcao} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        onChange={this.onChangeObjetos}
                                        id="objeto"
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                            <div className="form-group">
                              <label htmlFor="descricaoArquivo">Sub-Objetos<span className="obrigatorioAsterisco"> *</span></label>
                              <DataTable value={this.state.subObjetosAcao}
                                         selection={this.state.selectSubObjetos} onSelectionChange={(e) => this.setState({ selectSubObjetos: e.value })}
                                         paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                         emptyMessage=" "
                                         currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={5}>
                                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                                <Column field="nome" header="Sub-Objeto"></Column>
                              </DataTable>
                            </div>
                          </div>
                        </div>
                    </Dialog>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }
}

FichaProcesso.contextType = AuthContext;
export default withRouter(FichaProcesso)
